/* @jsxRuntime automatic */
/* @jsxImportSource react */

import { useId, type SVGProps } from "react";

export const ACFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.293 9.707 2 8.293 3.414 11 6.121v2.005a3.996 3.996 0 0 0-1.854 1.071L7.408 8.194l-.99-3.697-1.932.518.84 3.132-3.133.839.518 1.932 3.699-.991 1.735 1.002a4.005 4.005 0 0 0 0 2.142l-1.737 1.003-3.697-.991-.518 1.932 3.132.84-.839 3.131 1.932.518.991-3.7 1.737-1.002c.501.511 1.139.888 1.854 1.072v2.005l-2.707 2.707L9.707 22 12 19.707 14.293 22l1.414-1.414L13 17.878v-2.004a3.995 3.995 0 0 0 1.854-1.072l1.736 1.002.992 3.7 1.931-.518-.839-3.132 3.132-.84-.517-1.931-3.697.99-1.737-1.003a4.005 4.005 0 0 0 0-2.141l1.735-1.002 3.699.99.517-1.931-3.132-.839.84-3.132-1.932-.518-.99 3.697-1.738 1.003A3.995 3.995 0 0 0 13 8.126V6.122l2.707-2.708L14.293 2 12 4.293Z"
      fill="currentColor"
    />
  </svg>
);

export const ACOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2.293 7.707 0 6.293 1.414 9 4.121v2.005a3.996 3.996 0 0 0-1.854 1.071L5.408 6.194l-.99-3.697-1.932.518.84 3.132-3.133.839.518 1.932 3.699-.991 1.735 1.002a4.004 4.004 0 0 0 0 2.142l-1.737 1.003-3.697-.991-.518 1.932 3.132.84-.839 3.131 1.932.518.991-3.7 1.737-1.002c.501.511 1.139.888 1.854 1.072v2.005l-2.707 2.707L7.707 20 10 17.707 12.293 20l1.414-1.414L11 15.878v-2.004a3.995 3.995 0 0 0 1.854-1.072l1.736 1.002.992 3.7 1.931-.518-.839-3.132 3.132-.84-.517-1.931-3.697.99-1.737-1.003a4.005 4.005 0 0 0 0-2.141l1.735-1.002 3.699.99.517-1.931-3.132-.839.84-3.132-1.932-.518-.99 3.697-1.738 1.003A3.995 3.995 0 0 0 11 6.126V4.122l2.707-2.708L12.293 0 10 2.293ZM12 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      fill="currentColor"
    />
  </svg>
);

export const AliceCircleFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m.003 3.4c-.486 0-.943.175-1.336.404-.4.231-.787.548-1.148.906-.724.716-1.421 1.668-1.996 2.662-.574.994-1.05 2.072-1.31 3.054A5.8 5.8 0 0 0 6 13.866c-.002.452.074.934.316 1.352.243.418.623.723 1.017.947.4.228.868.403 1.36.536.982.267 2.156.394 3.306.396 1.15.001 2.325-.122 3.308-.387.49-.132.959-.307 1.359-.534.394-.224.775-.53 1.018-.948.242-.419.318-.9.316-1.352a5.9 5.9 0 0 0-.212-1.441c-.258-.983-.734-2.062-1.308-3.057-.573-.995-1.27-1.948-1.993-2.665a5.9 5.9 0 0 0-1.146-.908c-.394-.23-.851-.405-1.338-.405"
      clipRule="evenodd"
    />
  </svg>
);
export const AliceCircleOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.003 5.5c.487 0 .944.175 1.338.404.399.232.785.55 1.146.909.724.717 1.42 1.67 1.993 2.666.574.994 1.05 2.073 1.308 3.055.13.491.21.983.212 1.442.002.452-.074.934-.316 1.352l-.098.152c-.241.342-.575.6-.92.796l-.313.16a6.46 6.46 0 0 1-1.046.374l-.377.092c-.9.201-1.925.296-2.931.294-1.006-.001-2.031-.098-2.93-.302l-.377-.092a5.897 5.897 0 0 1-1.359-.537c-.394-.224-.774-.53-1.017-.948-.212-.365-.296-.779-.313-1.18L6 13.968a5.33 5.33 0 0 1 .126-1.073l.088-.369c.227-.858.619-1.791 1.098-2.676l.211-.376c.503-.87 1.099-1.708 1.725-2.383l.27-.28c.272-.268.558-.514.852-.717l.297-.19c.393-.228.85-.403 1.336-.403Zm-.089 2.02c-.061.02-.142.055-.243.114-.21.122-.464.32-.746.598-.566.56-1.16 1.359-1.67 2.242-.51.882-.905 1.794-1.108 2.562-.101.385-.146.7-.147.939 0 .114.01.2.022.261a.306.306 0 0 0 .025.079c.002.003.016.024.056.06.046.042.119.095.22.152.211.12.51.24.894.344.77.21 1.762.324 2.785.325 1.024.002 2.014-.11 2.784-.317.385-.104.683-.224.893-.343.1-.057.17-.108.217-.15a.326.326 0 0 0 .057-.06l.024-.08c.014-.06.023-.148.023-.263 0-.18-.026-.403-.081-.665l-.066-.275c-.202-.77-.596-1.683-1.105-2.566-.51-.884-1.102-1.682-1.668-2.244a3.892 3.892 0 0 0-.745-.6 1.295 1.295 0 0 0-.243-.113.343.343 0 0 0-.09-.02.337.337 0 0 0-.088.02Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
      fill="currentColor"
    />
  </svg>
);

export const AliceOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3 2.3c.7 0 1.3.3 1.8.6.7.4 1.3 1 1.8 1.5a20.5 20.5 0 0 1 5.2 9c.3.8.4 1.6.4 2.3 0 .7-.1 1.5-.5 2.2l-.2.2c-.3.5-.9 1-1.4 1.3H19c-.5.4-1.2.6-1.9.8l-.6.2c-1.4.3-3 .4-4.6.4h-.7a21 21 0 0 1-4-.5l-.5-.1-2-.7-.2-.2C4 19 3.4 18.5 3 17.8a4 4 0 0 1-.5-1.8v-.3l.3-2.3C3.2 12 4 10.2 5 8.6c1-1.6 2-3 3.2-4.2.5-.5 1-1 1.6-1.3l.2-.2c.6-.3 1.3-.6 2.1-.6h.3ZM12 4.2c-.3 0-.7.1-1.2.4L9.4 5.7c-1 1-2 2.4-2.8 3.8-.9 1.5-1.6 3-2 4.4l-.2 1.6v.2c0 .5 0 1 .2 1.2h.1c.2.3.5.6.9.8.4.3 1 .5 1.7.7 1.3.3 3 .5 4.7.5 1.7 0 3.4-.2 4.7-.5.7-.2 1.3-.4 1.7-.7.5-.2.8-.5 1-.8l.2-1.2-.3-1.8c-.3-1.3-1-2.9-1.9-4.4-.8-1.4-1.8-2.8-2.8-3.8l-1.4-1.1-1-.4H12Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M15 7V5l7 .003V12h-2V8.415l-8 8-3-3L2.414 20 1 18.586l8-8 3 3L18.586 7z"
    />
  </svg>
);

export const ArrowDashboardBold = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" {...props}>
    <path
      d="m20.6841 4.04205c.1533-.04452.3148-.05277.4719-.02408.157.02868.3052.09351.4329.18935.1276.09584.2313.22007.3026.36287.0714.14279.1086.30023.1086.45987l-.001 5.71204c0 .848-.969 1.332-1.647.823l-1.642-1.235-4.18 5.568c-.2436.324-.5981.5468-.9957.6258s-.8104.0085-1.1593-.1978l-.15-.1-3.33702-2.507-4.418 5.885c-.42.56-1.185.707-1.777.368l-.144-.095c-.26693-.2006-.45157-.4916-.51932-.8186-.06774-.3269-.01394-.6673.15132-.9574l.095-.144 5.077-6.762c.24347-.3245.59819-.5477.99609-.6267s.81096-.0082 1.15991.1987l.149.1 3.33602 2.506 3.522-4.69005-1.647-1.237c-.1426-.10752-.2547-.25026-.3255-.41421-.0707-.16395-.0977-.34347-.0781-.52096s.0849-.34685.1897-.49145.2453-.25948.4079-.33338l.137-.05 5.485-1.595z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M16.7 16.2904L15.2879 14.8754L12.9985 17.1695V2.48951H11.0015V17.1695L8.71207 14.8754L7.29999 16.2904L12 21L16.7 16.2904Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowDownRoundFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm6-10-6 6-6-6 1.265-1.265 3.84 3.84V6h1.79v8.575l3.84-3.84L18 12Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowExitFullscreen = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M17.341 8H21v2h-7V3h2v3.659L20.659 2 22 3.341 17.341 8ZM6.647 16.012H3V14h7v7H7.988v-3.647L3.341 22 2 20.659l4.647-4.647Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowFullscreen = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M15 2v2l3.647.012L14 8.659 15.341 10l4.65-4.65L20 9h2V2h-7ZM9 22v-2.012H5.353L10 15.341 8.659 14l-4.65 4.65V15H2v7h7Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m7.8 11 5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2H7.8Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 11h12.2l-5.6-5.6L12 4l8 8-8 8-1.4-1.4 5.6-5.6H4v-2Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowRightRoundOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 6L18 12L12 18L10.7349 16.7349L14.5752 12.8946H6V11.1054H14.5752L10.7349 7.26512L12 6Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowRound = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M5.49256 2.76846H3.49255l.00001 6.65686h6.65684v-2H6.91072c.0457-.04834.09222-.0962.13956-.14354 2.73367-2.73367 7.16582-2.73367 9.89952 0C18.3166 8.64862 19 10.4401 19 12.2315h2c0-2.30327-.8787-4.60657-2.636-6.36393-3.5147-3.51472-9.21321-3.51472-12.72793 0-.04851.04851-.09634.09743-.14351.14676V2.76846ZM18.5075 21.2315h2v-6.6568h-6.6569v2h3.2387c-.0457.0483-.0922.0962-.1396.1435-2.7336 2.7337-7.16578 2.7337-9.89945 0C5.68341 15.3514 5 13.5599 5 11.7685H3c0 2.3033.87868 4.6066 2.63604 6.3639 3.51472 3.5147 9.21316 3.5147 12.72796 0 .0485-.0485.0963-.0974.1435-.1467v3.2458Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowSorting = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10.29 8.636 1.415-1.415-4.707-4.71-4.707 4.71 1.414 1.415L5.998 6.34v14.68h2V6.341l2.292 2.295Zm10.001 6.75 1.415 1.415-4.708 4.71-4.707-4.71 1.415-1.415 2.292 2.294V3h2v14.68l2.293-2.294Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="m16.7 7.22066-1.4121 1.41496-2.2894-2.29411v14.65849h-1.997v-14.65849l-2.28943 2.29411-1.41208-1.41497 4.70001-4.7096z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowUpRoundFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM6 12l6-6 6 6-1.265 1.265-3.84-3.84V18h-1.79V9.425l-3.84 3.84L6 12Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Attach = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 20a4.5 4.5 0 0 0 4.5-4.5V11h2v4.5a6.5 6.5 0 1 1-13 0V7a5 5 0 0 1 10 0v8.5a3.5 3.5 0 1 1-7 0v-8h2v8a1.5 1.5 0 0 0 3 0V7a3 3 0 1 0-6 0v8.5a4.5 4.5 0 0 0 4.5 4.5Z"
      fill="currentColor"
    />
  </svg>
);

export const BasketOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10 12 2.5.01L13.705 10H21v.264l-1.732.866-.981 4.17c-.25 1.062-.41 1.737-.576 2.244-.156.477-.27.65-.35.744a2 2 0 0 1-.625.496c-.11.055-.304.127-.805.17-.53.044-1.225.046-2.317.046h-3.228c-1.092 0-1.786-.002-2.317-.047-.5-.042-.696-.114-.805-.169a2 2 0 0 1-.626-.496c-.078-.093-.193-.267-.348-.744-.166-.507-.327-1.182-.577-2.245l-.98-4.169L3 10.264V10h8.2L10 12Zm4.904-4H23v3.5l-2 1-.767 3.258c-.484 2.059-.726 3.088-1.342 3.819a4 4 0 0 1-1.251.991c-.853.432-1.91.432-4.026.432h-3.228c-2.116 0-3.173 0-4.026-.432a4 4 0 0 1-1.251-.991c-.616-.73-.858-1.76-1.343-3.82L3 12.5l-2-1V8h11.4L16 2h2.5l-3.596 6Z"
      fill="currentColor"
    />
  </svg>
);

export const BaggageHelpFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M11.5 4.8C11.5 7.3 9.7 9 8 9 6.2 9 4.5 7.3 4.5 4.8 4.5 2 6.6 1 8 1s3.5 1 3.5 3.8ZM13 8c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2V8Z"
      fill="currentColor"
    />
    <path
      d="M7.4 10.4c-.8-.3-1.7-.3-2.5 0-.8.4-1.5 1.2-2 2.6-.6 1.5-.9 3.5-.9 6.5V22h7.7l.3-2 .1-.8 2.2 1 4.3-.3c.7 0 1.5-.2 2.2-.6.8-.5 1.2-1.3 1.2-2.3v-1h-6.5l-3.3-4.1-.5-.4c-.6-.4-1.4-.9-2.3-1.1Z"
      fill="currentColor"
    />
  </svg>
);

export const BaggageHelpOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 9.5c1.8 0 3.7-1.8 3.7-4.4C11.7 2 9.5 1 8 1S4.3 2.1 4.3 5c0 2.7 1.9 4.5 3.7 4.5Zm0-2c.5 0 1.7-.7 1.7-2.4 0-1-.3-1.4-.6-1.7C8.7 3.1 8.3 3 8 3c-.3 0-.7.1-1 .4-.4.3-.7.7-.7 1.7 0 1.7 1.2 2.4 1.7 2.4ZM15 6a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5Zm5 2h-5v5h5V8Z"
      fill="currentColor"
    />
    <path
      d="M6.9 12.3c-.6-.2-1-.2-1.2 0-.1 0-.6.3-1 1.4-.4 1.1-.7 3-.7 5.8V22H2v-2.5c0-3 .3-5 .9-6.5.5-1.4 1.2-2.2 2-2.6.8-.3 1.7-.3 2.5 0 .9.2 1.7.7 2.3 1l.5.5 3.3 4.1H20v1c0 2-1.5 4.5-3.4 4.7l-5.9.3L9 21v-2.4l2.3 1.4 5.1-.3c.5 0 1.1-.7 1.3-1.7h-5.2l-3.9-4.8-1.7-1Z"
      fill="currentColor"
    />
  </svg>
);

export const Battery = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.09 5.59C17.13 5 15.82 5 13.2 5H7.8c-2.62 0-3.93 0-4.89.59-.54.33-.99.78-1.32 1.32C1 7.87 1 9.18 1 11.8v.4c0 2.62 0 3.93.59 4.89.33.54.78.99 1.32 1.32.96.59 2.27.59 4.89.59h5.4c2.62 0 3.93 0 4.89-.59.54-.33.99-.78 1.32-1.32.59-.96.59-2.27.59-4.89v-.4c0-2.62 0-3.93-.59-4.89-.33-.54-.78-.99-1.32-1.32ZM18 12.2c0 1.35 0 2.22-.06 2.88-.06.63-.16.85-.23.97-.16.27-.39.5-.66.66-.11.07-.34.17-.97.23-.66.06-1.53.06-2.88.06H7.8c-1.35 0-2.22 0-2.88-.06-.63-.06-.85-.16-.97-.23-.27-.16-.5-.39-.66-.66-.07-.11-.17-.34-.23-.97C3 14.42 3 13.55 3 12.2v-.4c0-1.35 0-2.22.06-2.88.06-.63.16-.85.23-.97.16-.27.39-.5.66-.66.11-.07.34-.17.97-.23C5.58 7 6.45 7 7.8 7h5.4c1.35 0 2.22 0 2.88.06.63.06.85.16.97.23.27.16.5.39.66.66.07.11.17.34.23.97.06.66.06 1.53.06 2.88v.4ZM4.48 8.15c-.13.08-.25.2-.33.33C4 8.72 4 9.05 4 9.7v4.6c0 .65 0 .98.15 1.22.08.13.2.25.33.33.24.15.57.15 1.22.15H12V8H5.7c-.65 0-.98 0-1.22.15ZM21 15V9c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2Z"
      clipRule="evenodd"
    />
  </svg>
);

export const BatteryEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.2 5c2.62 0 3.93 0 4.89.59.54.33.99.78 1.32 1.32.59.96.59 2.27.59 4.89v.4c0 2.62 0 3.93-.59 4.89-.33.54-.78.99-1.32 1.32-.96.59-2.27.59-4.89.59H7.8c-2.62 0-3.93 0-4.89-.59-.54-.33-.99-.78-1.32-1.32C1 16.13 1 14.82 1 12.2v-.4c0-2.62 0-3.93.59-4.89.33-.54.78-.99 1.32-1.32C3.87 5 5.18 5 7.8 5h5.4Zm4.74 10.08c.06-.66.06-1.53.06-2.88v-.4c0-1.35 0-2.22-.06-2.88-.06-.63-.16-.86-.23-.97-.16-.27-.39-.5-.66-.66-.12-.07-.34-.17-.97-.23C15.42 7 14.55 7 13.2 7H7.8c-1.35 0-2.22 0-2.88.06-.63.06-.86.16-.97.23-.27.16-.5.39-.66.66-.07.12-.17.34-.23.97C3 9.58 3 10.45 3 11.8v.4c0 1.35 0 2.22.06 2.88.06.63.16.86.23.97.16.27.39.5.66.66.12.07.34.17.97.23.66.06 1.53.06 2.88.06h5.4c1.35 0 2.22 0 2.88-.06.63-.06.86-.16.97-.23.27-.16.5-.39.66-.66.07-.12.17-.34.23-.97ZM21 15V9c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Parking = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.654 5.276C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622Zm5.9 1.497C8.5 6.88 8.5 7.02 8.5 7.3v9.9c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218C8.88 18 9.02 18 9.3 18h.34c.28 0 .42 0 .528-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-2.618c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.219c.107-.054.247-.054.527-.054h.932c.674 0 1.283-.07 1.828-.209.556-.15 1.027-.38 1.412-.69.396-.31.7-.705.914-1.186.214-.481.32-1.054.32-1.717 0-1.208-.384-2.09-1.154-2.646-.77-.556-1.85-.834-3.24-.834H9.3c-.28 0-.42 0-.527.054a.5.5 0 0 0-.218.219Zm2.16 1.466c.107-.055.247-.055.527-.055h1.012c.802 0 1.406.15 1.813.45.417.288.625.758.625 1.41 0 .76-.225 1.294-.674 1.604-.449.31-1.063.466-1.844.466h-.932c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218c-.054-.107-.054-.247-.054-.527v-2.33c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Rule = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.02 3.59a2 2 0 0 0-2.83 0L3.6 14.19a2 2 0 0 0 0 2.83l3.53 3.54a2 2 0 0 0 2.83 0l10.6-10.61a2 2 0 0 0 0-2.83zm-.97 1.94c-.3-.3-.68-.3-.97 0l-9.55 9.55c-.3.29-.32.63-.03.92s.7.3 1 0l1.24-1.24.53.53a.75.75 0 1 0 1.06-1.06l-.53-.53 1.06-1.06 1.24 1.24a.75.75 0 0 0 1.06-1.06l-1.24-1.24 1.06-1.06.53.53a.75.75 0 0 0 1.06-1.06l-.53-.53L14.1 8.4l1.24 1.24a.75.75 0 0 0 1.06-1.06l-1.24-1.24.89-.89c.29-.29.29-.63 0-.92"
      clipRule="evenodd"
    />
  </svg>
);

export const ParkingOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M5.5 2.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.219C5.88 2 6.02 2 6.3 2h5.727c2.418 0 4.296.483 5.635 1.45C19 4.417 19.67 5.952 19.67 8.053c0 1.153-.186 2.148-.558 2.985a5.319 5.319 0 0 1-1.59 2.064c-.67.54-1.487.939-2.454 1.2-.949.241-2.009.362-3.18.362H9.675c-.28 0-.42 0-.527.054a.5.5 0 0 0-.218.219c-.055.107-.055.247-.055.527V21.2c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C8.495 22 8.355 22 8.075 22H6.3c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C5.5 21.62 5.5 21.48 5.5 21.2V2.8Zm4.175 2.129c-.28 0-.42 0-.527.054a.5.5 0 0 0-.218.219c-.055.107-.055.247-.055.527v5.234c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h2.213c1.357 0 2.427-.27 3.207-.809.782-.54 1.172-1.47 1.172-2.79 0-1.134-.362-1.952-1.088-2.454-.706-.52-1.757-.781-3.152-.781H9.675Z"
    />
  </svg>
);

export const BellAlertFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M10.667 2h2.666l.256 1.844a5 5 0 0 0 4.914 8.426l.14.762c.224 1.239 1.02 2.8 2.146 3.362L21 16.5V18c0 1.1-4 2-9 2s-9-.9-9-2v-1.395l.211-.105c1.126-.563 1.922-2.23 2.147-3.468l.748-4.113a5.993 5.993 0 0 1 4.248-4.69L10.667 2ZM12 23a4 4 0 0 1-3.567-2.189A33.06 33.06 0 0 0 12 21c1.248 0 2.448-.067 3.567-.188A4 4 0 0 1 12 23Z"
    />
    <path fill="#F5523A" d="M20 7.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);

export const BellAlertOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 2h2l.348 2.085a4.995 4.995 0 0 0-1.121 1.921 3.991 3.991 0 0 0-4.154 3.27l-.747 4.114A6 6 0 0 1 5 17.133v.03c.254.092.604.195 1.06.297 1.444.322 3.541.54 5.94.54 2.399 0 4.496-.218 5.94-.54a8.724 8.724 0 0 0 1.06-.297v-.03a6 6 0 0 1-2.326-3.743l-.166-.914a5.058 5.058 0 0 0 1.996-.206l.138.762a4 4 0 0 0 2.147 2.862L21 16v2c0 .79-2.064 1.477-5.081 1.801a4 4 0 0 1-7.838 0C5.065 19.477 3 18.79 3 18v-2l.211-.106a4 4 0 0 0 2.147-2.862l.748-4.113a5.993 5.993 0 0 1 4.535-4.764L11 2Zm1 18c.6 0 1.187-.013 1.753-.038a2 2 0 0 1-3.506 0c.566.025 1.152.038 1.753.038Z"
      clipRule="evenodd"
    />
    <path fill="#F5523A" d="M20 7.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);

export const BellFillL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M20.79 16.39A4.931 4.931 0 0 1 18.64 13l-.75-4.11a6 6 0 0 0-4.25-4.69L13.33 2h-2.66l-.32 2.23a6 6 0 0 0-4.24 4.69L5.36 13a5.15 5.15 0 0 1-2.15 3.5l-.21.11V18c0 1.1 4 2 9 2s9-.9 9-2v-1.5l-.21-.11ZM8.43 20.81a4 4 0 0 0 7.13 0c-1.182.127-2.37.19-3.56.19a33.105 33.105 0 0 1-3.57-.19Z"
    />
  </svg>
);

export const BellFillM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 4h2l.294 1.177c1.782.51 2.962 2.06 3.29 3.868l.582 3.199C17.341 13.207 18 14 19 14.552V16c0 .625-1.6 1.137-4.022 1.368l-.001.007c-.938.093-1.954.14-2.977.14s-2.039-.047-2.977-.14v-.007C6.6 17.138 5 16.625 5 16v-1.448c1-.552 1.659-1.345 1.834-2.308l.581-3.2c.33-1.807 1.51-3.358 3.29-3.867zM9.35 18.409A3.01 3.01 0 0 0 12 20a3 3 0 0 0 2.65-1.591 32 32 0 0 1-2.65.106 32 32 0 0 1-2.65-.106"
      clipRule="evenodd"
    />
  </svg>
);

export const BellOutlineL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2h-2l-.36 2.155A5.99 5.99 0 0 0 6.107 8.92l-.748 4.113a4 4 0 0 1-2.147 2.862L3 16v2c0 .79 2.065 1.477 5.081 1.801a4 4 0 0 0 7.838 0C18.936 19.477 21 18.79 21 18v-2l-.211-.106a4 4 0 0 1-2.147-2.862l-.748-4.113a5.99 5.99 0 0 0-4.535-4.764zm.753 17.962a40 40 0 0 1-3.506 0 2 2 0 0 0 3.506 0M7.326 13.39l.747-4.113a3.991 3.991 0 0 1 7.854 0l.747 4.113A6 6 0 0 0 19 17.133v.03a9 9 0 0 1-1.06.297c-1.444.322-3.541.54-5.94.54s-4.496-.218-5.94-.54A9 9 0 0 1 5 17.163v-.03a6 6 0 0 0 2.326-3.743"
      clipRule="evenodd"
    />
  </svg>
);

export const BellOutlineM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 4h-2l-.294 1.177c-1.782.51-2.962 2.06-3.29 3.868l-.582 3.199C6.659 13.207 6 14 5 14.552V16c0 .625 1.6 1.137 4.022 1.368A2.996 2.996 0 0 0 12 20a2.996 2.996 0 0 0 2.978-2.632C17.399 17.138 19 16.625 19 16v-1.448c-1-.552-1.659-1.345-1.834-2.308l-.581-3.2c-.33-1.807-1.51-3.358-3.29-3.867zM7.5 15.132a4.93 4.93 0 0 0 1.302-2.53l.581-3.2C9.65 7.935 10.66 7 12 7s2.35.934 2.617 2.403l.581 3.199a4.93 4.93 0 0 0 1.303 2.53c-1.067.22-2.635.368-4.501.368s-3.434-.148-4.5-.368"
      clipRule="evenodd"
    />
  </svg>
);

export const BellOffFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M10.667 2h2.666l.31 2.229a5.99 5.99 0 0 1 4.251 4.69l.748 4.113c.225 1.239 1.02 2.8 2.147 3.362L21 16.5V18c0 .434-.625.838-1.689 1.167L9.186 4.7q.555-.296 1.168-.471zM6.802 7.01a6 6 0 0 0-.696 1.91l-.748 4.112c-.225 1.239-1.02 2.905-2.147 3.468L3 16.605V18c0 1.1 4 2 9 2 1.348 0 2.623-.066 3.767-.183L18 23.007h2.5l-14-20H4z"
    />
    <path
      fill="currentColor"
      d="M8.433 20.812a4 4 0 0 0 7.134 0A33 33 0 0 1 12 21a33 33 0 0 1-3.567-.189"
    />
  </svg>
);

export const BellOffOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M13 2h-2l-.36 2.155c-.511.12-1 .304-1.454.546l1.16 1.657a3.99 3.99 0 0 1 5.581 2.919l.747 4.113A6 6 0 0 0 19 17.133v.03a8 8 0 0 1-.908.262l1.22 1.742C20.374 18.837 21 18.434 21 18v-2l-.211-.106a4 4 0 0 1-2.147-2.862l-.748-4.113a5.99 5.99 0 0 0-4.535-4.764z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.802 7.01 4 3.007h2.5l14 20H18l-2.121-3.03a4 4 0 0 1-7.798-.176C5.065 19.477 3 18.79 3 18v-2l.211-.106a4 4 0 0 0 2.147-2.862l.748-4.113a6 6 0 0 1 .696-1.909m7.638 10.912c-.764.05-1.583.078-2.44.078-2.399 0-4.496-.218-5.94-.54A9 9 0 0 1 5 17.163v-.03a6 6 0 0 0 2.326-3.743l.747-4.113a4 4 0 0 1 .077-.34zm-.687 2.04a40 40 0 0 1-3.506 0A2 2 0 0 0 12 21a2 2 0 0 0 1.753-1.038"
      clipRule="evenodd"
    />
  </svg>
);

export const Bike = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m19.83 14.715.244.708-1.655.57-.244-.708-1.025-2.958a3.25 3.25 0 1 0 1.654-.572l1.026 2.96Zm-3.465-3.965a5.003 5.003 0 0 0-2.289 3.375H9.924a4.988 4.988 0 0 0-1.384-2.656l.503-.72h7.322ZM15.997 9l-1.14-3.291a.125.125 0 0 0-.119-.084H12v-1.75h2.738c.8 0 1.51.506 1.772 1.26l1.707 4.926a5 5 0 1 1-4.14 5.814H9.923A5.001 5.001 0 0 1 0 15a5 5 0 0 1 7.107-4.536l.355-.507-.76-2.207H5V6h5v1.75H8.553L8.983 9h7.014ZM4.25 15.875h3.88A3.251 3.251 0 0 1 1.75 15a3.25 3.25 0 0 1 6.38-.875H4.25v1.75Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Block = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20M6.343 6.343a8 8 0 0 1 10.563-.662L5.681 16.906a8 8 0 0 1 .662-10.563m.752 11.977A8 8 0 0 0 18.32 7.095z"
    />
  </svg>
);

export const BoardingHelpFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M11 14.313V4a2 2 0 0 0-2-2L7.547 7.984a7.187 7.187 0 0 1-1.823 3.306l-1.209 1.247c.013.147.074.377.216.68.285.61.825 1.369 1.56 2.104.736.735 1.497 1.277 2.107 1.563.308.145.6.209.748.22l.28-.15a3 3 0 0 0 1.573-2.64ZM3.373 13.853a4.919 4.919 0 0 1-.156-.37l-2.035 2.049c-.552.555.193 2.195 1.629 3.64 1.436 1.445 3.07 2.2 3.622 1.645l2.246-2.26a4.028 4.028 0 0 1-.919-.316c-.803-.377-1.703-1.034-2.529-1.86-.826-.826-1.482-1.725-1.858-2.528ZM13 14.313V4a2 2 0 0 1 2-2l1.451 5.983a7.186 7.186 0 0 0 1.824 3.306l1.209 1.247c-.013.147-.074.377-.217.68-.285.61-.825 1.369-1.56 2.104-.735.735-1.496 1.277-2.106 1.563-.308.145-.6.209-.748.22l-.28-.15A3 3 0 0 1 13 14.313ZM20.626 13.853c.057-.122.11-.246.156-.37l2.035 2.049c.552.555-.194 2.195-1.63 3.64-1.435 1.445-3.07 2.2-3.621 1.645l-2.246-2.26a4.03 4.03 0 0 0 .918-.316c.804-.377 1.704-1.034 2.53-1.86.826-.826 1.482-1.725 1.858-2.528Z"
    />
  </svg>
);

export const Bold = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M3 2h4.117c1.518 0 2.672.223 3.465.67.792.446 1.188 1.199 1.188 2.259 0 .859-.257 1.512-.77 1.958-.502.435-1.172.73-2.008.887 1.048.123 1.846.396 2.393.82.547.424.82 1.071.82 1.942 0 .624-.128 1.16-.385 1.606a3.077 3.077 0 0 1-1.071 1.071c-.458.268-.999.469-1.623.603C8.5 13.939 7.82 14 7.084 14H3V2Zm2.393 2.008v2.829h1.975c.603 0 1.088-.123 1.456-.368.368-.246.553-.63.553-1.155s-.168-.87-.503-1.038c-.334-.178-.803-.268-1.405-.268H5.393Zm0 4.804v3.196h2.042c.692 0 1.25-.117 1.674-.351.424-.234.636-.658.636-1.272 0-.58-.201-.988-.603-1.222-.39-.234-1.01-.351-1.857-.351H5.393Z"
      fill="currentColor"
    />
  </svg>
);

export const BookmarkFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M20 8.00462C20 6.13942 20 5.20682 19.6955 4.47117C19.2895 3.4903 18.5108 2.71101 17.5307 2.30471C16.7957 2 15.8638 2 14 2H10C8.13623 2 7.20435 2 6.46927 2.30471C5.48915 2.71101 4.71046 3.4903 4.30448 4.47117C4 5.20682 4 6.13943 4 8.00462V22H5.5L12 17.9969L18.5 22H20V8.00462Z"
      fill="currentColor"
    />
  </svg>
);

export const BookmarkOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15.5966L18 19.5966L18 8.00031C18 7.04106 17.9989 6.42179 17.9666 5.94782C17.9355 5.49183 17.8822 5.31817 17.8478 5.23494C17.6448 4.74488 17.2554 4.35553 16.7654 4.15255C16.6821 4.11807 16.5085 4.06484 16.0525 4.03373C15.5785 4.00139 14.9593 4.00031 14 4.00031H10C9.04075 4.00031 8.42148 4.00139 7.94752 4.03373C7.49152 4.06484 7.31786 4.11807 7.23463 4.15255C6.74458 4.35553 6.35523 4.74488 6.15224 5.23494C6.11777 5.31817 6.06453 5.49183 6.03342 5.94783C6.00108 6.42179 6 7.04106 6 8.00031L6.00001 19.5966L12 15.5966ZM6.00001 22.0003H4.00001L4 8.00031C4 6.13654 4 5.20466 4.30448 4.46957C4.71046 3.48946 5.48915 2.71076 6.46927 2.30479C7.20435 2.00031 8.13623 2.00031 10 2.00031H14C15.8638 2.00031 16.7957 2.00031 17.5307 2.30479C18.5108 2.71076 19.2895 3.48946 19.6955 4.46957C20 5.20466 20 6.13654 20 8.00031L20 22.0003H18L12 18.0003L6.00001 22.0003Z"
      fill="currentColor"
    />
  </svg>
);

export const BookShelf = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M9.5 2a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-16a.5.5 0 0 0-.5-.5h-2Zm3.604 1.939a.5.5 0 0 1 .385-.593l2.934-.624a.5.5 0 0 1 .594.385l3.118 14.673a.5.5 0 0 1-.385.593l-2.934.623a.5.5 0 0 1-.593-.385L13.104 3.94ZM4.5 3a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5h-3ZM22 22v-2H2v2h20Z"
    />
  </svg>
);

export const BoxFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m6.27 5.183 8.702 4.834c.548.304.654.373.726.444a1 1 0 0 1 .267.453c.027.098.035.223.035.851v8.012l-2.543 1.413c-.472.263-.709.394-.955.458a2 2 0 0 1-1.004 0c-.246-.064-.483-.195-.955-.458l-6-3.333c-.499-.277-.748-.416-.94-.602a2 2 0 0 1-.533-.906C3 16.09 3 15.805 3 15.235v-6.47c0-.57 0-.856.07-1.114a2 2 0 0 1 .533-.906c.192-.187.441-.325.94-.603l1.727-.96Z"
    />
    <path
      fill="currentColor"
      d="m8.33 4.039 2.213-1.23c.472-.262.709-.394.955-.457a2 2 0 0 1 1.004 0c.246.063.483.195.955.457l6 3.333c.499.278.748.416.94.603a2 2 0 0 1 .533.906c.07.258.07.543.07 1.114v6.47c0 .57 0 .855-.07 1.114a2 2 0 0 1-.533.905c-.192.187-.441.326-.94.603l-1.457.81v-7c0-.473.001-.888-.105-1.279a3 3 0 0 0-.8-1.359c-.29-.283-.653-.484-1.066-.713L8.33 4.04Z"
    />
  </svg>
);

export const BoxOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m7.83 6.605-1.544.857c-.848.471-.934.538-.984.587L3.905 6.618c.287-.28.661-.488 1.41-.904l4.5-2.5c.708-.394 1.062-.59 1.433-.686a3 3 0 0 1 1.505 0c.37.095.724.292 1.432.686l4.5 2.5c.749.416 1.123.623 1.41.904a3 3 0 0 1 .8 1.359c.105.387.105.815.105 1.67v4.705c0 .856 0 1.284-.105 1.671a3 3 0 0 1-.8 1.359c-.287.28-.661.488-1.41.904l-4.5 2.5c-.708.393-1.062.59-1.433.686a3 3 0 0 1-1.505 0c-.37-.096-.724-.293-1.432-.686l-4.5-2.5c-.749-.416-1.123-.624-1.41-.904a3 3 0 0 1-.8-1.359C3 15.636 3 15.208 3 14.352V9.648c0-.856 0-1.284.105-1.671a3 3 0 0 1 .8-1.36L5.302 8.05a1 1 0 0 0-.267.453C5.017 8.57 5 8.678 5 9.648v4.704c0 .97.017 1.078.035 1.145a1 1 0 0 0 .267.453c.05.05.136.116.984.587l4.5 2.5c.802.446.898.482.963.499a1 1 0 0 0 .502 0c.065-.017.161-.053.963-.499L15 18.045v-6.28c0-.627-.008-.753-.035-.851a1 1 0 0 0-.267-.453c-.073-.071-.178-.14-.727-.444zm2.956-1.643c.802-.445.898-.482.963-.498a1 1 0 0 1 .502 0c.065.016.161.053.963.498l4.5 2.5c.848.471.934.538.984.587a1 1 0 0 1 .267.453c.018.068.035.176.035 1.146v4.704c0 .97-.017 1.078-.035 1.145a1 1 0 0 1-.267.453c-.05.05-.136.116-.984.587l-.714.397v-5.268c0-.472.001-.887-.105-1.278a3 3 0 0 0-.8-1.359c-.29-.283-.653-.484-1.066-.713l-5.14-2.855z"
      clipRule="evenodd"
    />
  </svg>
);

export const BrokenHeartFillL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.329 4.05A4.929 4.929 0 0 0 7.454 3C4.09 3 2 5 2 9c0 5.951 7.825 11.07 9.505 11.965L13 11H9l1.666-6.663c-.108-.1-.22-.195-.338-.287Zm4.554-.7L13 9h3.5l-3.985 11.955C14.237 20.03 22 14.927 22 8.984 22 5 19.91 3 16.545 3c-.574.02-1.136.14-1.662.35Z"
      fill="currentColor"
    />
  </svg>
);

export const BugFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M12 2.5a3 3 0 0 1 2.919 3.683 7.118 7.118 0 0 1 2.562 2.156L18.5 8l1.209-2.015a1 1 0 0 1 .857-.485H21L20 9l-1.526 1.145c.172.448.304.92.393 1.407L22 12v1l-3.013.43a7.96 7.96 0 0 1-.255 1.619L20 16l1 3.5h-.434a1 1 0 0 1-.857-.485L18.5 17l-.486-.162c-1.06 1.901-2.881 3.258-5.014 3.585V7.5h-2v12.923c-2.133-.327-3.955-1.683-5.015-3.585L5.5 17l-1.209 2.015a1 1 0 0 1-.857.485H3L4 16l1.267-.951a7.966 7.966 0 0 1-.255-1.62L2 13v-1l3.132-.448c.089-.488.222-.959.394-1.407L4 9 3 5.5h.434a1 1 0 0 1 .857.485L5.5 8l1.018.339A7.12 7.12 0 0 1 9.08 6.183 3 3 0 0 1 12 2.5Z"
    />
  </svg>
);

export const BugOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2.5a3 3 0 0 1 2.919 3.683 7.118 7.118 0 0 1 2.562 2.156L18.5 8l1.209-2.015a1 1 0 0 1 .857-.485H21L20 9l-1.526 1.145c.172.448.304.92.393 1.407L22 12v1l-3.013.43a7.96 7.96 0 0 1-.255 1.619L20 16l1 3.5h-.434a1 1 0 0 1-.857-.485L18.5 17l-.486-.162C16.792 19.03 14.557 20.5 12 20.5c-2.557 0-4.793-1.47-6.015-3.662L5.5 17l-1.209 2.015a1 1 0 0 1-.857.485H3L4 16l1.267-.951a7.966 7.966 0 0 1-.255-1.62L2 13v-1l3.132-.448c.089-.488.222-.959.394-1.407L4 9 3 5.5h.434a1 1 0 0 1 .857.485L5.5 8l1.018.339A7.12 7.12 0 0 1 9.08 6.183 3 3 0 0 1 12 2.5Zm-1 5.113C8.796 8.115 7 10.24 7 13c0 2.761 1.796 4.884 4 5.386V7.613Zm2 10.773c2.204-.502 4-2.625 4-5.386s-1.796-4.885-4-5.387v10.773Z"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 3.00084V2H7V3.05317C6.07317 3.11965 5.42316 3.26926 4.88328 3.60596C4.36568 3.92877 3.92877 4.36568 3.60596 4.88328C3 5.85491 3 7.18327 3 9.84V14.16C3 16.8167 3 18.1451 3.60596 19.1167C3.92877 19.6343 4.36568 20.0712 4.88328 20.394C5.85491 21 7.18327 21 9.84 21H14.16C16.8167 21 18.1451 21 19.1167 20.394C19.6343 20.0712 20.0712 19.6343 20.394 19.1167C21 18.1451 21 16.8167 21 14.16V9.84C21 7.18327 21 5.85491 20.394 4.88328C20.0712 4.36568 19.6343 3.92877 19.1167 3.60596C18.5768 3.26926 17.9268 3.11965 17 3.05317V2H15V3.00084C14.7356 3 14.456 3 14.16 3H9.84C9.54395 3 9.2644 3 9 3.00084ZM7 5.05933V6H9V5.00097C9.2582 5.00011 9.53723 5 9.84 5H14.16C14.4628 5 14.7418 5.00011 15 5.00097V6H17V5.05933C17.0264 5.06163 17.0526 5.06403 17.0783 5.06651C17.7153 5.12792 17.943 5.23105 18.0584 5.30298C18.3172 5.46438 18.5356 5.68284 18.697 5.94164C18.7689 6.05697 18.8721 6.28475 18.9335 6.92166C18.9836 7.4413 18.996 8.09184 18.999 9H5.00097C5.00401 8.09184 5.01641 7.4413 5.06651 6.92166C5.12792 6.28475 5.23105 6.05697 5.30298 5.94164C5.46438 5.68284 5.68284 5.46438 5.94164 5.30298C6.05697 5.23105 6.28475 5.12792 6.92166 5.06651C6.94745 5.06403 6.97355 5.06163 7 5.05933ZM5 11V14.16C5 15.5277 5.00217 16.411 5.06651 17.0783C5.12792 17.7153 5.23105 17.943 5.30298 18.0584C5.46438 18.3172 5.68284 18.5356 5.94164 18.697C6.05697 18.7689 6.28475 18.8721 6.92166 18.9335C7.58904 18.9978 8.47233 19 9.84 19H14.16C15.5277 19 16.411 18.9978 17.0783 18.9335C17.7153 18.8721 17.943 18.7689 18.0584 18.697C18.3172 18.5356 18.5356 18.3172 18.697 18.0584C18.7689 17.943 18.8721 17.7153 18.9335 17.0783C18.9978 16.411 19 15.5277 19 14.16V11H5Z"
      fill="currentColor"
    />
  </svg>
);

export const CallFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.82 8.055c-.193.404 1.293 1.892 1.79 2.39 0 .198-1.99 2.587-2.785 3.384-.796.796-3.183 2.787-3.382 2.787-.497-.498-1.99-1.99-2.388-1.792-.397.2-4.476 1.891-4.874 2.09-.398.2-.1 2.29.498 2.887.596.598 4.476 3.883 12.235-3.882 7.759-7.764 4.499-11.623 3.88-12.244-.591-.591-2.68-.89-2.885-.497-.193.404-1.884 4.485-2.09 4.877Z"
      fill="currentColor"
    />
  </svg>
);

export const CallOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m18 1.6-.48.32a8 8 0 0 0-2.2 2.47A11 11 0 0 0 14 7.66l-.09.42 1.2 1.78q-.34.7-.9 1.38a15 15 0 0 1-2.46 2.47q-.69.55-1.38.9l-1.79-1.24-.43.1c-1.1.26-2.26.75-3.26 1.36-.99.6-1.9 1.36-2.47 2.2l-.33.49.27.52a14 14 0 0 0 2.33 3.14c.6.63 1.49.92 2.36.79 3.78-.6 7.23-2.8 9.9-5.53 2.67-2.7 4.86-6.1 5.5-9.87a2.7 2.7 0 0 0-.78-2.4c-.9-.86-2.06-1.76-3.13-2.3zm.17 2.36c.7.44 1.46 1.04 2.1 1.66a.7.7 0 0 1 .2.61c-.55 3.23-2.46 6.28-4.95 8.81-2.48 2.52-5.56 4.44-8.8 4.95a.7.7 0 0 1-.6-.2c-.62-.64-1.23-1.4-1.67-2.1q.56-.59 1.47-1.15c.71-.43 1.5-.79 2.25-1l1.92 1.32.48-.16c.9-.32 1.75-.9 2.4-1.42a17 17 0 0 0 2.8-2.8 9 9 0 0 0 1.41-2.4l.17-.47-1.3-1.93a9 9 0 0 1 2.12-3.72"
      clipRule="evenodd"
    />
  </svg>
);

export const Cam = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99987 2.00134V3.75144C8.09578 3.75474 7.41556 3.76702 6.85838 3.81254C6.13284 3.87182 5.77136 3.97863 5.5244 4.10446C4.91287 4.41605 4.41568 4.91324 4.10409 5.52476C3.97826 5.77172 3.87145 6.13321 3.81217 6.85875C3.76665 7.41593 3.75437 8.09615 3.75107 9.00023H2.00098C2.00863 6.85016 2.06898 5.6642 2.54483 4.73028C3.0242 3.78947 3.7891 3.02457 4.72991 2.5452C5.66383 2.06934 6.84979 2.009 8.99987 2.00134ZM14.9999 3.75144V2.00134C17.1499 2.009 18.3359 2.06934 19.2698 2.5452C20.2106 3.02457 20.9755 3.78947 21.4549 4.73028C21.9308 5.6642 21.9911 6.85016 21.9988 9.00023H20.2487C20.2454 8.09615 20.2331 7.41593 20.1876 6.85875C20.1283 6.13321 20.0215 5.77172 19.8956 5.52476C19.584 4.91324 19.0869 4.41605 18.4753 4.10446C18.2284 3.97863 17.8669 3.87182 17.1413 3.81254C16.5842 3.76702 15.9039 3.75474 14.9999 3.75144ZM6.85838 20.1879C7.41556 20.2334 8.09578 20.2457 8.99987 20.249V21.9991C6.84979 21.9915 5.66383 21.9311 4.72991 21.4553C3.7891 20.9759 3.0242 20.211 2.54483 19.2702C2.06898 18.3363 2.00863 17.1503 2.00098 15.0002H3.75107C3.75437 15.9043 3.76665 16.5845 3.81217 17.1417C3.87145 17.8673 3.97826 18.2287 4.10409 18.4757C4.41568 19.0872 4.91287 19.5844 5.5244 19.896C5.77136 20.0218 6.13284 20.1286 6.85838 20.1879ZM19.2698 21.4553C18.3359 21.9311 17.1499 21.9915 14.9999 21.9991V20.249C15.9039 20.2457 16.5842 20.2334 17.1413 20.1879C17.8669 20.1286 18.2284 20.0218 18.4753 19.896C19.0869 19.5844 19.584 19.0872 19.8956 18.4757C20.0215 18.2287 20.1283 17.8673 20.1876 17.1417C20.2331 16.5845 20.2454 15.9043 20.2487 15.0002H21.9988C21.9911 17.1503 21.9308 18.3363 21.4549 19.2702C20.9755 20.211 20.2106 20.9759 19.2698 21.4553ZM12.0269 16.7498C14.6502 16.7498 16.7769 14.6231 16.7769 11.9998C16.7769 9.3764 14.6502 7.24976 12.0269 7.24976C9.4035 7.24976 7.27686 9.3764 7.27686 11.9998C7.27686 14.6231 9.4035 16.7498 12.0269 16.7498ZM15.0269 11.9998C15.0269 13.6566 13.6837 14.9998 12.0269 14.9998C10.37 14.9998 9.02686 13.6566 9.02686 11.9998C9.02686 10.3429 10.37 8.99976 12.0269 8.99976C13.6837 8.99976 15.0269 10.3429 15.0269 11.9998Z"
      fill="currentColor"
    />
  </svg>
);

export const CameraFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M1.304 6.47C1 7.203 1 8.135 1 10v4c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C4.204 20 5.136 20 7 20h4c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164c.283-.681.303-1.531.305-3.134q.387.236.855.516c1.852 1.111 2.779 1.667 3.537 1.516a2 2 0 0 0 1.088-.617C23 15.24 23 14.16 23 12s0-3.24-.52-3.812a2 2 0 0 0-1.088-.617c-.758-.151-1.685.405-3.537 1.516q-.468.28-.855.516C16.998 8 16.978 7.15 16.695 6.47a4 4 0 0 0-2.164-2.165C13.796 4 12.864 4 11 4H7c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 1.303 6.47"
    />
  </svg>
);

export const CameraOffFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M14.413 19.733 16 22h2.5L4.5 2H2l1.578 2.254-.109.043A4 4 0 0 0 1.304 6.46C1 7.197 1 8.128 1 9.992v4c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.166c.735.304 1.667.304 3.531.304h4c1.766 0 2.695 0 3.413-.259M17 14.389c-.002 1.481-.02 2.32-.245 2.976L7.395 3.992H11c1.864 0 2.796 0 3.53.305a4 4 0 0 1 2.165 2.164c.283.681.303 1.531.305 3.134q.387-.236.855-.516c1.852-1.111 2.779-1.667 3.537-1.516a2 2 0 0 1 1.088.617c.52.572.52 1.652.52 3.812s0 3.24-.52 3.813a2 2 0 0 1-1.088.616c-.758.151-1.685-.404-3.537-1.516q-.468-.28-.855-.516"
    />
  </svg>
);

export const CameraOffOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.417 19.732 16 21.992l2.5.008-14-20H2l1.579 2.254-.11.043A4 4 0 0 0 1.304 6.46C1 7.197 1 8.128 1 9.992v4c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.166c.735.304 1.667.304 3.531.304h4c1.77 0 2.699 0 3.417-.26M13.17 17.95 4.826 6.035c-.366.032-.516.078-.591.11a2 2 0 0 0-1.083 1.082c-.034.083-.087.257-.119.713C3.001 8.414 3 9.033 3 9.992v4c0 .96.001 1.579.033 2.053.032.456.085.63.12.713a2 2 0 0 0 1.082 1.082c.083.034.257.088.713.119.473.032 1.093.033 2.052.033h4c.96 0 1.579 0 2.053-.033zm3.826-2.741c-.013.991-.06 1.632-.24 2.156l-1.758-2.51q.002-.379.002-.863v-4c0-.96-.001-1.578-.033-2.052-.032-.456-.085-.63-.12-.713a2 2 0 0 0-1.082-1.083c-.083-.034-.257-.087-.713-.118-.473-.033-1.093-.034-2.052-.034H8.795l-1.4-2H11c1.864 0 2.796 0 3.53.305a4 4 0 0 1 2.165 2.164c.23.555.287 1.221.3 2.315l.25-.147c.853-.502 1.58-.93 2.185-1.183.62-.26 1.354-.443 2.092-.113q.226.101.426.244c.66.469.874 1.194.964 1.861.088.649.088 1.493.088 2.482v.144c0 .99 0 1.834-.088 2.482-.09.668-.304 1.393-.964 1.861a2.5 2.5 0 0 1-.426.244c-.738.33-1.472.147-2.092-.113-.604-.253-1.332-.681-2.185-1.183zM17 12.878c.32.2.714.433 1.197.717.932.548 1.542.904 2.006 1.099.222.093.357.125.435.133a.3.3 0 0 0 .066-.001.5.5 0 0 0 .091-.054.3.3 0 0 0 .03-.051 1.7 1.7 0 0 0 .105-.444c.068-.498.07-1.204.07-2.285 0-1.08-.002-1.787-.07-2.285a1.7 1.7 0 0 0-.106-.443.3.3 0 0 0-.034-.057.5.5 0 0 0-.093-.05.3.3 0 0 0-.059 0c-.078.009-.213.04-.436.134-.463.194-1.073.55-2.005 1.098-.483.285-.877.517-1.197.717z"
      clipRule="evenodd"
    />
  </svg>
);

export const CameraOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 10c0-1.864 0-2.796.304-3.53A4 4 0 0 1 3.47 4.303C4.204 4 5.136 4 7 4h4c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165c.23.555.287 1.221.3 2.315l.127-.075.123-.072c.853-.502 1.58-.93 2.185-1.183.62-.26 1.354-.444 2.092-.113q.226.101.426.244c.66.468.874 1.194.964 1.86.088.65.088 1.494.088 2.483v.144c0 .989 0 1.833-.088 2.482-.09.667-.304 1.393-.964 1.861a2.5 2.5 0 0 1-.426.244c-.738.33-1.472.147-2.092-.113-.604-.253-1.332-.681-2.185-1.183l-.123-.072-.127-.075c-.013 1.094-.07 1.76-.3 2.315a4 4 0 0 1-2.164 2.165C13.796 20 12.864 20 11 20H7c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.164C1 16.796 1 15.864 1 14zm6-4h4c.96 0 1.579.001 2.053.033.455.032.63.085.712.12a2 2 0 0 1 1.083 1.082c.034.083.087.257.119.713C14.999 8.42 15 9.04 15 10v4c0 .96-.001 1.579-.033 2.052-.032.457-.085.63-.12.713a2 2 0 0 1-1.082 1.083c-.083.034-.257.088-.713.119C12.58 17.999 11.96 18 11 18H7c-.96 0-1.579-.001-2.052-.033-.456-.031-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.256-.119-.713C3.001 15.58 3 14.96 3 14v-4c0-.96.001-1.579.033-2.052.032-.456.085-.63.12-.713a2 2 0 0 1 1.082-1.083c.083-.034.257-.087.713-.119C5.42 6.001 6.04 6 7 6m10 6.886c.32.2.714.433 1.197.717.932.548 1.542.904 2.006 1.098.222.094.357.126.435.134a.3.3 0 0 0 .066-.001.5.5 0 0 0 .091-.055.3.3 0 0 0 .03-.05 1.7 1.7 0 0 0 .105-.444c.068-.498.07-1.204.07-2.285s-.002-1.787-.07-2.285a1.7 1.7 0 0 0-.106-.444.3.3 0 0 0-.034-.056.5.5 0 0 0-.093-.05.3.3 0 0 0-.059 0c-.078.008-.213.04-.436.134-.463.194-1.073.55-2.005 1.098a55 55 0 0 0-1.197.717z"
      clipRule="evenodd"
    />
  </svg>
);

export const CamPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.82572 5.84644C10.4937 5.26194 11.3279 5.01105 12 5.01105C12.6722 5.01105 13.5063 5.26194 14.1743 5.84644C14.8468 6.43483 15.3431 7.35469 15.3431 8.67347C15.3431 11.0389 13.695 12.6552 12 12.6552C10.3051 12.6552 8.6569 11.0389 8.6569 8.67347C8.6569 7.35469 9.15327 6.43483 9.82572 5.84644ZM12 6.58829C11.6806 6.58829 11.2235 6.71918 10.8643 7.03344C10.5475 7.31068 10.2341 7.79151 10.2341 8.67347C10.2341 10.3378 11.3369 11.078 12 11.078C12.6631 11.078 13.7659 10.3378 13.7659 8.67347C13.7659 7.79151 13.4525 7.31067 13.1357 7.03343C12.7765 6.71918 12.3195 6.58829 12 6.58829Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.61879 14.0082C8.61069 13.471 10.0785 13.2317 12 13.2317C13.9216 13.2317 15.3894 13.471 16.3812 14.0082C16.88 14.2782 17.2613 14.6251 17.5171 15.0564C17.7728 15.4877 17.8976 15.9941 17.8976 16.5749C17.8976 16.9053 17.6969 17.1964 17.389 17.4392C17.0794 17.6834 16.6408 17.8965 16.112 18.0726C15.0531 18.4254 13.5994 18.6407 12 18.6407C10.4007 18.6407 8.94699 18.4254 7.88798 18.0726C7.35925 17.8965 6.92059 17.6834 6.61103 17.4392C6.3031 17.1964 6.10242 16.9053 6.10242 16.5749C6.10242 15.9941 6.22722 15.4877 6.48296 15.0564C6.73874 14.6251 7.12006 14.2782 7.61879 14.0082ZM12 14.8089C10.1506 14.8089 9.00765 15.0498 8.36982 15.3952C8.07741 15.5535 7.92606 15.7152 7.83958 15.861C7.7803 15.9609 7.72783 16.0934 7.70022 16.2773C7.8391 16.3615 8.06148 16.468 8.38649 16.5762C9.24513 16.8623 10.5226 17.0635 12 17.0635C13.4775 17.0635 14.7549 16.8623 15.6136 16.5762C15.9386 16.468 16.1609 16.3615 16.2998 16.2773C16.2722 16.0934 16.2197 15.9609 16.1604 15.861C16.074 15.7152 15.9226 15.5535 15.6302 15.3952C14.9924 15.0498 13.8494 14.8089 12 14.8089Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 7C2 4.23858 4.23858 2 7 2H9V4H7C5.34315 4 4 5.34315 4 7V9H2V7ZM17 4H15V2H17C19.7614 2 22 4.23858 22 7V9H20V7C20 5.34315 18.6569 4 17 4ZM4 15V17C4 18.6569 5.34315 20 7 20H9V22H7C4.23858 22 2 19.7614 2 17V15H4ZM20 17V15H22V17C22 19.7614 19.7614 22 17 22H15V20H17C18.6569 20 20 18.6569 20 17Z"
      fill="currentColor"
    />
  </svg>
);

export const CarFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.826 9.711c.149.443.296.883.434 1.289.485 1.437.735 2.943.74 4.46V22h-4l-1-2H7l-1 2H2v-6.64a14 14 0 0 1 .78-4.62c.56-1.71 1.35-3.99 1.56-4.42a3.22 3.22 0 0 1 2.18-1.71A25.6 25.6 0 0 1 12 4a25.6 25.6 0 0 1 5.48.66 3.19 3.19 0 0 1 2.17 1.71c.17.34.678 1.854 1.176 3.341ZM12 6a24 24 0 0 0-5 .56 1.23 1.23 0 0 0-.87.67l-.05.144c-.087.252-.297.866-.75 2.136A33.81 33.81 0 0 1 12 9a33.72 33.72 0 0 1 6.65.5l-.337-.96-.002-.003c-.335-.954-.451-1.282-.451-1.337a1.22 1.22 0 0 0-.81-.64A23.9 23.9 0 0 0 12 6Zm3.732 7.454A2 2 0 0 1 17 13h2a5.93 5.93 0 0 1 .35 2H15a2 2 0 0 1 .732-1.547Zm-7.318.133A2 2 0 0 0 7 13H5a6.17 6.17 0 0 0-.34 2H9a2 2 0 0 0-.586-1.414Z"
      clipRule="evenodd"
    />
  </svg>
);

export const CarGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m15.178 5.998.304.902c.058.171.11.343.159.517a19.938 19.938 0 0 0-.617-.017h-.03a19.92 19.92 0 0 0-4.264.475h-.003a4.254 4.254 0 0 0-2.88 2.26l-.006.011c-.138.283-.358.896-.544 1.427-.178.506-.377 1.09-.554 1.627H5.5l-.7 1.4H2V9.952a9.8 9.8 0 0 1 .546-3.234c.392-1.197.945-2.793 1.092-3.094a2.254 2.254 0 0 1 1.526-1.197A17.92 17.92 0 0 1 9 2a17.92 17.92 0 0 1 3.836.462 2.233 2.233 0 0 1 1.519 1.197c.119.237.474 1.298.823 2.339Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m21.482 14.3-.304-.902c-.349-1.041-.704-2.102-.823-2.339a2.234 2.234 0 0 0-1.519-1.197A17.92 17.92 0 0 0 15 9.4a17.92 17.92 0 0 0-3.836.427 2.254 2.254 0 0 0-1.526 1.197c-.147.301-.7 1.897-1.092 3.094A9.8 9.8 0 0 0 8 17.352V22h2.8l.7-1.4h7l.7 1.4H22v-4.578a9.851 9.851 0 0 0-.518-3.122ZM11.5 11.192A16.803 16.803 0 0 1 15 10.8c1.189.005 2.374.136 3.535.392a.854.854 0 0 1 .567.448c0 .038.081.268.316.936v.002l.237.672A23.606 23.606 0 0 0 15 12.9a23.673 23.673 0 0 0-4.669.357 118.767 118.767 0 0 0 .56-1.596.86.86 0 0 1 .609-.469Zm7 4.509a1.4 1.4 0 0 0-1.4 1.4h3.045a4.141 4.141 0 0 0-.245-1.4h-1.4Zm-7 0a1.4 1.4 0 0 1 1.4 1.4H9.862c.002-.477.082-.95.238-1.4h1.4Z"
      clipRule="evenodd"
    />
  </svg>
);

export const CardOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 18h8c.96 0 1.578-.001 2.052-.034.457-.03.63-.084.713-.119a2 2 0 0 0 1.083-1.082c.034-.083.088-.257.119-.713.019-.284.027-.621.03-1.052H4.003c.004.431.012.768.031 1.052.032.456.085.63.12.713a2 2 0 0 0 1.082 1.082c.083.035.257.088.713.12C6.42 17.998 7.04 18 8 18Zm-4-5v-3c0-.96.001-1.579.033-2.053.032-.456.085-.63.12-.713a2 2 0 0 1 1.082-1.082c.083-.034.257-.088.713-.119C6.42 6.001 7.04 6 8 6h8c.96 0 1.578 0 2.052.033.457.031.63.085.713.119a2 2 0 0 1 1.083 1.082c.034.084.088.257.119.713.032.474.033 1.094.033 2.053v3H4Zm-2 1c0 1.864 0 2.795.304 3.53a4 4 0 0 0 2.165 2.165C5.204 20 6.136 20 8 20h8c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.165C22 16.796 22 15.864 22 14v-4c0-1.864 0-2.796-.305-3.531a4 4 0 0 0-2.164-2.165C18.796 4 17.864 4 16 4H8c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 2.303 6.47C2 7.204 2 8.136 2 9.999v4Zm8-5v2H6V9h4Z"
      clipRule="evenodd"
    />
  </svg>
);

export const CarTaxiFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M10.06 1h3.84a2 2 0 0 1 2 1.52l.11.48h-8l.05-.46a2 2 0 0 1 2-1.54Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.826 9.711c.149.443.296.883.434 1.289.485 1.437.735 2.943.74 4.46V22h-4l-1-2H7l-1 2H2v-6.64a14 14 0 0 1 .78-4.62c.56-1.71 1.35-3.99 1.56-4.42a3.22 3.22 0 0 1 2.18-1.71A25.6 25.6 0 0 1 12 4a25.6 25.6 0 0 1 5.48.66 3.19 3.19 0 0 1 2.17 1.71c.17.34.678 1.854 1.176 3.341ZM12 6a24 24 0 0 0-5 .56 1.23 1.23 0 0 0-.87.67l-.05.144c-.087.252-.297.866-.75 2.136A33.81 33.81 0 0 1 12 9a33.72 33.72 0 0 1 6.65.5l-.337-.96-.002-.003c-.335-.954-.451-1.282-.451-1.337a1.22 1.22 0 0 0-.81-.64A23.9 23.9 0 0 0 12 6Zm5 7h2c.231.642.35 1.319.35 2H15a2 2 0 0 1 2-2ZM7 13H5a6.17 6.17 0 0 0-.34 2H9a2 2 0 0 0-2-2Z"
    />
  </svg>
);

export const CarTaxiOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M13.9 1h-3.84a2 2 0 0 0-2 1.54L8.01 3h8l-.11-.48a2 2 0 0 0-2-1.52ZM5.34 13H7a2 2 0 0 1 2 2H5a6.17 6.17 0 0 1 .34-2ZM17 13h1.65c.231.642.35 1.319.35 2h-4a2 2 0 0 1 2-2Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.826 9.711c.149.443.296.883.434 1.289.485 1.437.735 2.943.74 4.46V22h-4l-1-2H7l-1 2H2v-6.64a14 14 0 0 1 .78-4.62c.56-1.71 1.35-3.99 1.56-4.42a3.22 3.22 0 0 1 2.18-1.71A25.6 25.6 0 0 1 12 4a25.6 25.6 0 0 1 5.48.66 3.19 3.19 0 0 1 2.17 1.71c.17.34.678 1.854 1.176 3.341ZM12 6a24 24 0 0 0-5 .56 1.23 1.23 0 0 0-.87.67l-.05.144c-.087.252-.297.866-.75 2.136A33.81 33.81 0 0 1 12 9a33.72 33.72 0 0 1 6.65.5l-.338-.963c-.336-.954-.452-1.282-.452-1.337a1.22 1.22 0 0 0-.81-.64A23.9 23.9 0 0 0 12 6Zm7.24 14H20v-4.54a12 12 0 0 0-.58-3.67c-.42-.18-2.25-.8-7.42-.8s-7.06.65-7.45.81A11.87 11.87 0 0 0 4 15.36V20h.76l1-2h12.48l.55 1.11.45.89Z"
      clipRule="evenodd"
    />
  </svg>
);

export const CarUltima = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 20h5l1-2h6l1 2h5v-4.316a1.5 1.5 0 0 1-.92.316h-.731c-.099 0-.197-.01-.294-.03l-2.896-.578a.88.88 0 0 1 .063-1.739L21 13l2-1v-1.5a.5.5 0 0 0-.5-.5h-2.924l-.593-2.956a1.993 1.993 0 0 0-1.568-1.568c-.47-.091-.94-.175-1.415-.24C14.934 5.089 13.698 5 12 5s-2.934.089-4 .236c-.474.065-.945.149-1.415.24a1.993 1.993 0 0 0-1.568 1.568L4.424 10H1.5a.5.5 0 0 0-.5.5V12l2 1 4.645.653c.432.056.755.43.755.875 0 .42-.29.781-.692.864l-2.832.579a1.44 1.44 0 0 1-.288.029h-.714c-.317 0-.623-.105-.874-.296V20ZM7.496 6.89c1.19-.265 2.42-.445 4.504-.445 1.27 0 3.315.18 4.504.445.976.217 1.048.57 1.246 1.54.137.673.279 1.344.419 2.015 0 0-3.753-.444-6.169-.444-2.416 0-6.169.444-6.169.444.14-.671.282-1.342.419-2.014.198-.971.27-1.324 1.246-1.541Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChatAlertOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.605 3.423A14.78 14.78 0 0 0 12 3C6.473 3 2 5.667 2 11c0 3.16 1.57 5.384 4 6.672V22h2l3.028-3.028c.32.019.644.028.972.028 5.503 0 9.96-2.643 10-7.929a4.996 4.996 0 0 1-2.127 1.238c-.276 1.346-.988 2.345-1.987 3.081C16.517 16.399 14.474 17 12 17c-.29 0-.575-.008-.855-.025l-.896-.052L8 19.5v-3.032l-1.063-.563C5.112 14.938 4 13.365 4 11c0-2.03.815-3.433 2.114-4.39C7.483 5.601 9.526 5 12 5c.735 0 1.431.053 2.084.154a5.023 5.023 0 0 1 1.52-1.73Z"
      clipRule="evenodd"
    />
    <path fill="#F5523A" d="M21.5 7.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);

export const ChatFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 11c0-5.334 4.473-8 10-8s10 2.666 10 8c0 5.333-4.473 8-10 8-.328 0-.652-.01-.972-.028L8 22H7v-3.87C4.01 16.952 2 14.575 2 11Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChatOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.249 16.923.896.053c.28.016.565.024.855.024 2.474 0 4.517-.6 5.886-1.61C19.185 14.433 20 13.03 20 11s-.815-3.433-2.114-4.39C16.517 5.601 14.474 5 12 5s-4.517.601-5.886 1.61C4.815 7.567 4 8.97 4 11c0 2.366 1.112 3.938 2.937 4.905L8 16.468V19.5l2.249-2.577Zm.78 2.05c.319.018.643.027.971.027 5.527 0 10-2.666 10-8 0-5.333-4.473-8-10-8S2 5.667 2 11c0 3.16 1.57 5.384 4 6.672V22h2l3.028-3.028Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="m10.002 19-7.498-7.5L4 9.999l6.001 6.061 9.5-9.564 1.5 1.5-11 11.004Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckRoundFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM11 16.5L17.5 10L16 8.5L11.0105 13.5L8 10.5L6.5 12L11 16.5Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckRoundOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM6.343 6.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 6.343 6.343ZM11 16.5l6.5-6.5L16 8.5l-4.99 5-3.01-3L6.5 12l4.5 4.5Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronDownL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M4 9L5.4 7.6L12 14.2L18.6 7.6L20 9L12 17L4 9Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronDownM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M16.5 10L12 14.5L7.5 10"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </svg>
);

export const ChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M14.5 16.5 10 12l4.5-4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const ChevronLeftFillL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Zm.8-15.1.7-.71 1.41 1.41-.7.7-3.7 3.7 3.7 3.7.7.7-1.41 1.41-.7-.7-4.4-4.4-.71-.71.7-.7 4.4-4.4Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronLeftFillM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm.61 12.31.62.62 1.24-1.24-.62-.62L10.78 12l3.07-3.07.62-.62-1.24-1.24-.62.62-3.69 3.7-.62.61.62.62 3.7 3.7Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronLeftL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="m15 4 1.4 1.4L9.8 12l6.6 6.6L15 20l-8-8 8-8Z"
    />
  </svg>
);

export const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M10 7.5L14.5 12L10 16.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const ChevronRightL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path fill="currentColor" d="m9 20-1.4-1.4 6.6-6.6-6.6-6.6L9 4l8 8-8 8Z" />
  </svg>
);

export const ChevronRightFillL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm-.8-15.1-.7-.71L9.09 7.6l.7.7 3.7 3.7-3.7 3.7-.7.7 1.41 1.41.7-.7 4.4-4.4.71-.71-.7-.7-4.4-4.4Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronRightFillM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-.61-12.31-.62-.62-1.24 1.24.62.62L13.22 12l-3.07 3.07-.62.62 1.24 1.24.62-.62 3.69-3.7.62-.61-.62-.62-3.7-3.7Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronUpM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.75}
      d="M7.5 14.5 12 10l4.5 4.5"
    />
  </svg>
);

export const ChevronUpL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M20 14L18.6 15.4L12 8.8L5.4 15.4L4 14L12 6L20 14Z"
      fill="currentColor"
    />
  </svg>
);

export const CoinsFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M16 15.5c0-.512-.045-1.014-.132-1.502 1.761-.021 3.403-.194 4.678-.488A8.836 8.836 0 0 0 22 13.055V15.5c0 .8-2.713 1.454-6.132 1.498.087-.486.132-.987.132-1.498ZM22 10.5V8.055a8.83 8.83 0 0 1-1.454.455C19.183 8.824 17.4 9 15.5 9c-.93 0-1.832-.042-2.67-.122a8.53 8.53 0 0 1 2.418 3.121L15.5 12c3.59 0 6.5-.671 6.5-1.5ZM9 5.5C9 6.33 11.91 7 15.5 7S22 6.33 22 5.5v-1c0-.828-2.91-1.5-6.5-1.5S9 3.672 9 4.5v1ZM7.5 22a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
      fill="currentColor"
    />
  </svg>
);

export const CoinsOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 6c0-.87-.492-1.438-.783-1.697-.3-.266-.626-.43-.86-.53-.48-.207-1.054-.347-1.61-.448C17.6 3.117 16.1 3 14.5 3s-3.101.117-4.247.325c-.556.1-1.13.241-1.61.448-.234.1-.56.264-.86.53C7.492 4.563 7 5.129 7 6v1.15a7.5 7.5 0 1 0 8.138 10.844c1.36-.027 2.617-.14 3.609-.32.556-.1 1.13-.24 1.61-.448.233-.1.56-.263.86-.53.291-.259.783-.826.783-1.696zm-6.144 9.969c2.382-.11 4.144-.502 4.144-.97v-1.636c-.395.135-.83.234-1.253.312-.783.142-1.732.241-2.766.29a7.6 7.6 0 0 1-.125 2.004m-.29-3.988C18.095 11.89 20 11.486 20 11V9.363c-.395.135-.83.234-1.253.311C17.602 9.883 16.1 10 14.5 10c.448.597.81 1.264 1.066 1.98m-3.508-4.085A28 28 0 0 0 14.5 8c3.038 0 5.5-.448 5.5-1V6c0-.553-2.462-1-5.5-1S9 5.447 9 6v1.016a7.45 7.45 0 0 1 3.059.88M14 14.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
      fill="currentColor"
    />
  </svg>
);

export const Columns = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 5h4a2 2 0 0 1 2 2v1.5h-6V5Zm-2 0H7a2 2 0 0 0-2 2v1.5h6V5Zm0 5.5H5v3h6v-3Zm0 5H5V17a2 2 0 0 0 2 2h4v-3.5Zm2 3.5h4a2 2 0 0 0 2-2v-1.5h-6V19Zm0-5.5v-3h6v3h-6ZM3 7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7Z"
      fill="currentColor"
    />
  </svg>
);

export const Compare = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <circle
      cx="9.25"
      cy="9.25"
      r="7.15"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <circle
      cx="14.449"
      cy="14.75"
      r="7.15"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.25 15.5a6.25 6.25 0 0 0 6.215-6.918 6.25 6.25 0 0 0-7.23 6.836c.33.054.67.082 1.015.082z"
      fill="currentColor"
    />
  </svg>
);

export const CompassFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.929 4.929A10 10 0 1 1 19.07 19.07 10 10 0 0 1 4.93 4.93ZM17.5 7l-3 7.5-7.5 3-.5-.5 3-7.5 7.5-3 .5.5Z"
      fill="currentColor"
    />
  </svg>
);

export const CompassOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m17 7.5-2.53 6.97L7.5 17l-.5-.5 2.53-6.97L16.5 7l.5.5Zm-5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export const CopyFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.695 13.53C22 12.797 22 11.865 22 10V8c0-1.864 0-2.796-.305-3.53a4 4 0 0 0-2.164-2.166C18.796 2 17.864 2 16 2h-2c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 8.303 4.47C8 5.204 8 6.136 8 8v2c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C11.204 16 12.136 16 14 16h2c1.865 0 2.796 0 3.532-.305a4 4 0 0 0 2.164-2.164ZM15 18l.974-.003c-.034.656-.109 1.125-.278 1.534a4 4 0 0 1-2.165 2.165C12.795 22 11.863 22 10 22H8c-1.864 0-2.796 0-3.531-.305a4 4 0 0 1-2.165-2.164c-.305-.735-.305-1.667-.305-3.531v-2c0-1.864 0-2.796.305-3.53a4 4 0 0 1 2.165-2.166c.408-.169.877-.244 1.533-.277L6 9c0 2.796 0 4.194.457 5.296a6 6 0 0 0 3.247 3.247C10.806 18 12.203 18 15 18Z"
      fill="currentColor"
    />
  </svg>
);

export const CopyOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 20h2c.96 0 1.579-.001 2.053-.033.456-.031.63-.085.713-.12a2 2 0 0 0 1.082-1.082c.035-.083.088-.256.119-.713A88.15 88.15 0 0 0 13.995 16c-1.862 0-2.793 0-3.528-.305a4 4 0 0 1-2.164-2.164c-.305-.735-.305-1.665-.305-3.525-.71.004-1.833.013-2.05.027-.456.032-.63.085-.713.12a2 2 0 0 0-1.082 1.082c-.035.083-.088.257-.12.713C4.002 12.42 4 13.04 4 14v2c0 .96.001 1.578.034 2.052.03.457.084.63.119.713a2 2 0 0 0 1.082 1.083c.083.034.257.088.713.119C6.422 19.999 7.04 20 8 20ZM7.998 8.008c-1.252.019-3.012.083-3.528.296a4 4 0 0 0-2.165 2.165C2 11.204 2 12.136 2 14v2c0 1.864 0 2.796.305 3.53a4 4 0 0 0 2.165 2.165C5.205 22 6.137 22 8 22h2c1.864 0 2.796 0 3.531-.305a4 4 0 0 0 2.165-2.164c.244-.59.293-1.307.302-2.531v-1c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.166-2.164c.304-.735.304-1.667.304-3.531V8c0-1.864 0-2.796-.304-3.53a4 4 0 0 0-2.165-2.166C18.794 2 17.862 2 15.998 2h-2c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 8.302 4.47c-.305.735-.305 1.667-.305 3.531v.008Zm8 5.992h-2c-.96 0-1.579-.001-2.052-.033-.456-.032-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.257-.119-.713C10 11.58 9.998 10.96 9.998 10V8c0-.96.001-1.579.034-2.052.03-.456.084-.63.118-.713a2 2 0 0 1 1.083-1.083c.083-.034.257-.087.713-.119.473-.032 1.093-.033 2.052-.033h2c.96 0 1.579.001 2.053.033.456.032.63.085.712.12a2 2 0 0 1 1.083 1.082c.034.083.087.257.119.713.032.473.033 1.093.033 2.052v2c0 .96-.001 1.579-.033 2.053-.032.455-.085.63-.12.712a2 2 0 0 1-1.082 1.083c-.083.034-.257.087-.713.119-.473.032-1.093.033-2.052.033Z"
      fill="currentColor"
    />
  </svg>
);

export const CornerUp = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M16.95 15.33a1 1 0 0 0 0-1.414l-4.243-4.243a1 1 0 0 0-1.414 0L7.05 13.916a1 1 0 1 0 1.415 1.414L12 11.795l3.536 3.535a1 1 0 0 0 1.414 0Z"
      fill="currentColor"
    />
  </svg>
);

export const Coupon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.967 7.948C19.999 8.42 20 9.04 20 10v4c0 .96-.001 1.579-.033 2.052-.031.457-.085.63-.12.713a2 2 0 0 1-1.082 1.083c-.083.034-.256.088-.713.119-.474.032-1.093.033-2.052.033H8c-.96 0-1.579-.001-2.052-.033-.456-.031-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.256-.119-.713C4.001 15.58 4 14.96 4 14v-4c0-.96.001-1.579.033-2.052.032-.456.085-.63.12-.713a2 2 0 0 1 1.082-1.083c.083-.034.257-.087.713-.119C6.42 6.001 7.04 6 8 6h.897a4 4 0 0 0 6.206 0H16c.96 0 1.578.001 2.052.033.457.032.63.085.713.12a2 2 0 0 1 1.083 1.082c.034.083.088.257.119.713Zm-9.182-2.884A2 2 0 0 1 10.07 4H8c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 2.303 6.47C2 7.204 2 8.136 2 10v4c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C5.204 20 6.136 20 8 20h8c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164C22 16.796 22 15.864 22 14v-4c0-1.864 0-2.796-.305-3.53a4 4 0 0 0-2.164-2.166C18.796 4 17.864 4 16 4h-2.07a2 2 0 0 1-3.145 1.064ZM9.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-5.75 0L13 9h2.25L11 16H8.75Z"
      fill="currentColor"
    />
  </svg>
);

export const Courier = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m17.809 4.45.67-.27a1.554 1.554 0 0 0 .958-1.649l-3.062.54a2.787 2.787 0 1 0 1.433 1.379m-14.68 6.293a2.91 2.91 0 0 1 2.694-1.56c.476.019 1.04.028 1.663.039 1.253.02 2.742.045 4.216.155.293 3.884-.856 6.327-2.552 7.923l-.3 2.1-5.2-.3.85-6.4-1.951-.847zM8.85 19.4 8.6 21c.445 0 1.417.011 2.588.024h.001c1.768.02 3.985.046 5.512.046.366-1.189.665-2.414.915-3.76l1.76 3.763c.613-.485.92-.727 1.115-1.024a2.2 2.2 0 0 0 .36-1.296c-.014-.355-.152-.72-.427-1.453l-2.062-5.473c-.037-.097-.061-.162-.088-.21a.7.7 0 0 0-.132-.251c-.856-1.052-2.78-1.575-4.932-1.842.368 4.38-1.125 7.824-4.36 9.876"
      clipRule="evenodd"
    />
  </svg>
);

export const CourierBike = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M7.346 1.652a.97.97 0 0 1 1.227-.005l2.838 2.26c-2.422 1.796-4.93 5.39-4.93 5.39L3.8 7.15a.95.95 0 0 1-.229-1.248C4.577 4.31 5.94 2.837 7.346 1.652"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 23a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M23 18.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.464 11.087 12.684 9.6a19 19 0 0 0-1.636 2.082l2.435 1.754a1.5 1.5 0 0 1 .554 1.667l-1.86 5.918a1.32 1.32 0 0 1-1.382-1.55l.768-4.315-5.25-2.59h.002l-.01-.002C8.308 7.897 12.52 4.826 12.71 4.69l.003-.013 2.992 4.708 3.202 1.057a.86.86 0 0 1 .445 1.296l-4.04-.306a1.5 1.5 0 0 1-.848-.344m-.691-7.928A2.118 2.118 0 1 1 17.79 4.5a2.118 2.118 0 0 1-4.018-1.34"
    />
  </svg>
);

export const CriticalEvent = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.586 2.1a2 2 0 0 1 2.828 0l1.9 1.9H18a2 2 0 0 1 2 2v2.686l1.9 1.9a2 2 0 0 1 0 2.828l-1.9 1.9V18a2 2 0 0 1-2 2h-2.686l-1.9 1.9a2 2 0 0 1-2.828 0l-1.9-1.9H6a2 2 0 0 1-2-2v-2.686l-1.9-1.9a2 2 0 0 1 0-2.828l1.9-1.9V6a2 2 0 0 1 2-2h2.686zM11 14l-.25-8h2.5L13 14zm2.5 3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
      clipRule="evenodd"
    />
  </svg>
);

export const CrossM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.05 8.464 10.586 12 7.05 15.536l1.414 1.414L12 13.414l3.536 3.536 1.414-1.414L13.414 12l3.536-3.536-1.414-1.414L12 10.586 8.464 7.05 7.05 8.464Z"
      fill="currentColor"
    />
  </svg>
);

export const CrossRoundFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM7.29004 8.70447L10.5858 12.0002L7.29047 15.2955L8.70469 16.7097L12 13.4144L15.2953 16.7097L16.7095 15.2955L13.4142 12.0002L16.71 8.70447L15.2957 7.29025L12 10.586L8.70425 7.29025L7.29004 8.70447Z"
      fill="currentColor"
    />
  </svg>
);

export const CrossRoundOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 13.4141L8.99417 16.42L7.57995 15.0057L10.5858 11.9999L7.58008 8.9942L8.99429 7.57999L12 10.5857L15.0057 7.57999L16.4199 8.9942L13.4142 11.9999L16.42 15.0057L15.0058 16.42L12 13.4141Z"
      fill="currentColor"
    />
  </svg>
);

export const CrossBackspaceFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.463 10c0-1.864 0-2.796-.305-3.53a4 4 0 0 0-2.165-2.166C19.258 4 18.326 4 16.463 4H9.787c-1.078 0-1.617 0-2.11.127a4 4 0 0 0-1.752.971c-.369.35-.655.808-1.226 1.722L2.953 9.615c-.48.768-.72 1.153-.836 1.558a3 3 0 0 0 0 1.654c.116.405.356.79.836 1.558L4.7 17.18c.571.914.857 1.372 1.226 1.722a4 4 0 0 0 1.752.97C8.171 20 8.71 20 9.788 20h6.674c1.864 0 2.796 0 3.531-.305a4 4 0 0 0 2.165-2.164c.304-.735.304-1.667.304-3.531zm-8.053 1.995L17.405 9l-1.414-1.414-2.995 2.995L10 7.586 8.586 9l2.995 2.996-2.995 2.995L10 16.405l2.996-2.995L16 16.414 17.414 15z"
      clipRule="evenodd"
    />
  </svg>
);

export const CrossBackspaceOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m16.991 9.414-2.581 2.582 2.581 2.58-1.414 1.415-2.581-2.581-2.582 2.581L9 14.577l2.581-2.581L9 9.414 10.414 8l2.582 2.581L15.576 8z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.158 6.47c.304.734.304 1.666.304 3.53v4c0 1.864 0 2.796-.304 3.53a4 4 0 0 1-2.165 2.165c-.735.305-1.667.305-3.53.305H9.787c-1.078 0-1.618 0-2.11-.127a4 4 0 0 1-1.752-.971c-.37-.35-.655-.808-1.226-1.722l-1.747-2.795c-.48-.768-.72-1.153-.837-1.558a3 3 0 0 1 0-1.654c.117-.405.357-.79.837-1.558L4.7 6.82c.571-.914.857-1.371 1.226-1.722a4 4 0 0 1 1.752-.97C8.17 4 8.71 4 9.788 4h6.674c1.864 0 2.796 0 3.531.304a4 4 0 0 1 2.165 2.165M9.788 6h6.674c.96 0 1.579.001 2.053.033.456.032.63.085.713.12a2 2 0 0 1 1.082 1.082c.035.083.088.257.119.713.032.473.033 1.093.033 2.052v4c0 .96 0 1.579-.033 2.052-.031.457-.084.63-.119.713a2 2 0 0 1-1.082 1.083c-.084.034-.257.088-.713.119-.474.032-1.093.033-2.053.033H9.788c-1.185 0-1.421-.015-1.61-.064a2 2 0 0 1-.875-.485c-.141-.134-.28-.326-.907-1.331l-1.747-2.795c-.545-.871-.59-.979-.61-1.05a1 1 0 0 1 0-.55c.02-.071.065-.179.61-1.05L6.396 7.88c.628-1.005.766-1.197.907-1.33a2 2 0 0 1 .876-.486C8.367 6.015 8.603 6 9.788 6"
      clipRule="evenodd"
    />
  </svg>
);

export const CrossBanFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.828 3h6.344a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 21 8.828v6.344a2 2 0 0 1-.586 1.414l-3.828 3.828a2 2 0 0 1-1.414.586H8.828a2 2 0 0 1-1.414-.586l-3.828-3.828A2 2 0 0 1 3 15.172V8.828a2 2 0 0 1 .586-1.414l3.828-3.828A2 2 0 0 1 8.828 3m4.582 8.996 2.581-2.582L14.577 8l-2.581 2.581L9.414 8 8 9.414l2.581 2.582L8 14.576l1.414 1.415 2.582-2.581 2.58 2.581 1.415-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

export const CrossBanOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2.6 21.4 7c.4.3.6.8.6 1.4v7.2c0 .5-.2 1-.6 1.4L17 21.4c-.4.4-.9.6-1.4.6H8.4c-.6 0-1.1-.2-1.4-.6L2.6 17c-.4-.4-.6-.9-.6-1.4V8.4c0-.6.2-1.1.6-1.4L7 2.6c.3-.4.8-.6 1.4-.6h7.2c.5 0 1.1.2 1.4.6M15.6 20l4.4-4.4V8.4L15.6 4H8.4L4 8.4v7.2L8.4 20zm-2.19-8.004 2.581-2.582L14.577 8l-2.581 2.581L9.414 8 8 9.414l2.581 2.582L8 14.576l1.414 1.415 2.582-2.581 2.58 2.581 1.415-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

export const CrossL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M10.584 12 4 5.416 5.416 4 12 10.584 18.584 4 20 5.416 13.416 12 20 18.584 18.584 20 12 13.416 5.416 20 4 18.584z"
    />
  </svg>
);

export const CrossLFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12m-5.414-16 4 4-4 4.086L12 21.5l4-4.086 4.086 4.086 1.414-1.414L17.414 16l4.086-4-1.414-1.414-4.086 4-4-4z"
      clipRule="evenodd"
    />
  </svg>
);

export const DislikeFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.004 14.01h-4.5c-1.5 0-1.99-.92-2-2 .05-.808.408-1.446 1-2a10 10 0 0 0-.11-.284c-.19-.484-.35-.888-.14-1.73.25-1 1.25-1.735 1.25-1.735s.308-1.256 1.506-2.245C6.21 3.026 7.004 3.01 8.004 3.01h2.994c1.531 0 3.228.615 4.506 1.985 0 0 .5 1.015.5 3.015s-.5 3.5-.5 3.5c-2.08 2.984-3.948 6.905-4.5 10.5h-1c-2.5 0-2.62-3.036-2.62-4s.313-2.684.62-4m13-6.01c0-2.73-.9-5-2-5h-3c1 1 1.5 3 1.5 5s-.5 4-1.5 5h3c1.11 0 2-2.27 2-5"
    />
  </svg>
);

export const DislikeOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M4.09 16.003h4.66c-.172.99-.259 1.994-.26 2.999 0 2.469 1.15 3.998 3 3.998h2l.14-.81a33.28 33.28 0 0 1 2.75-8.186h4.12c1.11 0 2-2.498 2-5.507C22.5 5.49 21.61 3 20.5 3h-5c-.23 0-.46.26-.67.65A9.004 9.004 0 0 0 11.5 3h-2C6.82 3 4.79 4.41 4.21 6.628a4.058 4.058 0 0 0-1.29 4.198A4.386 4.386 0 0 0 2 13.465c0 1.679.94 2.538 2.09 2.538ZM19.91 5.01c.43 1.115.63 2.304.59 3.498a8.933 8.933 0 0 1-.59 3.498h-3a8.993 8.993 0 0 0 .59-3.498 8.892 8.892 0 0 0-.6-3.498h3.01ZM4.75 11.686l.42-.51-.27-.62a2.108 2.108 0 0 1 .85-2.548l.32-.24.07-.39c.31-1.74 2-2.359 3.4-2.359h2a6.202 6.202 0 0 1 3.72 1.13 9.45 9.45 0 0 1 .28 2.368 10.5 10.5 0 0 1-.9 4.578 35.967 35.967 0 0 0-2.8 7.906h-.34c-.82 0-1-1.09-1-1.999a15.618 15.618 0 0 1 .45-3.758c.18-.69.09-1.24-1-1.24H4.04a2.438 2.438 0 0 1 .71-2.318Z"
    />
  </svg>
);

export const DocDraftOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M13 4H9c-.96 0-1.58 0-2.05.03-.46.03-.63.09-.72.12a2 2 0 0 0-1.08 1.08c-.03.09-.09.26-.12.72C5 6.42 5 7.05 5 8v8c0 .96 0 1.58.03 2.05.03.46.09.63.12.72a2 2 0 0 0 1.08 1.08c.09.03.26.09.72.12.47.03 1.1.03 2.05.03h4c.96 0 1.58 0 2.05-.03.46-.03.63-.09.72-.12a2 2 0 0 0 1.08-1.08c.03-.09.09-.26.12-.72.03-.47.03-1.1.03-2.05v-.5l2-2V16c0 1.86 0 2.8-.3 3.53a4 4 0 0 1-2.17 2.17c-.73.3-1.67.3-3.53.3H9c-1.86 0-2.8 0-3.53-.3a4 4 0 0 1-2.17-2.17C3 18.8 3 17.86 3 16V8c0-1.86 0-2.8.3-3.53A4 4 0 0 1 5.47 2.3C6.2 2 7.14 2 9 2h4c1.86 0 2.8 0 3.53.3a4 4 0 0 1 2.17 2.17c.3.73.3 1.67.3 3.53v.5l3-3L23.5 7l-10 10h-3l6.5-6.5V8c0-.96 0-1.58-.03-2.05a2.32 2.32 0 0 0-.12-.72 2 2 0 0 0-1.08-1.08 2.32 2.32 0 0 0-.72-.12C14.58 4 13.95 4 13 4Z"
    />
    <path
      fill="currentColor"
      d="M14.97 8.86c-.17-1.18-1.08-1.9-2.23-2.3A15.2 15.2 0 0 0 8 6v2c1.96 0 3.28.17 4.09.46.8.27.88.56.9.68.02.16 0 .23-.03.28a.91.91 0 0 1-.3.3c-.41.27-1.03.49-1.84.77l-.05.01c-.73.25-1.63.56-2.33 1.02A2.9 2.9 0 0 0 7 14a3 3 0 0 0 .92 2.08A3 3 0 0 0 10 17v-2c-.17 0-.43-.1-.67-.33-.23-.24-.33-.5-.33-.67 0-.3.12-.54.54-.81.47-.3 1.12-.54 1.92-.81l.09-.03c.71-.24 1.58-.54 2.23-.98.35-.24.7-.56.94-1 .25-.45.33-.97.25-1.51Z"
    />
  </svg>
);

export const DocEmptyFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m19.82 8-.07-.15c-.14-.24-.34-.44-.75-.85l-4-4c-.4-.4-.61-.61-.85-.75a2 2 0 0 0-.28-.13c.06.24.1.48.1.72.03.31.03.69.03 1.13v.23c0 .86 0 1.44.04 1.89.03.44.1.66.18.82.19.37.5.68.87.87.16.08.38.15.82.18.45.04 1.03.04 1.89.04H19.83Z"
    />
    <path
      fill="currentColor"
      d="M10.27 2c-2.27 0-3.46.04-4.36.59A4 4 0 0 0 4.59 3.9C4 4.87 4 6.18 4 8.8v6.4c0 2.62 0 3.93.59 4.89a4 4 0 0 0 1.32 1.32c.96.59 2.27.59 4.89.59h2.4c2.62 0 3.93 0 4.89-.59a4 4 0 0 0 1.32-1.32c.59-.96.59-2.27.59-4.89v-5.18c-.23-.02-.54-.02-1-.02h-1.24c-.8 0-1.47 0-2.01-.04a4.09 4.09 0 0 1-1.57-.4 4 4 0 0 1-1.74-1.74c-.25-.49-.35-1-.4-1.57-.04-.54-.04-1.2-.04-2V4c0-.48 0-.79-.02-1.03a1.16 1.16 0 0 0-.06-.35 1 1 0 0 0-.54-.54 1.16 1.16 0 0 0-.35-.06C10.83 2 10.6 2 10.27 2Z"
    />
  </svg>
);

export const DocDraftFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 2h4c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165c.245.59.293 1.308.303 2.533L21.499 4.5 23 6 19 10v.003L11.003 18H13.5l5.5-5.498V16c0 1.863 0 2.795-.305 3.53a4 4 0 0 1-2.164 2.165C15.796 22 14.864 22 13 22H9c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.165C3 18.796 3 17.863 3 16V8c0-1.864 0-2.796.304-3.531A4 4 0 0 1 5.47 2.304C6.204 2 7.136 2 9 2Zm5.992 6.32a3.021 3.021 0 0 0-.47-1.305c-.291-.442-.712-.817-1.274-1.117C12.16 5.318 10.498 5 8 5v2c2.391 0 3.655.316 4.307.663.31.165.463.327.546.453.084.128.132.273.155.453.06.482-.091.828-.462 1.19-.421.412-1.051.767-1.85 1.186l-.19.1c-.697.365-1.509.79-2.146 1.318-.73.604-1.36 1.45-1.36 2.64C7 16.406 8.139 18 10 18v-2c-.583 0-1-.517-1-.997 0-.384.173-.717.636-1.1.467-.388 1.094-.716 1.846-1.112l.145-.075c.756-.398 1.653-.877 2.316-1.526.714-.697 1.204-1.636 1.05-2.87Z"
      clipRule="evenodd"
    />
  </svg>
);

export const DocEmptyOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 15.2C20 17.8187 20 19.1281 19.4106 20.09C19.0807 20.6282 18.6282 21.0807 18.09 21.4106C17.1281 22 15.8187 22 13.2 22H10.8C8.18126 22 6.87188 22 5.91001 21.4106C5.37178 21.0807 4.91926 20.6282 4.58944 20.09C4 19.1281 4 17.8187 4 15.2V8.8C4 6.18126 4 4.87188 4.58944 3.91001C4.91926 3.37178 5.37178 2.91926 5.91001 2.58944C6.76853 2.06334 7.90388 2.00681 10 2.00073L10.032 2C10.1215 2 10.2086 2 10.2931 2.00018C10.4564 2 10.6253 2 10.8 2H11.1833C12.3254 2 12.8964 2 13.4289 2.15018C13.7316 2.23555 14.0232 2.35633 14.2976 2.51002C14.7804 2.78036 15.1841 3.18413 15.9917 3.99167L18.0083 6.00833C18.8159 6.81587 19.2196 7.21965 19.49 7.70237C19.6437 7.97679 19.7644 8.26838 19.8498 8.57109C20 9.10359 20 9.67461 20 10.8167V15.2ZM10.2933 4.00024C9.22706 4.0016 8.49489 4.01032 7.92299 4.0647C7.29446 4.12446 7.06888 4.22494 6.955 4.29472C6.68589 4.45963 6.45963 4.68589 6.29472 4.955C6.22494 5.06888 6.12446 5.29446 6.0647 5.92299C6.00211 6.58127 6 7.4519 6 8.8V15.2C6 16.5481 6.00211 17.4187 6.0647 18.077C6.12446 18.7055 6.22494 18.9311 6.29472 19.045C6.45963 19.3141 6.68589 19.5404 6.955 19.7053C7.06888 19.7751 7.29446 19.8755 7.92299 19.9353C8.58127 19.9979 9.4519 20 10.8 20H13.2C14.5481 20 15.4187 19.9979 16.077 19.9353C16.7055 19.8755 16.9311 19.7751 17.045 19.7053C17.3141 19.5404 17.5404 19.3141 17.7053 19.045C17.7751 18.9311 17.8755 18.7055 17.9353 18.077C17.9979 17.4187 18 16.5481 18 15.2L18 12C18 11.5204 17.9995 11.2107 17.9833 10.9738C17.9677 10.7458 17.9411 10.6589 17.9239 10.6173C17.8224 10.3723 17.6277 10.1776 17.3827 10.0761C17.3411 10.0589 17.2542 10.0323 17.0262 10.0167C16.7893 10.0005 16.4796 10 16 10L15.968 10C15.5294 10 15.1509 10 14.8376 9.97865C14.5078 9.95615 14.1779 9.90664 13.8519 9.77164C13.1169 9.46716 12.5328 8.88314 12.2284 8.14805C12.0934 7.82212 12.0439 7.49221 12.0213 7.16238C12 6.84912 12 6.47063 12 6.03197L12 6C12 5.52038 11.9995 5.21074 11.9833 4.97376C11.9677 4.74576 11.9411 4.65893 11.9239 4.61732C11.8224 4.37229 11.6277 4.17762 11.3827 4.07612C11.3411 4.05889 11.2542 4.03227 11.0262 4.01671C10.8415 4.00411 10.6126 4.001 10.2933 4.00024ZM17.1881 8.02316C17.1795 8.02254 17.1709 8.02193 17.1624 8.02135C16.8491 7.99998 16.4706 7.99999 16.032 8L16 8C15.5204 8 15.2107 7.99946 14.9738 7.98329C14.7458 7.96773 14.6589 7.94112 14.6173 7.92388C14.3723 7.82239 14.1776 7.62771 14.0761 7.38268C14.0589 7.34107 14.0323 7.25424 14.0167 7.02624C14.0005 6.78926 14 6.47963 14 6L14 5.96804C14 5.52938 14 5.15088 13.9786 4.83762C13.9781 4.82906 13.9775 4.82051 13.9768 4.81195C14.1314 4.9618 14.3263 5.15471 14.5775 5.40589L16.5941 7.42254C16.8453 7.67372 17.0382 7.86861 17.1881 8.02316Z"
    />
  </svg>
);

export const DocReportFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 2h4c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165C20 5.204 20 6.136 20 8v8c0 1.864 0 2.796-.305 3.53a4 4 0 0 1-2.164 2.165C16.796 22 15.864 22 14 22h-4c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.164C4 18.796 4 17.864 4 16V8c0-1.864 0-2.796.304-3.53A4 4 0 0 1 6.47 2.303C7.204 2 8.136 2 10 2m3 6v8h2V8zm-4 3v5h2v-5z"
      clipRule="evenodd"
    />
  </svg>
);

export const DocReportOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M13 8v8h2V8h-2ZM9 16v-5h2v5H9Z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 2h4c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165C20 5.204 20 6.136 20 8v8c0 1.864 0 2.796-.305 3.53a4 4 0 0 1-2.164 2.165C16.796 22 15.864 22 14 22h-4c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.164C4 18.796 4 17.864 4 16V8c0-1.864 0-2.796.304-3.53A4 4 0 0 1 6.47 2.303C7.204 2 8.136 2 10 2Zm4 2h-4c-.96 0-1.579.001-2.052.033-.456.032-.63.085-.713.12a2 2 0 0 0-1.083 1.082c-.034.083-.087.257-.119.713C6.001 6.42 6 7.04 6 8v8c0 .96.001 1.578.033 2.052.032.457.085.63.12.713a2 2 0 0 0 1.082 1.083c.083.034.257.088.713.119C8.42 19.999 9.04 20 10 20h4c.96 0 1.579-.001 2.052-.033.457-.031.63-.085.713-.12a2 2 0 0 0 1.083-1.082c.034-.083.088-.256.119-.713.032-.474.033-1.093.033-2.052V8c0-.96-.001-1.579-.033-2.052-.031-.456-.085-.63-.12-.713a2 2 0 0 0-1.082-1.083c-.083-.034-.256-.087-.713-.119C15.58 4.001 14.96 4 14 4Z"
      clipRule="evenodd"
    />
  </svg>
);

export const DocTextFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 2H10C8.13623 2 7.20435 2 6.46926 2.30448C5.48915 2.71046 4.71046 3.48915 4.30448 4.46927C4 5.20435 4 6.13623 4 7.99999V16C4 17.8638 4 18.7956 4.30448 19.5307C4.71046 20.5108 5.48915 21.2895 6.46926 21.6955C7.20435 22 8.13623 22 10 22H14C15.8638 22 16.7957 22 17.5307 21.6955C18.5108 21.2895 19.2895 20.5108 19.6955 19.5307C20 18.7956 20 17.8638 20 16V8C20 6.13623 20 5.20435 19.6955 4.46927C19.2895 3.48915 18.5108 2.71046 17.5307 2.30448C16.7957 2 15.8638 2 14 2ZM8 8H16V6H8V8ZM16 13H8V11H16V13ZM8 16V18H12V16H8Z"
      fill="currentColor"
    />
  </svg>
);

export const DocTextOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 4h4c.96 0 1.579.001 2.052.033.457.032.63.085.713.12a2 2 0 0 1 1.083 1.082c.034.083.088.257.119.713C17.999 6.42 18 7.04 18 8v8c0 .96-.001 1.578-.033 2.052-.031.457-.085.63-.12.713a2 2 0 0 1-1.082 1.083c-.083.034-.256.088-.713.119C15.58 19.999 14.96 20 14 20h-4c-.96 0-1.579-.001-2.052-.033-.456-.031-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.256-.119-.713C6.001 17.578 6 16.96 6 16V8c0-.96.001-1.579.033-2.052.032-.456.085-.63.12-.713a2 2 0 0 1 1.082-1.083c.083-.034.257-.087.713-.119C8.42 4.001 9.04 4 10 4Zm4-2h-4c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 4.303 4.47C4 5.204 4 6.136 4 8v8c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C7.204 22 8.136 22 10 22h4c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164C20 18.796 20 17.864 20 16V8c0-1.864 0-2.796-.305-3.53a4 4 0 0 0-2.164-2.166C16.796 2 15.864 2 14 2ZM8 9h8V7H8v2Zm8 4H8v-2h8v2Zm-8 4h4v-2H8v2Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Door = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H8Zm9 2H8a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
      fill="currentColor"
    />
    <path
      d="M8.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z"
      fill="currentColor"
    />
  </svg>
);

export const DotL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M12 19.0002C11.0337 19.0002 10.1263 18.8176 9.27778 18.4523C8.42929 18.0987 7.68098 17.6038 7.03283 16.9674C6.39646 16.3193 5.89562 15.571 5.5303 14.7225C5.17677 13.874 5 12.9666 5 12.0002C5 11.0221 5.17677 10.1147 5.5303 9.27802C5.89562 8.42954 6.39646 7.68711 7.03283 7.05075C7.68098 6.4026 8.42929 5.90176 9.27778 5.54822C10.1263 5.1829 11.0337 5.00024 12 5.00024C12.9781 5.00024 13.8855 5.1829 14.7222 5.54822C15.5707 5.90176 16.3131 6.4026 16.9495 7.05075C17.5976 7.68711 18.0985 8.42954 18.452 9.27802C18.8173 10.1147 19 11.0221 19 12.0002C19 12.9666 18.8173 13.874 18.452 14.7225C18.0985 15.571 17.5976 16.3193 16.9495 16.9674C16.3131 17.6038 15.5707 18.0987 14.7222 18.4523C13.8855 18.8176 12.9781 19.0002 12 19.0002Z"
      fill="currentColor"
    />
  </svg>
);

export const DotLOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
      fill="currentColor"
    />
  </svg>
);

export const DotM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
      fill="currentColor"
    />
  </svg>
);

export const Download = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M12.01 15.736c.239 0 .467-.078.706-.31l3.332-3.127c.169-.165.268-.349.268-.581 0-.455-.378-.784-.835-.784a.841.841 0 0 0-.617.27l-1.392 1.434-.637.716.1-1.433V1.891c0-.484-.418-.891-.925-.891-.517 0-.935.407-.935.89v10.031l.1 1.433-.637-.716-1.392-1.433a.863.863 0 0 0-.627-.271c-.457 0-.825.329-.825.784 0 .232.1.416.268.58l3.342 3.128c.239.232.457.31.706.31ZM6.272 22h11.456C19.886 22 21 20.916 21 18.844V9.326c0-2.072-1.114-3.156-3.272-3.156h-2.685v1.927H17.6c.905 0 1.422.465 1.422 1.394v9.178c0 .93-.517 1.395-1.422 1.395H6.4c-.915 0-1.422-.465-1.422-1.395V9.491c0-.93.507-1.394 1.422-1.394h2.586V6.17H6.272C4.124 6.17 3 7.245 3 9.326v9.518C3 20.916 4.124 22 6.272 22Z"
      fill="currentColor"
    />
  </svg>
);

export const Drag = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 8H3v2h18V8Zm0 5H3v2h18v-2Z"
      fill="currentColor"
    />
  </svg>
);

export const Edit = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.556 3.707c.033-.033.068-.063.104-.09.539.304 1.107.69 1.57 1.153.497.498.908 1.118 1.221 1.692-.02.025-.043.05-.066.073l-2.869 2.869a8.95 8.95 0 0 0-1.273-1.647 8.818 8.818 0 0 0-1.533-1.203l2.846-2.847Zm-4.305 4.305L4.033 17.23l-.619 3.447 3.447-.618 9.192-9.192c-.314-.575-.726-1.197-1.225-1.696-.464-.465-1.036-.854-1.577-1.159Z"
    />
  </svg>
);

export const Eats = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M19.735 19.082a10.344 10.344 0 0 1-6.235 2.1c-2.672 0-5.168-1.023-7.026-2.88-1.818-1.819-2.82-4.204-2.82-6.718 0-4.921 3.894-8.93 8.68-8.93 2.173 0 4.2.824 5.712 2.318 1.483 1.467 2.3 3.4 2.3 5.444 0 3.913-3.07 7.095-6.845 7.095-3.406 0-6.177-2.659-6.177-5.927 0-2.9 2.247-5.26 5.01-5.26 2.394 0 4.343 1.835 4.343 4.092 0 1.89-1.425 3.426-3.176 3.426-1.549 0-2.508-1.172-2.508-2.258 0-.878.601-1.59 1.34-1.59.359 0 .605.19.662.353a.827.827 0 0 0 .632 1.47c.59-.09 1.035-.693 1.035-1.4 0-1.145-1.045-2.078-2.328-2.078-1.655 0-2.996 1.456-2.996 3.245 0 2.157 1.868 3.912 4.163 3.912 2.664 0 4.83-2.278 4.83-5.08 0-3.168-2.69-5.747-5.997-5.747-3.675 0-6.665 3.102-6.665 6.915 0 4.18 3.514 7.582 7.832 7.582 4.686 0 8.499-3.926 8.499-8.75 0-2.489-.99-4.84-2.79-6.617C17.385 1.993 14.944 1 12.333 1 6.635 1 2 5.748 2 11.584c0 2.956 1.174 5.757 3.309 7.89 2.17 2.169 5.081 3.364 8.195 3.364a11.992 11.992 0 0 0 7.247-2.445l-1.016-1.31Z"
      fill="currentColor"
    />
  </svg>
);

export const EducationOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.867 3.223a1.826 1.826 0 0 0-1.734 0L2.793 7.81c-1.244.684-1.244 2.47 0 3.154L4.98 12.18 5 16.993c0 .67.397 1.312.995 1.611l3.769 1.884a5.062 5.062 0 0 0 4.472 0l3.769-1.884a1.83 1.83 0 0 0 .995-1.61V12.18l1.555-.856a.303.303 0 0 1 .445.263v5.401l1.773-1.152a.507.507 0 0 0 .227-.42V9.988c0-.744-.428-1.427-1.076-1.783l-9.056-4.98-.001-.002Zm-1.734 12.328L7 13.278v3.406c0 .112.066.219.166.268l3.492 1.746c.833.417 1.85.417 2.684 0l3.492-1.746c.1-.05.166-.156.166-.268v-3.406l-4.132 2.273a1.825 1.825 0 0 1-1.735 0Zm.627-10.39L4.395 9.21c-.135.074-.132.28 0 .351l7.365 4.05a.507.507 0 0 0 .482 0l7.365-4.05c.132-.073.135-.278 0-.352l-7.365-4.05a.507.507 0 0 0-.482 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export const EuroOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 22C17.4695 22 22 17.4792 22 12C22 6.53049 17.4695 2 11.9903 2C6.52081 2 2 6.53049 2 12C2 17.4792 6.53049 22 12 22ZM12 20.0349C7.54695 20.0349 3.97483 16.453 3.97483 12C3.97483 7.54695 7.53727 3.97483 11.9903 3.97483C16.4434 3.97483 20.0252 7.54695 20.0349 12C20.0349 16.453 16.453 20.0349 12 20.0349ZM13.3166 16.5789C13.8199 16.5789 14.1781 16.5208 14.4201 16.395C14.6912 16.2691 14.817 16.0755 14.817 15.8238C14.817 15.485 14.5944 15.2817 14.2846 15.2527C14.062 15.2236 13.7231 15.2623 13.3069 15.2623C11.9806 15.2527 10.8867 14.6041 10.4898 13.3262H13.423C13.6941 13.3262 13.878 13.1229 13.878 12.8712C13.878 12.5905 13.6941 12.4066 13.423 12.4066H10.2962C10.2769 12.3001 10.2769 12.1549 10.2769 12.0097C10.2769 11.8645 10.2769 11.7289 10.2865 11.6031H13.423C13.6941 11.6031 13.878 11.3998 13.878 11.1384C13.878 10.8674 13.6941 10.6834 13.423 10.6834H10.4898C10.8964 9.4153 11.9903 8.7667 13.3166 8.75702C13.7231 8.75702 14.0716 8.80542 14.2846 8.7667C14.5944 8.73766 14.817 8.53437 14.817 8.19555C14.817 7.95353 14.7202 7.74056 14.4008 7.59535C14.1781 7.47919 13.8199 7.43078 13.3166 7.43078C11.1965 7.43078 9.44434 8.53437 8.93127 10.6834H7.93417C7.6728 10.6834 7.47919 10.8674 7.47919 11.1384C7.47919 11.3998 7.6728 11.6031 7.93417 11.6031H8.80542C8.79574 11.7289 8.79574 11.8451 8.79574 12C8.79574 12.1646 8.80542 12.3195 8.80542 12.4066H7.93417C7.6728 12.4066 7.47919 12.5905 7.47919 12.8712C7.47919 13.1229 7.6728 13.3262 7.93417 13.3262H8.94095C9.44434 15.4753 11.1965 16.5789 13.3166 16.5789Z"
      fill="currentColor"
    />
  </svg>
);

export const ExclamationFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.737 2.198a4.132 4.132 0 0 1 2.526 0c.874.28 1.517.937 2.1 1.732.578.79 1.21 1.879 1.998 3.236l3.33 5.739c.777 1.338 1.4 2.413 1.793 3.295.396.89.641 1.758.45 2.636a3.997 3.997 0 0 1-1.261 2.138c-.679.6-1.566.821-2.547.924-.972.102-2.23.102-3.795.102H8.669c-1.565 0-2.823 0-3.795-.102-.98-.103-1.868-.324-2.547-.924a3.997 3.997 0 0 1-1.26-2.138c-.192-.878.053-1.747.449-2.636.392-.882 1.016-1.957 1.793-3.295l3.33-5.74C7.427 5.81 8.06 4.72 8.637 3.93c.584-.795 1.226-1.451 2.1-1.732ZM11 14l-.25-7h2.5L13 14h-2Zm2.75 3.995a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
      fill="currentColor"
    />
  </svg>
);

export const ExclamationMarkFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1 12-.5-8h3l-.5 8h-2Zm1 5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
      fill="currentColor"
    />
  </svg>
);

export const ExclamationMarkOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path d="m10.75 6 .25 8h2l.25-8h-2.5Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      fill="currentColor"
    />
    <path
      d="M12 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
      fill="currentColor"
    />
  </svg>
);

export const ExclamationOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="m11 14-.25-6h2.5L13 14h-2ZM13.5 17a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.737 2.198a4.132 4.132 0 0 1 2.526 0c.874.28 1.517.937 2.1 1.732.578.79 1.21 1.879 1.998 3.236l3.33 5.739c.777 1.338 1.4 2.413 1.793 3.295.396.89.641 1.758.45 2.636a3.997 3.997 0 0 1-1.261 2.138c-.679.6-1.566.821-2.547.924-.972.102-2.23.102-3.795.102H8.669c-1.565 0-2.823 0-3.795-.102-.98-.103-1.868-.324-2.547-.924a3.997 3.997 0 0 1-1.26-2.138c-.192-.878.053-1.747.449-2.636.392-.882 1.016-1.957 1.793-3.295l3.33-5.74C7.427 5.81 8.06 4.72 8.637 3.93c.584-.795 1.226-1.451 2.1-1.732Zm1.895 1.906a2.066 2.066 0 0 0-1.264 0c-.246.079-.57.303-1.08 1-.507.692-1.087 1.687-1.912 3.109l-3.269 5.634c-.814 1.403-1.383 2.386-1.727 3.158-.345.774-.377 1.16-.323 1.408.09.413.31.787.63 1.07.192.17.548.332 1.403.422.85.089 2 .09 3.64.09h6.54c1.64 0 2.79-.001 3.64-.09.855-.09 1.21-.253 1.403-.422.32-.283.54-.657.63-1.07.054-.248.022-.634-.323-1.409-.344-.771-.913-1.754-1.727-3.157l-3.27-5.634c-.824-1.422-1.404-2.417-1.911-3.11-.51-.696-.834-.92-1.08-1Z"
      fill="currentColor"
    />
  </svg>
);

export const EyeOffOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.826 18.902 18 22.008h2.5l-14-20H4L6.599 5.72A12.57 12.57 0 0 0 1 11v2a12.56 12.56 0 0 0 14.826 5.902m-1.212-1.731-1.283-1.833a5.5 5.5 0 0 1-6.363-7.562A10.55 10.55 0 0 0 3 11.538L2.75 12l.25.461a10.56 10.56 0 0 0 11.614 4.71m-2.57-3.671L8.726 8.76a3.5 3.5 0 0 0 3.318 4.74"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M23 13a12.56 12.56 0 0 1-4.17 4.48l-1.148-1.64A10.6 10.6 0 0 0 21 12.46l.25-.461-.25-.462a10.55 10.55 0 0 0-3.968-3.762c.3.68.468 1.432.468 2.224a5.48 5.48 0 0 1-1.366 3.628l-1.202-1.717a3.5 3.5 0 0 0-2.93-5.411H12a3.5 3.5 0 0 0-.792.09L9.87 4.681A12.55 12.55 0 0 1 23 11z"
    />
  </svg>
);

export const EyeOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.61 6.246A12.55 12.55 0 0 1 12 4.5 12.55 12.55 0 0 1 23 11v2a12.56 12.56 0 0 1-17.388 4.753A12.56 12.56 0 0 1 1 13v-2a12.55 12.55 0 0 1 4.61-4.754M12 6.5a3.5 3.5 0 1 0-.005 7 3.5 3.5 0 0 0 .008-7zM6.968 7.776a5.5 5.5 0 1 0 10.063 0q.172.093.34.192A10.55 10.55 0 0 1 21 11.538l.25.462-.25.461a10.56 10.56 0 0 1-14.37 3.57A10.56 10.56 0 0 1 3 12.46L2.75 12l.25-.462a10.55 10.55 0 0 1 3.968-3.762"
      clipRule="evenodd"
    />
  </svg>
);

export const Facebook = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M12 2c5.523 0 10 4.477 10 10 0 4.992-3.656 9.129-8.438 9.879V14.89h2.33L16.337 12h-2.773v-1.893c0-.09.006-.179.017-.266.088-.682.519-1.278 1.611-1.278h1.262V6.101s-1.144-.196-2.238-.196c-2.143 0-3.588 1.217-3.76 3.434-.012.148-.018.3-.018.457V12H7.899v2.89h2.54v6.989C5.655 21.129 2 16.992 2 12 2 6.477 6.477 2 12 2Z"
    />
  </svg>
);

export const FacebookColor = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="#1877F2"
      d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.5-3.9 3.77-3.9 1.1 0 2.24.2 2.24.2v2.46H15.2c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.9h-2.33v6.98A10 10 0 0 0 22 12Z"
    />
    <path
      fill="#fff"
      d="m15.9 14.9.44-2.9h-2.78v-1.88c0-.79.39-1.56 1.63-1.56h1.26V6.1s-1.14-.2-2.24-.2c-2.28 0-3.77 1.4-3.77 3.9V12H7.9v2.9h2.54v6.98a10.08 10.08 0 0 0 3.12 0v-6.99h2.33Z"
    />
  </svg>
);

export const Figure = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M11.06 24c.64 0 1.1-.42 1.1-1.19v-7.6c0-.33.17-.53.44-.53s.43.2.43.53v7.6c0 .77.49 1.19 1.12 1.19.64 0 1.12-.42 1.12-1.19V9.98c0-.26.13-.41.35-.41.2 0 .34.15.34.41v5.28c0 .7.42 1.09 1 1.09.6 0 1-.4 1-1.1V10.1c0-3.13-1.76-3.93-5.26-3.93h-1.52c-.68 0-1.02-.11-1.57-.5l-1.3-.92-.24-3.7C8.03.33 7.57-.05 6.97 0c-.6.03-1 .47-.97 1.17l.24 3.67c.05.8.37 1.27.85 1.64l2.37 1.71c.35.25.47.57.47.95v13.67c0 .77.48 1.19 1.13 1.19ZM12.7 5.18a2.37 2.37 0 1 0 0-4.75 2.37 2.37 0 0 0 0 4.75Z"
      fill="currentColor"
    />
  </svg>
);

export const Finish = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M15.7 17.92 8.6 5.64c-.3-.52-.73-.68-1.23-.63-.42.05-.96.26-1.47.56C4.26 6.52 3.6 8 2.04 8.9c-.68.4-1.3.55-1.6.72-.4.23-.57.64-.33 1.05l2.68 4.65c.3.52.74.68 1.24.63.41-.04.95-.26 1.47-.56 1.63-.95 2.29-2.43 3.85-3.34.48-.27.92-.43 1.21-.54l4.06 7.02c.17.3.55.41.85.24.3-.18.4-.56.23-.86Zm-3.21-7.24.72 1.25.23-.41c.3.11.73.27 1.2.54 1.57.9 2.22 2.4 3.87 3.34.5.3 1.05.52 1.46.56.5.05.94-.1 1.24-.63l2.68-4.65c.24-.41.07-.82-.33-1.05-.31-.17-.92-.33-1.6-.72-1.56-.9-2.22-2.4-3.86-3.34-.5-.3-1.05-.5-1.47-.56a1.2 1.2 0 0 0-1.23.63l-2.91 5.04Zm-.97 4.18-.73-1.25-2.49 4.31c-.16.3-.06.68.24.86.3.17.67.07.84-.24l2.13-3.68Z"
      fill="currentColor"
    />
  </svg>
);

export const FlameFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 7C10.4335 5.32538 12 2.5 13 1H14C15.796 2.796 17.6878 5.15748 18.9291 7.31353C20.1651 9.4603 21 11.7607 21 14C21 18.5827 17.5 22 14 22L13.5 21C15 20.5 16 19 16 17C16 14.3603 13.4207 11.4501 12 10C10.5793 11.4501 8 14.5 8 17C8 19 9.5 20.5 10.5 21L10 22C6.5 22 3 18.5827 3 14C3 9.65668 5.47583 6.03223 7 4H8L9.5 7Z"
      fill="currentColor"
    />
  </svg>
);

export const FlameOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.46705 6.42677C10.4005 4.75215 11.8477 2.53641 13 1H14C15.796 2.796 17.6878 5.15748 18.9291 7.31353C20.1651 9.4603 21 11.7607 21 14C21 18.5827 17.5 22 13.5 22L13 21C13.8512 19.936 14.4634 18.0866 14.2615 16.765C14.0827 15.595 13.4207 14.2442 12 12.7941C10.5793 14.2442 9.91732 15.595 9.73853 16.765C9.53658 18.0866 10.1488 19.936 11 21L10.5 22C6.5 22 3 18.5827 3 14C3 9.65668 5.47583 6.03223 7 4H8L9.46705 6.42677ZM19 14C19 12.2393 18.3349 10.2897 17.1959 8.31146C16.2463 6.66219 14.8831 4.98499 13.5 3.5C12.2782 5.25208 10.8223 7.85532 10 9.5H9L7.5 6.5C6.27126 8.33864 5 11.0611 5 14C5 16.4113 6.26848 18.1967 7.93461 19.1921C7.68707 18.3377 7.615 17.4215 7.76147 16.4629C8.16424 13.8272 9.99209 12.0035 11.7888 10.2109C11.8593 10.1405 11.9297 10.0703 12 10C12.0703 10.0703 12.1407 10.1405 12.2112 10.2109C14.0079 12.0035 15.8358 13.8273 16.2385 16.4629C16.385 17.4215 16.3129 18.3377 16.0654 19.1921C17.7315 18.1967 19 16.4113 19 14Z"
      fill="currentColor"
    />
  </svg>
);

export const FlasherFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.002 7c3.543 0 4.749 1.035 5.146 1.616.162.236.208.525.25.808L18.679 18l1.323 1v2c0 1.22-3.556 2-8 2s-8-.78-8-2v-2l1.325-1 1.279-8.577c.042-.282.088-.57.25-.806C7.252 8.037 8.455 7 12.002 7Zm1 3 1.5.25.891 8.628-1.891.122-.5-9Z"
      fill="currentColor"
    />
    <path
      d="m13.002 5-.25-4h-1.503l-.25 4h2.003Zm8.809-.248-2.652 3.005-1.416-1.416 3.005-2.652 1.063 1.063ZM6.256 6.342 3.252 3.69 2.189 4.753 4.84 7.758l1.416-1.416Z"
      fill="currentColor"
    />
  </svg>
);

export const FlasherOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path fill="currentColor" d="m12.5 10.001 1.5.25.892 7.627L13 18z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.676 17 20 18v2c0 1.22-3.556 2-8 2s-8-.78-8-2v-2l1.324-1 1.279-8.575c.042-.283.09-.573.251-.81C7.252 7.036 8.458 6 12 6c3.543 0 4.749 1.035 5.146 1.616.162.236.208.526.25.808zM6 18.996l1.182-.892 1.4-9.384.006-.046C8.855 8.47 9.722 8 12 8s3.145.47 3.412.674l.006.045 1.4 9.385 1.182.892v.277a7 7 0 0 1-.801.24C15.96 19.811 14.129 20 12 20s-3.96-.189-5.199-.487a7 7 0 0 1-.801-.24z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m13 4-.25-4h-1.503l-.25 4zM21.809 3.752l-2.652 3.005-1.416-1.416 3.005-2.652zM6.254 5.342 3.25 2.69 2.187 3.753l2.651 3.005z"
    />
  </svg>
);

export const FolderOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1716 7H16C16.9592 7 17.5785 7.00108 18.0525 7.03342C18.5085 7.06453 18.6821 7.11777 18.7654 7.15224C19.2554 7.35523 19.6448 7.74458 19.8478 8.23463C19.8822 8.31786 19.9355 8.49152 19.9666 8.94752C19.9989 9.42148 20 10.0408 20 11V14C20 14.9592 19.9989 15.5785 19.9666 16.0525C19.9355 16.5085 19.8822 16.6821 19.8478 16.7654C19.6448 17.2554 19.2554 17.6448 18.7654 17.8478C18.6821 17.8822 18.5085 17.9355 18.0525 17.9666C17.5785 17.9989 16.9592 18 16 18H8C7.04075 18 6.42148 17.9989 5.94752 17.9666C5.49152 17.9355 5.31786 17.8822 5.23463 17.8478C4.74458 17.6448 4.35523 17.2554 4.15224 16.7654C4.11777 16.6821 4.06453 16.5085 4.03342 16.0525C4.00108 15.5785 4 14.9592 4 14V9C4 8.04075 4.00108 7.42148 4.03342 6.94752C4.06453 6.49152 4.11777 6.31786 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.31786 5.11777 5.49152 5.06453 5.94752 5.03342C6.42148 5.00108 7.04075 5 8 5H9.17157L11.1716 7ZM10 3H8C6.13623 3 5.20435 3 4.46927 3.30448C3.48915 3.71046 2.71046 4.48915 2.30448 5.46927C2 6.20435 2 7.13623 2 9V14C2 15.8638 2 16.7956 2.30448 17.5307C2.71046 18.5108 3.48915 19.2895 4.46927 19.6955C5.20435 20 6.13623 20 8 20H16C17.8638 20 18.7956 20 19.5307 19.6955C20.5108 19.2895 21.2895 18.5108 21.6955 17.5307C22 16.7956 22 15.8638 22 14V11C22 9.13623 22 8.20435 21.6955 7.46927C21.2895 6.48915 20.5108 5.71046 19.5307 5.30448C18.7956 5 17.8638 5 16 5H12L10 3Z"
      fill="currentColor"
    />
  </svg>
);

export const GiftOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.91395 6.11091C7.14913 6.34609 7.63181 6.66069 8.3939 6.99877C9.20758 7.35973 10.1665 7.76231 11 8C10.7762 7.21326 10.3349 6.21924 9.98463 5.43112C9.64664 4.67069 9.3288 4.18262 9.08552 3.93934C8.49974 3.35355 7.49974 3.35355 6.91395 3.93934C6.32816 4.52513 6.32816 5.52513 6.91395 6.11091ZM17.9113 8.02263C18.128 7.86493 18.3257 7.69916 18.4997 7.52513C19.8666 6.15829 19.8666 3.89196 18.4997 2.52513C17.1329 1.15829 14.8666 1.15829 13.4997 2.52513C12.9029 3.12196 12.4067 4.10486 11.9999 5.17895C11.5929 4.10486 11.0966 3.12196 10.4997 2.52513C9.1329 1.15829 6.86657 1.15829 5.49974 2.52513C4.1329 3.89196 4.1329 6.15829 5.49974 7.52513C5.67378 7.69917 5.87151 7.86494 6.08825 8.02265C5.38719 8.05386 4.89519 8.12806 4.46927 8.30448C3.48915 8.71046 2.71046 9.48915 2.30448 10.4693C2 11.2044 2 12.1362 2 14L4 15V16C4 17.8638 4 18.7957 4.30448 19.5307C4.71046 20.5108 5.48915 21.2895 6.46927 21.6955C7.20435 22 8.13623 22 10 22H14C15.8638 22 16.7956 22 17.5307 21.6955C18.5108 21.2895 19.2895 20.5108 19.6955 19.5307C20 18.7957 20 17.8638 20 16V15L22 14C22 12.1362 22 11.2044 21.6955 10.4693C21.2895 9.48915 20.5108 8.71046 19.5307 8.30448C19.1047 8.12802 18.6126 8.05383 17.9113 8.02263ZM13 8C13.2239 7.21269 13.6645 6.21946 14.0148 5.43112C14.3528 4.67069 14.6707 4.18262 14.9139 3.93934C15.4997 3.35355 16.4997 3.35355 17.0855 3.93934C17.6713 4.52513 17.6713 5.52513 17.0855 6.11091C16.8503 6.34609 16.3677 6.66069 15.6056 6.99877C14.7922 7.35962 13.8331 7.76244 13 8ZM18 13.7639L19.9951 12.7664C19.9907 12.4439 19.9823 12.1785 19.9666 11.9475C19.9355 11.4915 19.8822 11.3179 19.8478 11.2346C19.6448 10.7446 19.2554 10.3552 18.7654 10.1522C18.6821 10.1178 18.5085 10.0645 18.0525 10.0334C17.5785 10.0011 16.9592 10 16 10H13V20H14C14.9592 20 15.5785 19.9989 16.0525 19.9666C16.5085 19.9355 16.6821 19.8822 16.7654 19.8478C17.2554 19.6448 17.6448 19.2554 17.8478 18.7654C17.8822 18.6821 17.9355 18.5085 17.9666 18.0525C17.9989 17.5785 18 16.9592 18 16V13.7639ZM10 20H11V10H8C7.04075 10 6.42148 10.0011 5.94752 10.0334C5.49152 10.0645 5.31786 10.1178 5.23463 10.1522C4.74458 10.3552 4.35523 10.7446 4.15224 11.2346C4.11777 11.3179 4.06453 11.4915 4.03342 11.9475C4.01766 12.1785 4.00933 12.4439 4.00492 12.7664L6 13.7639V16C6 16.9592 6.00108 17.5785 6.03342 18.0525C6.06453 18.5085 6.11777 18.6821 6.15224 18.7654C6.35523 19.2554 6.74458 19.6448 7.23463 19.8478C7.31786 19.8822 7.49152 19.9355 7.94752 19.9666C8.42148 19.9989 9.04075 20 10 20Z"
      fill="currentColor"
    />
  </svg>
);

export const GiftFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.3939 6.99877C7.63181 6.66069 7.14913 6.34609 6.91395 6.11091C6.32816 5.52513 6.32816 4.52513 6.91395 3.93934C7.49974 3.35355 8.49974 3.35355 9.08552 3.93934C9.3288 4.18262 9.64664 4.67069 9.98463 5.43112C10.3085 6.1597 10.5914 7.00105 10.8267 7.82438L10.8356 7.85554L10.7919 7.84305C9.96589 7.60604 9.12256 7.32202 8.3939 6.99877ZM5.49974 7.52513C5.67378 7.69917 5.87151 7.86494 6.08825 8.02265C5.38719 8.05386 4.89519 8.12806 4.46927 8.30448C3.48915 8.71046 2.71046 9.48915 2.30448 10.4693C2 11.2044 2 12.1362 2 14L4 15V16C4 17.8638 4 18.7957 4.30448 19.5307C4.71046 20.5108 5.48915 21.2895 6.46927 21.6955C7.20435 22 8.13623 22 10 22H11V10H13V22H14C15.8638 22 16.7956 22 17.5307 21.6955C18.5108 21.2895 19.2895 20.5108 19.6955 19.5307C20 18.7957 20 17.8638 20 16V15L22 14C22 12.1362 22 11.2044 21.6955 10.4693C21.2895 9.48915 20.5108 8.71046 19.5307 8.30448C19.1047 8.12802 18.6126 8.05383 17.9113 8.02263C18.128 7.86493 18.3257 7.69916 18.4997 7.52513C19.8666 6.15829 19.8666 3.89196 18.4997 2.52513C17.1329 1.15829 14.8666 1.15829 13.4997 2.52513C12.9029 3.12196 12.4067 4.10486 11.9999 5.17895C11.5929 4.10486 11.0966 3.12196 10.4997 2.52513C9.1329 1.15829 6.86657 1.15829 5.49974 2.52513C4.1329 3.89196 4.1329 6.15829 5.49974 7.52513ZM15.6056 6.99877C16.3677 6.66069 16.8503 6.34609 17.0855 6.11091C17.6713 5.52513 17.6713 4.52513 17.0855 3.93934C16.4997 3.35355 15.4997 3.35355 14.9139 3.93934C14.6707 4.18262 14.3528 4.67069 14.0148 5.43112C13.691 6.1597 13.408 7.00105 13.1728 7.82438L13.1639 7.85554L13.2076 7.84305C14.0336 7.60604 14.8769 7.32202 15.6056 6.99877Z"
      fill="currentColor"
    />
  </svg>
);

export const GoBackward = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M14 1.7 12.8.3 8 5l4.7 4.7L14 8.3 11.8 6h.2a7 7 0 1 1-5 2L5.7 6.7A9 9 0 0 0 12 22a9 9 0 1 0-.2-18L14 1.7Z"
      fill="currentColor"
    />
  </svg>
);

export const GoForward = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M10 1.7 11.2.3 16 5l-4.7 4.7L10 8.3 12.2 6H12a7 7 0 1 0 5 2l1.4-1.4A9 9 0 0 1 12 22a9 9 0 1 1 .2-18L10 1.7Z"
      fill="currentColor"
    />
  </svg>
);

export const GoogleAds = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M20.597 15.158 14.617 4.92A3.05 3.05 0 0 0 10.5 3.845a2.922 2.922 0 0 0-1.329 1.517c-.298.793-.234 1.71.236 2.528l5.98 10.24a3.05 3.05 0 0 0 4.116 1.074c1.415-.822 1.93-2.655 1.093-4.045v-.001ZM8.642 18.067c.23-.414.362-.89.362-1.395 0-1.617-1.344-2.928-3.002-2.928-1.15 0-2.148.63-2.652 1.556-.224.41-.35.876-.35 1.372C3 18.289 4.344 19.6 6.002 19.6a3.017 3.017 0 0 0 2.64-1.533Z"
    />
    <path
      fill="currentColor"
      d="m9.927 15.898 1.5-2.569L8.54 8.39a4.13 4.13 0 0 1-.465-1.212L4.7 12.958c.41-.139.848-.213 1.303-.213 1.922 0 3.557 1.34 3.925 3.153Z"
    />
  </svg>
);

export const GoogleAdsColor = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="#FBBC04"
      d="M3.41 15.16 9.4 4.92c.76.45 4.6 2.57 5.21 2.97L8.62 18.13c-.65.86-6.03-1.66-5.2-2.97Z"
    />
    <path
      fill="#4285F4"
      d="M20.6 15.16 14.62 4.92a3.05 3.05 0 0 0-4.12-1.08A2.89 2.89 0 0 0 9.4 7.9l5.99 10.24a3.05 3.05 0 0 0 4.11 1.07 2.96 2.96 0 0 0 1.1-4.04Z"
    />
    <path
      fill="#34A853"
      d="M6 19.6c1.66 0 3-1.31 3-2.93a2.97 2.97 0 0 0-3-2.93c-1.66 0-3 1.32-3 2.93a2.97 2.97 0 0 0 3 2.93Z"
    />
  </svg>
);

export const Grid = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.01 5.997C15 6.221 15 6.517 15 7c0 .483 0 .779.01 1.003.01.213.026.263.024.256a1 1 0 0 0 .707.707c.007.002.069.015.256.023C16.221 9 16.517 9 17 9c.483 0 .779 0 1.003-.01.213-.01.263-.026.256-.024a1 1 0 0 0 .707-.707c.002-.007.015-.069.023-.256C19 7.779 19 7.483 19 7c0-.483 0-.779-.01-1.003-.01-.213-.026-.263-.024-.256a1 1 0 0 0-.707-.707 1.667 1.667 0 0 0-.256-.023C17.779 5 17.483 5 17 5c-.483 0-.779 0-1.003.01-.213.01-.263.026-.256.024a1 1 0 0 0-.707.707c.002-.007-.014.043-.023.256zM17.408 11c.667-.002 1.048-.016 1.37-.102a3 3 0 0 0 2.12-2.122C21 8.395 21 7.93 21 7s0-1.395-.102-1.776a3 3 0 0 0-2.122-2.122C18.395 3 17.93 3 17 3s-1.395 0-1.777.102a3 3 0 0 0-2.12 2.122c-.087.32-.1.702-.103 1.37v.812c.002.668.016 1.05.102 1.37a3 3 0 0 0 2.121 2.122c.322.086.703.1 1.37.102h.814zM11 7.406v-.812c-.002-.668-.016-1.05-.102-1.37a3 3 0 0 0-2.122-2.122C8.395 3 7.93 3 7 3s-1.395 0-1.776.102a3 3 0 0 0-2.122 2.122C3 5.605 3 6.07 3 7s0 1.395.102 1.776a3 3 0 0 0 2.122 2.122c.32.086.702.1 1.37.102h.812c.668-.002 1.05-.016 1.37-.102a3 3 0 0 0 2.122-2.122c.086-.32.1-.702.102-1.37zM7.406 13h-.812c-.668.002-1.05.016-1.37.102a3 3 0 0 0-2.122 2.121C3 15.605 3 16.07 3 17c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C5.605 21 6.07 21 7 21s1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122c.086-.32.1-.702.102-1.37v-.813c-.002-.667-.016-1.048-.102-1.37a3 3 0 0 0-2.122-2.12c-.32-.087-.702-.1-1.37-.103zM13 16.594v.812c.002.668.016 1.05.102 1.37a3 3 0 0 0 2.121 2.122C15.605 21 16.07 21 17 21c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.395 21 17.93 21 17s0-1.395-.102-1.777a3 3 0 0 0-2.122-2.12c-.32-.087-.702-.1-1.37-.103h-.812c-.668.002-1.05.016-1.37.102a3 3 0 0 0-2.122 2.121c-.086.322-.1.703-.102 1.37zm2.01-.597c-.01.224-.01.52-.01 1.003 0 .483 0 .779.01 1.003.01.187.022.249.024.256a1 1 0 0 0 .707.707c-.007-.002.043.014.256.023.224.01.52.011 1.003.011.483 0 .779 0 1.003-.01.213-.01.263-.026.256-.024a1 1 0 0 0 .707-.707c-.002.007.014-.043.023-.256.01-.224.011-.52.011-1.003 0-.483 0-.779-.01-1.003-.01-.213-.026-.263-.024-.256a1 1 0 0 0-.707-.707 1.67 1.67 0 0 0-.256-.023C17.779 15 17.483 15 17 15c-.483 0-.779 0-1.003.01-.213.01-.263.026-.256.024a1 1 0 0 0-.707.707c.002-.007-.014.043-.023.256zm-10 0C5 16.221 5 16.517 5 17c0 .483 0 .779.01 1.003.01.213.026.263.024.256a1 1 0 0 0 .707.707c-.007-.002.043.014.256.023C6.221 19 6.517 19 7 19c.483 0 .779 0 1.003-.01.187-.01.249-.022.256-.024a1 1 0 0 0 .707-.707c-.002.007.014-.043.023-.256C9 17.779 9 17.483 9 17c0-.483 0-.779-.01-1.003a1.666 1.666 0 0 0-.024-.256 1 1 0 0 0-.707-.707c.007.002-.043-.014-.256-.023C7.779 15 7.483 15 7 15c-.483 0-.779 0-1.003.01a1.67 1.67 0 0 0-.256.024 1 1 0 0 0-.707.707m-.023.256c.008-.187.021-.249.023-.256l-.023.256zm0-10C5 6.221 5 6.517 5 7c0 .483 0 .779.01 1.003.01.213.026.263.024.256a1 1 0 0 0 .707.707c-.007-.002.043.014.256.023C6.221 9 6.517 9 7 9c.483 0 .779 0 1.003-.01.213-.01.263-.026.256-.024a1 1 0 0 0 .707-.707c-.002.007.014-.043.023-.256C9 7.779 9 7.483 9 7c0-.483 0-.779-.01-1.003a1.67 1.67 0 0 0-.024-.256 1 1 0 0 0-.707-.707c.007.002-.043-.014-.256-.023C7.779 5 7.483 5 7 5c-.483 0-.779 0-1.003.01-.213.01-.263.026-.256.024a1 1 0 0 0-.707.707c.002-.007-.014.043-.023.256z"
      fill="currentColor"
    />
  </svg>
);

export const GridFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.102 5.224C13 5.605 13 6.07 13 7s0 1.395.102 1.776a3 3 0 0 0 2.121 2.122C15.605 11 16.07 11 17 11c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 8.395 21 7.93 21 7s0-1.395-.102-1.776a3 3 0 0 0-2.122-2.122C18.395 3 17.93 3 17 3s-1.395 0-1.777.102a3 3 0 0 0-2.12 2.122Zm0 10C13 15.604 13 16.07 13 17s0 1.395.102 1.776a3 3 0 0 0 2.121 2.122C15.605 21 16.07 21 17 21c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.395 21 17.93 21 17s0-1.395-.102-1.777a3 3 0 0 0-2.122-2.12C18.395 13 17.93 13 17 13s-1.395 0-1.777.102a3 3 0 0 0-2.12 2.121ZM3 17c0-.93 0-1.395.102-1.777a3 3 0 0 1 2.122-2.12C5.605 13 6.07 13 7 13s1.395 0 1.776.102a3 3 0 0 1 2.122 2.121C11 15.605 11 16.07 11 17c0 .93 0 1.395-.102 1.776a3 3 0 0 1-2.122 2.122C8.395 21 7.93 21 7 21s-1.395 0-1.776-.102a3 3 0 0 1-2.122-2.122C3 18.395 3 17.93 3 17Zm.102-11.776C3 5.605 3 6.07 3 7s0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C5.605 11 6.07 11 7 11s1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C11 8.395 11 7.93 11 7s0-1.395-.102-1.776a3 3 0 0 0-2.122-2.122C8.395 3 7.93 3 7 3s-1.395 0-1.776.102a3 3 0 0 0-2.122 2.122Z"
      clipRule="evenodd"
    />
  </svg>
);

export const GridFlex = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7C3 4.79086 4.79086 3 7 3H11V11H3V7ZM11 21H7C4.79086 21 3 19.2091 3 17V13H11V21ZM17 3H13V21H17C19.2091 21 21 19.2091 21 17V7C21 4.79086 19.2091 3 17 3Z"
      fill="currentColor"
    />
  </svg>
);

export const HeadphonesFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="m5.984 19.53.006.005.027-.03 3.043-2.468c.408-.712-.2-2.688-.95-4.37-.75-1.681-1.872-3.22-2.65-3.382l-1.74.341a8.615 8.615 0 0 1 16.57.001l-1.749-.342c-.779.162-1.9 1.7-2.65 3.382-.75 1.682-1.359 3.658-.95 4.37l2.25 1.825a8.571 8.571 0 0 1-4.19 1.68l-1 1.928c3.57 0 6.723-1.784 8.616-4.51l.007.005a10.46 10.46 0 0 0 1.559-8.49A10.483 10.483 0 0 0 12 1.5c-5.55 0-10.094 4.313-10.46 9.772h.003a10.485 10.485 0 0 0 3.78 8.803l.66-.545Z"
    />
  </svg>
);

export const HeadphonesOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.907 5.377a8.575 8.575 0 0 1 3.195 4.15l-1.56-.42c-.308-.082-.802-.138-1.283.134-.606.344-1.073.952-1.42 1.553a9.945 9.945 0 0 0-.877 2.102c-.22.742-.371 1.52-.423 2.239-.05.694-.017 1.434.22 2.038.144.37.4.612.601.759l1.864 1.366a8.571 8.571 0 0 1-4.228 1.71l-1 1.927c3.57 0 6.724-1.785 8.617-4.51l.007.004a10.463 10.463 0 0 0 1.481-8.785 10.416 10.416 0 0 0-2.3-4.196 10.459 10.459 0 0 0-7.805-3.483c-5.55 0-10.094 4.313-10.461 9.771h.004a10.485 10.485 0 0 0 3.78 8.803l.926-.762 2.426-1.862c.187-.143.426-.375.565-.725.241-.605.276-1.348.226-2.042-.052-.72-.204-1.5-.425-2.243a9.972 9.972 0 0 0-.88-2.108c-.348-.602-.816-1.211-1.424-1.556-.48-.272-.975-.216-1.283-.133l-1.551.417a8.615 8.615 0 0 1 13.008-4.148Zm-13.491 6.35a8.635 8.635 0 0 0 1.936 6.214l2.055-1.577c.06-.21.096-.569.06-1.072a8.795 8.795 0 0 0-.347-1.818 7.992 7.992 0 0 0-.696-1.677c-.216-.374-.412-.605-.558-.73l-2.45.66Zm15.264 6.158a8.58 8.58 0 0 0 1.901-6.158l-2.454-.66c-.146.125-.34.354-.554.726a7.957 7.957 0 0 0-.693 1.672 8.82 8.82 0 0 0-.346 1.815c-.037.5-.002.86.058 1.075l2.088 1.53Z"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartFillL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.455 3a4.929 4.929 0 0 1 2.873 1.05c.82.644 1.405 1.452 1.672 2.45.267-.998.853-1.806 1.671-2.45A4.93 4.93 0 0 1 16.545 3C19.91 3 22 5 22 8.984c0 6.016-7.955 11.17-9.546 12.003h-.909C9.955 20.155 2 15 2 9c0-4 2.09-6 5.455-6Z"
      fill="currentColor"
    />
  </svg>
);

export const HeartFillM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.875 7.358c.5-.993 1.716-2.358 3.5-2.358.977 0 2.082.3 2.951 1.1.885.817 1.424 2.059 1.424 3.74 0 2.364-1.613 4.444-3.213 5.937-1.633 1.523-3.456 2.624-4.27 3.029l-.392.194-.391-.194c-.777-.386-2.608-1.357-4.257-2.83C5.595 14.518 4 12.439 4 9.839c0-1.697.578-2.936 1.474-3.745C6.349 5.304 7.446 5 8.375 5c1.784 0 3 1.365 3.5 2.358Z"
      fill="currentColor"
    />
  </svg>
);

export const HeartOutlineL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.605 4.48C4.65 3.437 6.053 3 7.5 3c2.103 0 3.583 1.123 4.5 2.667C12.912 4.125 14.38 3 16.5 3c1.447 0 2.851.437 3.895 1.48C21.442 5.527 22 7.06 22 9c0 2.774-1.678 5.354-3.59 7.363-1.938 2.035-4.279 3.77-5.95 4.637h-.92c-1.671-.867-4.012-2.602-5.95-4.637C3.679 14.354 2 11.774 2 9c0-1.94.558-3.473 1.605-4.52ZM5.02 5.895C4.442 6.473 4 7.44 4 9c0 1.996 1.242 4.096 3.04 5.984C8.636 16.663 10.547 18.178 12 19c1.452-.822 3.363-2.337 4.96-4.016C18.759 13.096 20 10.996 20 9c0-1.56-.442-2.527-1.02-3.105C18.4 5.313 17.553 5 16.5 5c-1.823 0-3 1.5-3.5 3.5l-1.962-.004C10.5 6.5 9.308 5 7.5 5c-1.053 0-1.899.313-2.48.895Z"
      fill="currentColor"
    />
  </svg>
);

export const HeartOutlineM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.651 7.397c-.48.436-.901 1.187-.901 2.478 0 1.88 1.155 3.537 2.648 4.88 1.248 1.124 2.634 1.938 3.47 2.382a19.06 19.06 0 0 0 3.47-2.556C16.863 13.148 18 11.493 18 9.875c0-1.307-.404-2.056-.865-2.484-.477-.443-1.122-.641-1.76-.641-1.08 0-1.71.6-2.115 1.31a4.63 4.63 0 0 0-.419 1.009c-.04.14-.216.806-.216.806h-1.5s-.176-.667-.216-.806a4.63 4.63 0 0 0-.419-1.01C10.085 7.35 9.455 6.75 8.375 6.75c-.57 0-1.224.193-1.724.647Zm5.224-.429C12.498 5.992 13.591 5 15.375 5c.977 0 2.082.302 2.951 1.109.885.822 1.424 2.073 1.424 3.766 0 2.382-1.613 4.477-3.213 5.981-1.633 1.535-3.456 2.644-4.27 3.052l-.392.195-.391-.195c-.777-.389-2.608-1.367-4.257-2.851C5.595 14.588 4 12.494 4 9.875c0-1.71.578-2.958 1.474-3.772C6.349 5.307 7.446 5 8.375 5c1.784 0 2.877.992 3.5 1.968Z"
      fill="currentColor"
    />
  </svg>
);

export const Hello = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M10.991 4.777l.006-1.77a1 1 0 10-2-.007L8.98 8.561v5.235a1.15 1.15 0 01-2.012.761s-2.614-2.97-3.096-3.295c-.483-.325-1.018-.325-1.459.05a1.382 1.382 0 00-.155 1.949l4.575 5.369.012.014c1.46 1.614 2.948 2.968 5.143 2.968 2.547 0 4.86-1.875 5.709-4.136l3.295-9.569a1 1 0 10-1.89-.651l-1.255 3.626-.26.789a.454.454 0 01-.868-.266l.816-3.059.772-3.009a1 1 0 00-1.937-.497l-.182.708-1.258 4.86c-.086.342-.47.524-.737.444-.301-.09-.432-.39-.378-.7l.527-3.359.606-3.63a1 1 0 00-1.973-.328l-.267 1.603-.84 5.248c-.03.188-.152.363-.356.385-.248.027-.441-.156-.437-.465l-.084-4.83z"
      fill="currentColor"
    />
  </svg>
);

export const HelmetOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.166 15.3651C20.9776 15.8164 20.6017 16.1603 20.1493 16.3459L6.47987 21.9526C6.2966 22.0278 6.08775 22.0143 5.92149 21.9066C1.93234 19.3229 0.409819 12.8882 4.10981 7.11192C8.22092 0.693772 14.5496 1.38746 17.7409 3.45445C20.5812 5.29405 23.4642 9.85865 21.166 15.3651ZM4.72154 17.4594C5.14908 18.4072 5.74318 19.209 6.44341 19.8059L19.3553 14.5099C21.1328 10.1355 18.8658 6.56591 16.6537 5.13311C15.4343 4.34336 13.5409 3.78603 11.564 4.07957C9.66553 4.36147 7.55156 5.44673 5.79394 8.19067C5.6212 8.46035 5.46215 8.7303 5.31628 9H12C13.1046 9 14 9.89543 14 11V11.6562C14 12.8752 13.2624 13.973 12.1338 14.4337L4.72154 17.4594ZM4.13237 15.5397L11.3779 12.582C11.7541 12.4285 12 12.0625 12 11.6562V11H4.46406C3.95732 12.6075 3.88592 14.1589 4.13237 15.5397Z"
      fill="currentColor"
    />
  </svg>
);

export const History = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8a1 1 0 0 1 1 1v3.465l2 1.367a1 1 0 0 1-1.11 1.664l-2.445-1.664A1 1 0 0 1 11 13V9a1 1 0 0 1 1-1Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5a7 7 0 0 0-7 7H3a9 9 0 1 1 2.464 6.188l1.453-1.376A7 7 0 1 0 12 5Z"
      fill="currentColor"
    />
    <path d="M8 11H0l4 5 4-5Z" fill="currentColor" />
  </svg>
);

export const HumanDropOff = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.213 4.616c-.86.625-2.358.03-2.983-.83a1.925 1.925 0 1 1 3.114-2.263c.625.86.729 2.468-.131 3.093ZM13 6h-2.5l-2 3.5-1.184 3.551a1 1 0 0 0 .632 1.265l.552.184L10 11l.927-1.159.349 3.142-1.943 4.185-3.2 1.067A1 1 0 0 0 5.5 19.5l.316.948 4.851-1.617 2.149-3.114L14 17.712V22a1 1 0 0 0 1 1h1v-5.712l-1-2.395v-3.339l3.18-.278a1 1 0 0 0 .908-1.083l-.065-.744L15 9.562V8a2 2 0 0 0-2-2Z"
      clipRule="evenodd"
    />
  </svg>
);

export const HumanSeat = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M6.86 6.87c-.5.94-2.1 1.07-3.05.57a1.92 1.92 0 1 1 1.8-3.4c.94.5 1.74 1.9 1.25 2.83Zm-.2 1.2-2.34.88 3.28 6.48a2 2 0 0 0 .26.4 2 2 0 0 0 1.93.9l6.71-.83 3.2 4.47a1 1 0 0 0 1.42.22l.79-.59-4.31-5.6a1 1 0 0 0-.8-.4h-5.79L9.24 9.25a2 2 0 0 0-2.58-1.17Zm.29 7.95a3 3 0 0 0 3.07 1.61l5.31-.71 1.27 1.84-6.31.85a5 5 0 0 1-5.12-2.67L1.11 9h2.25l3.59 7.02Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const HumanSurgeIndicator = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.91 6.533c0 1.4-1.134 3.192-2.534 3.192-1.399 0-2.533-1.792-2.533-3.192a2.534 2.534 0 0 1 5.067 0Zm-.592 4.221-4.2-.229a3.002 3.002 0 0 0-.903.088l-.555.141C9.073 10.891 6.602 11.998 6 12l-5 .347.005 1.076c.01.048.018.098.026.15.07.424.152.927 1.13.927h4.032L9 14l2.16 6h6.38l-1.28-4.977 3.84 5.07.64-.38c.384-.507.512-1.14.128-1.647l-4.216-6.867c-.3-.396-.83-.417-1.138-.429a1.246 1.246 0 0 1-.196-.016Z"
      clipRule="evenodd"
    />
  </svg>
);

export const HumanSurgeIndicatorPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Zm8.46 7.923a2.46 2.46 0 1 1 .002-4.922 2.46 2.46 0 0 1-.002 4.922Zm-1.689.108c-.986-.37-1.85-.985-2.467-1.846l-1.321-1.94c-.278 1.02-.613 1.408-1.6 1.717L7.07 11.77c1.11 1.723 1.973 3.692 2.344 5.785L10.4 21h6.168l-1.233-4.923 3.7 4.923.617-.37c.37-.491.494-1.107.124-1.6l-3.825-5.907c-.277-.37-.868-.546-1.224-.652a1.84 1.84 0 0 1-.256-.086l-3.7-1.354Z"
      fill="currentColor"
    />
  </svg>
);

export const HumanUser = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M6.87 11.945c-.302-.743-.357-1.022-.44-1.64-.081-.618.171-.92.364-.92.174 0 .47.287.575.387.105.102.235-.018.235-.018-.072-.395-.04-1.05-.184-1.706-.293-1.336-.573-2.272-.17-3.093.586-1.195 1.585-.807 1.585-.807s-.221-.571.779-.888c1.406-.444 3.097-.28 4.251.191 1.609.657 1.996.411 1.996.411s.665.85.36 3.485c-.134 1.166-.217 1.781-.217 2.194 0 .06.063.06.127.06.128-.118.26-.212.448-.178.387.072.47.998-.106 2.363-.32.65-.45 1.085-.764 1.047-.314-.039-.357-.197-.357-.138-.124.63-.244.913-.372 1.267-.64 1.532-2.014 2.633-2.622 2.77-.435.099-.69.133-1.151 0-.822-.236-2.275-1.613-2.686-2.829-.13-.382-.329-1.159-.329-1.159s-.09.147-.31.216c-.223.07-.71-.271-1.012-1.015zM12 22a9.98 9.98 0 007.715-3.637L17 17s-2 2-5 2-5-2-5-2l-2.715 1.363A9.98 9.98 0 0012 22z"
      fill="currentColor"
    />
  </svg>
);

export const InfoFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 5.5c0 .28.22.5.5.5h.5v1h-4v-1h.5a.5.5 0 0 0 .5-.5V11a.5.5 0 0 0-.5-.5H10v-1h2.5c.28 0 .5.22.5.5v4.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export const InfoOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 5.5a.5.5 0 0 0 .5.5h.5v1h-4v-1h.5a.5.5 0 0 0 .5-.5V11a.5.5 0 0 0-.5-.5H10v-1h2.5a.5.5 0 0 1 .5.5z"
      clipRule="evenodd"
    />
  </svg>
);

export const Italic = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M4.38 13.9H9.6c.2 0 .36-.05.48-.16a.6.6 0 0 0 .2-.46.57.57 0 0 0-.2-.45.68.68 0 0 0-.47-.17H7.76l2-9.32h1.86c.19 0 .35-.06.47-.17a.6.6 0 0 0 .19-.46.57.57 0 0 0-.18-.45.67.67 0 0 0-.48-.16H6.38c-.2 0-.35.05-.47.16a.57.57 0 0 0-.18.45c0 .2.06.34.18.46a.7.7 0 0 0 .48.17h1.85l-2 9.32H4.37c-.2 0-.35.06-.47.17a.57.57 0 0 0-.19.45c0 .19.06.34.19.46a.7.7 0 0 0 .47.16Z"
    />
  </svg>
);

export const Layers = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M21.5 15.266c-1.424.751-2.854 1.504-4.283 2.254-1.587.834-3.173 1.666-4.75 2.499l-.457.242-.462-.235c-1.588-.806-3.17-1.611-4.75-2.416L2.5 15.424V13.18l5.205 2.647c1.427.727 2.855 1.453 4.287 2.18 1.427-.752 2.862-1.506 4.295-2.259 1.587-.833 3.173-1.665 4.75-2.498l.463-.246v2.26z"
      fill="currentColor"
    />
    <path
      d="M12.467 4.25c1.576.832 3.163 1.667 4.75 2.502 1.43.752 2.86 1.504 4.283 2.255v2.263l-4.284 2.253c-1.587.832-3.173 1.665-4.75 2.497l-.456.24L2.5 11.43v-2.26l4.273-2.325c1.58-.862 3.162-1.723 4.75-2.587l.47-.257.474.25zM7.73 8.6l-3.08 1.677 3.055 1.553 4.286 2.179c1.428-.753 2.863-1.505 4.296-2.257 1.024-.537 2.047-1.077 3.069-1.614l-3.07-1.616c-1.428-.75-2.857-1.503-4.28-2.253L7.73 8.599z"
      fill="currentColor"
    />
  </svg>
);

export const LetterFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m12 12.5 7.967-4.552c-.031-.456-.085-.63-.12-.713a2 2 0 0 0-1.082-1.083c-.083-.034-.256-.087-.713-.119C17.578 6.001 16.96 6 16 6H8c-.96 0-1.579.001-2.052.033-.456.032-.63.085-.713.12a2 2 0 0 0-1.083 1.082c-.034.083-.087.257-.119.713L12 12.5ZM22 10v4c0 1.864 0 2.796-.305 3.53a4 4 0 0 1-2.164 2.165C18.796 20 17.864 20 16 20H8c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.164C2 16.796 2 15.864 2 14v-4c0-1.864 0-2.796.304-3.53A4 4 0 0 1 4.47 4.303C5.204 4 6.136 4 8 4h8c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165C22 7.204 22 8.136 22 10Z"
      clipRule="evenodd"
    />
  </svg>
);

export const LetterOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 10c0-1.864 0-2.796.304-3.53A4 4 0 0 1 4.47 4.303C5.204 4 6.136 4 8 4h8c1.864 0 2.796 0 3.53.304a4
      4 0 0 1 2.165 2.165C22 7.204 22 8.136 22 10v4c0 1.864 0 2.796-.305 3.53a4 4 0 0 1-2.164 2.165C18.796 20
      17.864 20 16 20H8c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.164C2 16.796 2 15.864 2 14v-4Zm2-.693V14c0 .96.001
      1.579.033 2.052.032.457.085.63.12.713a2 2 0 0 0 1.082 1.083c.083.034.257.088.713.119C6.42 17.999 7.04 18 8
      18h8c.96 0 1.578-.001 2.052-.033.457-.031.63-.085.713-.12a2 2 0 0 0 1.083-1.082c.034-.083.088-.256.119-.713C19.999
      15.58 20 14.96 20 14V9.32l-7.002 4.03A2 2 0 0 1 11 13.347l-7-4.04Zm15.8-2.179a2 2 0 0 0-1.035-.976c-.083-.034-.256-.087-.713-.119C17.578
      6.001 16.96 6 16 6H8c-.96 0-1.579.001-2.052.033-.456.032-.63.085-.713.12a2 2 0 0 0-1.03.963l7.795 4.5 7.8-4.488Z"
      clipRule="evenodd"
    />
  </svg>
);

export const LicensePlateFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H3Zm2.65 6.932c.172-.12.339-.239.5-.358.143-.11.266-.229.368-.36l.002-.002c.095-.115.148-.274.148-.485a.81.81 0 0 0-.08-.353l-.003-.005a.558.558 0 0 0-.27-.274c-.134-.073-.34-.114-.627-.114-.447 0-.823.101-1.134.3l-.154.097v-1.23l.051-.03c.386-.214.878-.318 1.47-.318.729 0 1.294.171 1.68.53.388.351.58.814.58 1.379 0 .39-.076.715-.24.964a2.362 2.362 0 0 1-.545.591c-.171.135-.343.251-.515.35-.156.092-.288.19-.395.292a.4.4 0 0 0-.131.305v.298h-1.37v-.28c0-.33.062-.602.196-.81a1.71 1.71 0 0 1 .468-.487Zm-.881 2.755c0 .244.093.458.272.638l.002.001c.18.174.397.262.645.262.259 0 .48-.087.656-.263a.877.877 0 0 0 .272-.638.848.848 0 0 0-.273-.63.894.894 0 0 0-.655-.262.902.902 0 0 0-.645.262.848.848 0 0 0-.274.63Zm6.457-2.755c.173-.12.34-.239.501-.358.143-.11.266-.229.368-.36l.002-.002c.096-.115.148-.274.148-.485a.811.811 0 0 0-.08-.353l-.002-.005a.558.558 0 0 0-.27-.274c-.135-.073-.34-.114-.628-.114-.446 0-.823.101-1.134.3l-.154.097v-1.23l.051-.03c.386-.214.878-.318 1.471-.318.728 0 1.293.171 1.679.53.388.351.581.814.581 1.379 0 .39-.077.715-.241.964a2.361 2.361 0 0 1-.545.591c-.17.135-.343.251-.515.35-.156.092-.288.19-.395.292a.4.4 0 0 0-.13.305v.298h-1.37v-.28c0-.33.061-.602.195-.81a1.71 1.71 0 0 1 .468-.487Zm-.608 3.393a.877.877 0 0 1-.272-.638c0-.244.093-.456.274-.63a.902.902 0 0 1 .645-.262c.258 0 .48.087.655.263.18.174.273.385.273.629a.877.877 0 0 1-.272.638.894.894 0 0 1-.656.263.902.902 0 0 1-.645-.262l-.002-.001Zm6.186-3.393c.173-.12.34-.239.5-.358.144-.11.267-.229.369-.36l.002-.002c.095-.115.148-.274.148-.485a.81.81 0 0 0-.08-.353l-.003-.005a.557.557 0 0 0-.27-.274c-.134-.073-.34-.114-.627-.114-.447 0-.823.101-1.135.3l-.153.097v-1.23l.051-.03c.386-.214.878-.318 1.47-.318.728 0 1.294.171 1.68.53.388.351.58.814.58 1.379 0 .39-.077.715-.24.964a2.36 2.36 0 0 1-.545.591c-.171.135-.343.251-.515.35-.157.092-.288.19-.396.292a.4.4 0 0 0-.13.305v.298h-1.37v-.28c0-.33.062-.602.196-.81a1.71 1.71 0 0 1 .468-.487Zm-.608 3.393a.877.877 0 0 1-.272-.638c0-.244.093-.456.273-.63a.902.902 0 0 1 .646-.262c.258 0 .479.087.655.263.18.174.273.385.273.629a.877.877 0 0 1-.273.638.894.894 0 0 1-.655.263.902.902 0 0 1-.646-.262l-.001-.001Z"
      clipRule="evenodd"
    />
  </svg>
);

export const LicensePlateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M5.65 11.932c.172-.12.339-.239.5-.358.143-.11.266-.229.368-.36l.002-.002c.095-.115.148-.274.148-.485a.81.81 0 0 0-.08-.353l-.003-.005a.558.558 0 0 0-.27-.274c-.134-.073-.34-.114-.627-.114-.447 0-.823.101-1.134.3l-.154.097v-1.23l.051-.03c.386-.214.878-.318 1.47-.318.729 0 1.294.171 1.68.53.388.351.58.814.58 1.379 0 .39-.076.715-.24.964a2.362 2.362 0 0 1-.545.591c-.171.135-.343.251-.515.35-.156.092-.288.19-.395.292a.4.4 0 0 0-.131.305v.298h-1.37v-.28c0-.33.062-.602.196-.81a1.71 1.71 0 0 1 .468-.487ZM4.769 14.687c0 .244.093.458.272.638l.002.001c.18.174.397.262.645.262.259 0 .48-.087.656-.263a.877.877 0 0 0 .272-.638.848.848 0 0 0-.273-.63.894.894 0 0 0-.655-.262.902.902 0 0 0-.645.262.848.848 0 0 0-.274.63ZM11.226 11.932c.173-.12.34-.239.501-.358.143-.11.266-.229.368-.36l.002-.002c.096-.115.148-.274.148-.485a.811.811 0 0 0-.08-.353l-.002-.005a.558.558 0 0 0-.27-.274c-.135-.073-.34-.114-.628-.114-.446 0-.823.101-1.134.3l-.154.097v-1.23l.051-.03c.386-.214.878-.318 1.471-.318.728 0 1.293.171 1.679.53.388.351.581.814.581 1.379 0 .39-.077.715-.241.964a2.361 2.361 0 0 1-.545.591c-.17.135-.343.251-.515.35-.156.092-.288.19-.395.292a.4.4 0 0 0-.13.305v.298h-1.37v-.28c0-.33.061-.602.195-.81a1.71 1.71 0 0 1 .468-.487ZM10.618 15.325a.877.877 0 0 1-.272-.638c0-.244.093-.456.274-.63a.902.902 0 0 1 .645-.262c.258 0 .48.087.655.263.18.174.273.385.273.629a.877.877 0 0 1-.272.638.894.894 0 0 1-.656.263.902.902 0 0 1-.645-.262l-.002-.001ZM16.804 11.932c.173-.12.34-.239.5-.358.144-.11.267-.229.369-.36l.002-.002c.095-.115.148-.274.148-.485a.81.81 0 0 0-.08-.353l-.003-.005a.557.557 0 0 0-.27-.274c-.134-.073-.34-.114-.627-.114-.447 0-.823.101-1.135.3l-.153.097v-1.23l.051-.03c.386-.214.878-.318 1.47-.318.728 0 1.294.171 1.68.53.388.351.58.814.58 1.379 0 .39-.077.715-.24.964a2.36 2.36 0 0 1-.545.591c-.171.135-.343.251-.515.35-.157.092-.288.19-.396.292a.4.4 0 0 0-.13.305v.298h-1.37v-.28c0-.33.062-.602.196-.81a1.71 1.71 0 0 1 .468-.487ZM16.196 15.325a.877.877 0 0 1-.272-.638c0-.244.093-.456.273-.63a.902.902 0 0 1 .646-.262c.258 0 .479.087.655.263.18.174.273.385.273.629a.877.877 0 0 1-.273.638.894.894 0 0 1-.655.263.902.902 0 0 1-.646-.262l-.001-.001Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 8a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8Zm3-1h18a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);

export const LikeFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 9h4.5c1.5 0 1.99.92 2 2-.05.809-.408 1.447-1 2q.055.15.109.284c.192.485.351.888.141 1.73-.25 1.001-1.25 1.736-1.25 1.736s-.308 1.255-1.506 2.245C16.795 19.985 16 20 15 20h-2.994A6.2 6.2 0 0 1 7.5 18.015S7 17 7 15s.5-3.5.5-3.5C9.58 8.516 11.448 4.595 12 1h1c2.5 0 2.62 3.036 2.62 4s-.313 2.684-.62 4M2 15.011c0 2.73.9 5 2 5h3c-1-1-1.5-3-1.5-5s.5-4 1.5-5H4c-1.11 0-2 2.27-2 5"
    />
  </svg>
);

export const LikeOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M20.41 7.997h-4.66c.172-.99.259-1.994.26-2.999 0-2.469-1.15-3.998-3-3.998h-2l-.14.81a33.28 33.28 0 0 1-2.75 8.186H4c-1.11 0-2 2.498-2 5.507C2 18.51 2.89 21 4 21h5c.23 0 .46-.26.67-.65A9.005 9.005 0 0 0 13 21h2c2.68 0 4.71-1.41 5.29-3.628a4.058 4.058 0 0 0 1.29-4.198c.586-.756.91-1.682.92-2.639 0-1.679-.94-2.538-2.09-2.538ZM4.59 18.99A8.891 8.891 0 0 1 4 15.493a8.932 8.932 0 0 1 .59-3.498h3A8.992 8.992 0 0 0 7 15.492a8.892 8.892 0 0 0 .6 3.498H4.59Zm15.16-6.677-.42.51.27.62a2.108 2.108 0 0 1-.85 2.548l-.32.24-.07.39c-.31 1.74-2 2.359-3.4 2.359h-2a6.202 6.202 0 0 1-3.72-1.13 9.451 9.451 0 0 1-.28-2.368 10.5 10.5 0 0 1 .9-4.578 35.967 35.967 0 0 0 2.8-7.906H13c.82 0 1 1.09 1 1.999a15.619 15.619 0 0 1-.45 3.758c-.18.69-.09 1.24 1 1.24h5.91a2.438 2.438 0 0 1-.71 2.318Z"
    />
  </svg>
);

export const Link = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 7h-6a3.001 3.001 0 0 0-2.83 2H11a5.002 5.002 0 0 1 4.9 4H19a3 3 0 1 0 0-6Zm-3.1 8H19a5 5 0 0 0 0-10h-6a5.002 5.002 0 0 0-4.9 4H5a5 5 0 0 0 0 10h6a5.001 5.001 0 0 0 4.584-3h-2.348c-.55.614-1.348 1-2.236 1H5a3 3 0 1 1 0-6h6c1.306 0 2.418.835 2.83 2H13a2.993 2.993 0 0 1-2.236-1H8.416A5.001 5.001 0 0 0 13 15h2.9Z"
      fill="currentColor"
    />
  </svg>
);

export const LinkedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M17.25 3H6.75A3.75 3.75 0 0 0 3 6.75v10.5A3.75 3.75 0 0 0 6.75 21h10.5A3.75 3.75 0 0 0 21 17.25V6.75A3.75 3.75 0 0 0 17.25 3ZM9 17.25H6.75V9H9v8.25ZM7.875 8.049a1.318 1.318 0 0 1-1.313-1.323c0-.73.588-1.323 1.313-1.323s1.313.593 1.313 1.323S8.6 8.049 7.875 8.049ZM18 17.25h-2.25v-4.203c0-2.526-3-2.335-3 0v4.203H10.5V9h2.25v1.324C13.797 8.384 18 8.24 18 12.18v5.069Z"
    />
  </svg>
);

export const LinkedInColor = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="#0A66C2"
      d="M17.25 3H6.75A3.75 3.75 0 0 0 3 6.75v10.5A3.75 3.75 0 0 0 6.75 21h10.5A3.75 3.75 0 0 0 21 17.25V6.75A3.75 3.75 0 0 0 17.25 3ZM9 17.25H6.75V9H9v8.25Zm-1.13-9.2c-.72 0-1.3-.6-1.3-1.32 0-.73.58-1.33 1.3-1.33.73 0 1.32.6 1.32 1.33 0 .73-.59 1.32-1.31 1.32ZM18 17.25h-2.25v-4.2c0-2.53-3-2.34-3 0v4.2H10.5V9h2.25v1.32A2.85 2.85 0 0 1 18 12.18v5.07Z"
    />
    <path
      fill="#fff"
      d="M9 17.25H6.75V9H9v8.25Zm-1.13-9.2c-.72 0-1.3-.6-1.3-1.32 0-.73.58-1.33 1.3-1.33.73 0 1.32.6 1.32 1.33 0 .73-.59 1.32-1.31 1.32ZM18 17.25h-2.25v-4.2c0-2.53-3-2.34-3 0v4.2H10.5V9h2.25v1.32A2.85 2.85 0 0 1 18 12.18v5.07Z"
    />
  </svg>
);

export const List = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M1 4.005a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0ZM1 12.005a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0ZM2.2 6.805a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4ZM15 3H5v2h10V3ZM5 7h10v2H5V7ZM15 11H5v2h10v-2Z"
      fill="currentColor"
    />
  </svg>
);

export const ListAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M3 6h18v2H3zm0 5h12v2H3zm9 5H3v2h9zm7-2v2h2v2h-2v2h-2v-2h-2v-2h2v-2z"
    />
  </svg>
);

export const ListChecked = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M3 6h18v2H3zm0 5h12v2H3zm9 5H3v2h9zm5.887 4.128 4.56-4.561-1.413-1.415-3.147 3.148-2.018-2.018-1.414 1.414z"
    />
  </svg>
);

export const ListSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-6 4a6 6 0 1 1 10.89 3.477l2.767 2.766-1.414 1.414-2.766-2.766A6 6 0 0 1 9 10Zm3 7H3v2h9v-2ZM3 7h4v2H3V7Zm4 5H3v2h4v-2Z"
      fill="currentColor"
    />
  </svg>
);

export const LocationFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m9.481 14.516 2.43 6.48h.81L19 5.606 18.392 5 3 11.275v.81z"
      clipRule="evenodd"
    />
  </svg>
);

export const LocationLiveFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12 1c6.075 0 11 4.925 11 11h-2a9 9 0 0 0-9-9z"
    />
    <path fill="currentColor" d="M12 5a7 7 0 0 1 7 7h-2a5 5 0 0 0-5-5z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.097 17.903 1 16v-1l12.229-5 .77.771L9 23H8z"
      clipRule="evenodd"
    />
  </svg>
);

export const LocationLiveOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12 1c6.075 0 11 4.925 11 11h-2a9 9 0 0 0-9-9z"
    />
    <path fill="currentColor" d="M12 5a7 7 0 0 1 7 7h-2a5 5 0 0 0-5-5z" />
    <path
      stroke="currentColor"
      strokeWidth={2}
      d="m7.034 17.553-.16-.428-.427-.16-3.98-1.485 10.239-4.186L8.52 21.532z"
    />
  </svg>
);

export const LocationOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M18.246 6.8c.236-.563.354-.845.297-1.022a.5.5 0 0 0-.322-.322c-.176-.057-.458.061-1.022.297L3.396 11.528c-.086.035-.128.053-.164.076a.5.5 0 0 0-.225.337C3 11.983 3 12.03 3 12.123c0 .095 0 .143.008.186a.5.5 0 0 0 .233.34c.038.023.082.04.171.075L9.08 14.92l2.187 5.667c.035.09.052.134.074.171a.5.5 0 0 0 .342.235c.043.007.09.007.186.007.092 0 .139 0 .18-.007a.5.5 0 0 0 .338-.225c.023-.036.04-.078.076-.164L18.247 6.8Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const LockFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 6a3 3 0 1 1 6 0v3H9zM7 9.126V6a5 5 0 1 1 10 0v3.126c1.725.444 3 2.01 3 3.874v5a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-5a4 4 0 0 1 3-3.874"
      clipRule="evenodd"
    />
  </svg>
);

export const LockOpenFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3a3 3 0 0 0-3 3v3h7a4 4 0 0 1 4 4v5a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-5a4 4 0 0 1 3-3.874V6a5 5 0 1 1 10 0h-2a3 3 0 0 0-3-3"
      clipRule="evenodd"
    />
  </svg>
);

export const LockOpenOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.99976C10.3431 2.99976 9 4.3429 9 5.99976V8.99976H16C18.2091 8.99976 20 10.7906 20 12.9998V17.9998C20 20.2089 18.2091 21.9998 16 21.9998H8C5.79086 21.9998 4 20.2089 4 17.9998V12.9998C4 11.1359 5.27477 9.56982 7 9.12577V5.99976C7 3.23833 9.23858 0.999756 12 0.999756C14.7614 0.999756 17 3.23833 17 5.99976H15C15 4.3429 13.6569 2.99976 12 2.99976ZM6 12.9998C6 11.8952 6.89543 10.9998 8 10.9998H16C17.1046 10.9998 18 11.8952 18 12.9998V17.9998C18 19.1043 17.1046 19.9998 16 19.9998H8C6.89543 19.9998 6 19.1043 6 17.9998V12.9998Z"
      fill="currentColor"
    />
  </svg>
);

export const LockOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 5.99976C9 4.3429 10.3431 2.99976 12 2.99976C13.6569 2.99976 15 4.3429 15 5.99976V8.99976H9V5.99976ZM7 9.12577V5.99976C7 3.23833 9.23858 0.999756 12 0.999756C14.7614 0.999756 17 3.23833 17 5.99976V9.12577C18.7252 9.56982 20 11.1359 20 12.9998V17.9998C20 20.2089 18.2091 21.9998 16 21.9998H8C5.79086 21.9998 4 20.2089 4 17.9998V12.9998C4 11.1359 5.27477 9.56982 7 9.12577ZM6 12.9998C6 11.8952 6.89543 10.9998 8 10.9998H16C17.1046 10.9998 18 11.8952 18 12.9998V17.9998C18 19.1043 17.1046 19.9998 16 19.9998H8C6.89543 19.9998 6 19.1043 6 17.9998V12.9998Z"
      fill="currentColor"
    />
  </svg>
);

export const Login = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M18.97 18.05c.03-.47.03-1.1.03-2.05V8c0-.96 0-1.58-.03-2.05a2.32 2.32 0 0 0-.12-.72 2 2 0 0 0-1.08-1.08 2.32 2.32 0 0 0-.72-.12C16.58 4 15.95 4 15 4h-5V2h5c1.86 0 2.8 0 3.53.3a4 4 0 0 1 2.17 2.17c.3.73.3 1.67.3 3.53v8c0 1.86 0 2.8-.3 3.53a4 4 0 0 1-2.17 2.17c-.73.3-1.67.3-3.53.3h-5v-2h5c.96 0 1.58 0 2.05-.03.46-.03.63-.09.72-.12a2 2 0 0 0 1.08-1.08c.03-.09.09-.26.12-.72Z"
      fill="currentColor"
    />
    <path
      d="m8.9 8.7 1.42-1.4 4.71 4.7-4.7 4.7-1.42-1.4 2.3-2.3H2v-2h9.2L8.9 8.7Z"
      fill="currentColor"
    />
  </svg>
);

export const Logout = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M23.7202 11.9967C23.7202 11.758 23.6427 11.5293 23.4104 11.2906L20.2831 7.95915C20.1185 7.79009 19.9346 7.69065 19.7022 7.69065C19.2472 7.69065 18.918 8.06855 18.918 8.526C18.918 8.75473 19.0148 8.98346 19.1891 9.14258L20.622 10.5348L21.3385 11.1713L19.9055 11.0719H10.8751C10.391 11.0719 9.98438 11.4895 9.98438 11.9967C9.98438 12.5138 10.391 12.9315 10.8751 12.9315H19.9055L21.3385 12.8321L20.622 13.4685L19.1891 14.8608C19.0148 15.0199 18.918 15.2586 18.918 15.4873C18.918 15.9448 19.2472 16.3127 19.7022 16.3127C19.9346 16.3127 20.1185 16.2133 20.2831 16.0442L23.4104 12.7028C23.6427 12.4641 23.7202 12.2453 23.7202 11.9967Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 5.00024H13.5C14.3284 5.00024 15 5.67182 15 6.50024V9.00024H17V6.50024C17 4.56725 15.433 3.00024 13.5 3.00024H7.5C5.567 3.00024 4 4.56725 4 6.50024V17.5002C4 19.4332 5.567 21.0002 7.5 21.0002H13.5C15.433 21.0002 17 19.4332 17 17.5002V15.0002H15V17.5002C15 18.3287 14.3284 19.0002 13.5 19.0002H7.5C6.67157 19.0002 6 18.3287 6 17.5002V6.50024C6 5.67182 6.67157 5.00024 7.5 5.00024Z"
      fill="currentColor"
    />
  </svg>
);

export const MapFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 19V3.5L3 3l6 1.5 5.48-1.37a2 2 0 0 1 1.036.018l6.405 1.839L22 20.5l-1 .5-6-1.5-5.48 1.37a2 2 0 0 1-1.035-.017zm12-1.312V5.312l-4 1v12.376z"
      clipRule="evenodd"
    />
  </svg>
);

export const MapOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M14.99 21.413c.43 0 .887-.184 1.256-.387l4.36-2.47c.685-.377.966-.878.966-1.608V4.591c0-.818-.518-1.327-1.345-1.327-.342 0-.641.132-1.037.36L14.7 6.138l-4.404-2.734C9.918 3.167 9.514 3 9.092 3c-.44 0-.88.185-1.275.404l-4.35 2.461c-.686.378-.967.88-.967 1.617v12.34c0 .818.519 1.336 1.345 1.336.342 0 .641-.132 1.046-.36l4.368-2.39L13.724 21c.378.229.843.413 1.265.413ZM4.52 18.76c-.123 0-.193-.097-.193-.238V8.027c0-.28.097-.43.352-.589l3.278-1.933c.097-.053.176-.097.264-.15v11.4l-3.516 1.942a.377.377 0 0 1-.185.062Zm9.457.14c-.105-.061-.22-.123-.333-.184l-3.551-2.092V5.531c.096.044.193.106.281.158l3.604 2.25V18.9Zm1.873.167V7.658l3.524-1.942a.425.425 0 0 1 .185-.053c.123 0 .184.097.184.237v10.503c0 .282-.096.431-.343.58l-3.146 1.864c-.14.079-.273.15-.404.22Z"
      fill="currentColor"
    />
  </svg>
);

export const Menu = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M3 6h18v2H3V6ZM3 11h18v2H3v-2ZM3 16h18v2H3v-2Z"
      fill="currentColor"
    />
  </svg>
);

export const MinusL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 13h18v-2H3z"
      clipRule="evenodd"
    />
  </svg>
);

export const MinusM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 13H18V11H6V13Z"
      fill="currentColor"
    />
  </svg>
);

export const MinusSquareOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M8 13V11H16V13H8Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 9C3 7.13623 3 6.20435 3.30448 5.46927C3.71046 4.48915 4.48915 3.71046 5.46927 3.30448C6.20435 3 7.13623 3 9 3H15C16.8638 3 17.7956 3 18.5307 3.30448C19.5108 3.71046 20.2895 4.48915 20.6955 5.46927C21 6.20435 21 7.13623 21 9V15C21 16.8638 21 17.7956 20.6955 18.5307C20.2895 19.5108 19.5108 20.2895 18.5307 20.6955C17.7956 21 16.8638 21 15 21H9C7.13623 21 6.20435 21 5.46927 20.6955C4.48915 20.2895 3.71046 19.5108 3.30448 18.5307C3 17.7956 3 16.8638 3 15V9ZM9 5H15C15.9592 5 16.5785 5.00108 17.0525 5.03342C17.5085 5.06453 17.6821 5.11777 17.7654 5.15224C18.2554 5.35523 18.6448 5.74458 18.8478 6.23463C18.8822 6.31786 18.9355 6.49152 18.9666 6.94752C18.9989 7.42148 19 8.04075 19 9V15C19 15.9592 18.9989 16.5785 18.9666 17.0525C18.9355 17.5085 18.8822 17.6821 18.8478 17.7654C18.6448 18.2554 18.2554 18.6448 17.7654 18.8478C17.6821 18.8822 17.5085 18.9355 17.0525 18.9666C16.5785 18.9989 15.9592 19 15 19H9C8.04075 19 7.42148 18.9989 6.94752 18.9666C6.49152 18.9355 6.31786 18.8822 6.23463 18.8478C5.74458 18.6448 5.35523 18.2554 5.15224 17.7654C5.11777 17.6821 5.06453 17.5085 5.03342 17.0525C5.00108 16.5785 5 15.9592 5 15V9C5 8.04075 5.00108 7.42148 5.03342 6.94752C5.06453 6.49152 5.11777 6.31786 5.15224 6.23463C5.35523 5.74458 5.74458 5.35523 6.23463 5.15224C6.31786 5.11777 6.49152 5.06453 6.94752 5.03342C7.42148 5.00108 8.04075 5 9 5Z"
      fill="currentColor"
    />
  </svg>
);

export const MinusOutlineL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M17 11v2H7v-2h10Z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
      clipRule="evenodd"
    />
  </svg>
);

export const MixedCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <rect
      x="6"
      y="10.345"
      width="12"
      height="2.5"
      rx="1.25"
      fill="currentColor"
    />
  </svg>
);

export const MobileFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.58944 2.91001C5 3.87188 5 5.18126 5 7.8V16.2C5 18.8187 5 20.1281 5.58944 21.09C5.91926 21.6282 6.37178 22.0807 6.91001 22.4106C7.87188 23 9.18126 23 11.8 23H12.2C14.8187 23 16.1281 23 17.09 22.4106C17.6282 22.0807 18.0807 21.6282 18.4106 21.09C19 20.1281 19 18.8187 19 16.2V7.8C19 5.18126 19 3.87188 18.4106 2.91001C18.0807 2.37178 17.6282 1.91926 17.09 1.58944C16.1281 1 14.8187 1 12.2 1H11.8C9.18126 1 7.87188 1 6.91001 1.58944C6.37178 1.91926 5.91926 2.37178 5.58944 2.91001ZM14 5V3H10V5H14Z"
      fill="currentColor"
    />
  </svg>
);

export const MobileOffFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M3.5 1H1L5.00969 6.04075C5 6.55307 5 7.13422 5 7.8V16.2C5 18.8187 5 20.1281 5.58944 21.09C5.91926 21.6282 6.37178 22.0807 6.91001 22.4106C7.87188 23 9.18126 23 11.8 23H12.2C14.8187 23 16.1281 23 17.09 22.4106C17.3006 22.2815 17.498 22.1337 17.6801 21.9693L18.5 23H21L3.5 1Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.31986 2.03068L18.9903 17.9593C19 17.4469 19 16.8658 19 16.2V7.8C19 5.18126 19 3.87188 18.4106 2.91001C18.0807 2.37178 17.6282 1.91926 17.09 1.58944C16.1281 1 14.8187 1 12.2 1H11.8C9.18126 1 7.87188 1 6.91001 1.58944C6.69943 1.71848 6.50198 1.8663 6.31986 2.03068ZM14 5V3H10V5H14Z"
      fill="currentColor"
    />
  </svg>
);

export const MobileOffOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 1H1L5.00969 6.04075C5 6.55307 5 7.13422 5 7.8V16.2C5 18.8187 5 20.1281 5.58944 21.09C5.91926 21.6282 6.37178 22.0807 6.91001 22.4106C7.87188 23 9.18126 23 11.8 23H12.2C14.8187 23 16.1281 23 17.09 22.4106C17.3006 22.2815 17.498 22.1337 17.6801 21.9693L18.5 23H21L3.5 1ZM7 16.2V8.54286L16.4302 20.398C16.3154 20.5155 16.1861 20.6188 16.045 20.7053C15.9311 20.7751 15.7055 20.8755 15.077 20.9353C14.4187 20.9979 13.5481 21 12.2 21H11.8C10.4519 21 9.58127 20.9979 8.92299 20.9353C8.29446 20.8755 8.06888 20.7751 7.955 20.7053C7.68589 20.5404 7.45963 20.3141 7.29472 20.045C7.22494 19.9311 7.12446 19.7055 7.0647 19.077C7.00211 18.4187 7 17.5481 7 16.2Z"
      fill="currentColor"
    />
    <path
      d="M6.31986 2.03068L7.56977 3.60199C7.68463 3.48448 7.81393 3.38117 7.955 3.29472C8.06888 3.22494 8.29446 3.12446 8.92299 3.0647C9.58127 3.00211 10.4519 3 11.8 3H12.2C13.5481 3 14.4187 3.00211 15.077 3.0647C15.7055 3.12446 15.9311 3.22494 16.045 3.29472C16.3141 3.45963 16.5404 3.68589 16.7053 3.955C16.7751 4.06888 16.8755 4.29446 16.9353 4.92299C16.9979 5.58127 17 6.4519 17 7.8V15.4571L18.9903 17.9593C19 17.4469 19 16.8658 19 16.2V7.8C19 5.18126 19 3.87188 18.4106 2.91001C18.0807 2.37178 17.6282 1.91926 17.09 1.58944C16.1281 1 14.8187 1 12.2 1H11.8C9.18126 1 7.87188 1 6.91001 1.58944C6.69943 1.71848 6.50198 1.8663 6.31986 2.03068Z"
      fill="currentColor"
    />
    <path d="M14 6V4H10V6H14Z" fill="currentColor" />
  </svg>
);

export const MobileOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M14 6V4H10V6H14Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 7.8C5 5.18126 5 3.87188 5.58944 2.91001C5.91926 2.37178 6.37178 1.91926 6.91001 1.58944C7.87188 1 9.18126 1 11.8 1H12.2C14.8187 1 16.1281 1 17.09 1.58944C17.6282 1.91926 18.0807 2.37178 18.4106 2.91001C19 3.87188 19 5.18126 19 7.8V16.2C19 18.8187 19 20.1281 18.4106 21.09C18.0807 21.6282 17.6282 22.0807 17.09 22.4106C16.1281 23 14.8187 23 12.2 23H11.8C9.18126 23 7.87188 23 6.91001 22.4106C6.37178 22.0807 5.91926 21.6282 5.58944 21.09C5 20.1281 5 18.8187 5 16.2V7.8ZM11.8 3H12.2C13.5481 3 14.4187 3.00211 15.077 3.0647C15.7055 3.12446 15.9311 3.22494 16.045 3.29472C16.3141 3.45963 16.5404 3.68589 16.7053 3.955C16.7751 4.06888 16.8755 4.29446 16.9353 4.92299C16.9979 5.58127 17 6.4519 17 7.8V16.2C17 17.5481 16.9979 18.4187 16.9353 19.077C16.8755 19.7055 16.7751 19.9311 16.7053 20.045C16.5404 20.3141 16.3141 20.5404 16.045 20.7053C15.9311 20.7751 15.7055 20.8755 15.077 20.9353C14.4187 20.9979 13.5481 21 12.2 21H11.8C10.4519 21 9.58127 20.9979 8.92299 20.9353C8.29446 20.8755 8.06888 20.7751 7.955 20.7053C7.68589 20.5404 7.45963 20.3141 7.29472 20.045C7.22494 19.9311 7.12446 19.7055 7.0647 19.077C7.00211 18.4187 7 17.5481 7 16.2V7.8C7 6.4519 7.00211 5.58127 7.0647 4.92299C7.12446 4.29446 7.22494 4.06888 7.29472 3.955C7.45963 3.68589 7.68589 3.45963 7.955 3.29472C8.06888 3.22494 8.29446 3.12446 8.92299 3.0647C9.58127 3.00211 10.4519 3 11.8 3Z"
      fill="currentColor"
    />
  </svg>
);

export const MoreHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.5 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0m9.5 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4m7.5 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
      clipRule="evenodd"
    />
  </svg>
);

export const MoreVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 7.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      clipRule="evenodd"
    />
  </svg>
);

export const MotorcycleProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5.99976H14.3175L15.1001 7.99976H12L10 8.99976H0.5L1.84191 11.6836C2.62978 11.2478 3.53592 10.9998 4.5 10.9998C7.36902 10.9998 9.72496 13.1965 9.97758 15.9998H7.96456C7.72194 14.3036 6.26324 12.9998 4.5 12.9998C2.567 12.9998 1 14.5668 1 16.4998C1 18.4328 2.567 19.9998 4.5 19.9998C5.8962 19.9998 7.10145 19.1822 7.66318 17.9998H14V15.9998C14.1588 14.2374 15.1714 12.7148 16.5977 11.827L17.3465 13.7405C16.5269 14.3811 16 15.3789 16 16.4998C16 18.4328 17.567 19.9998 19.5 19.9998C21.433 19.9998 23 18.4328 23 16.4998C23 14.5668 21.433 12.9998 19.5 12.9998C19.402 12.9998 19.3049 13.0038 19.2089 13.0117L18.4601 11.0979C18.9565 11.0029 19.4879 10.9536 20 10.9998V9.99976C20 8.89519 19.1046 7.99976 18 7.99976H17.2477L16.18 5.27096C15.8799 4.50427 15.1408 3.99976 14.3175 3.99976H12V5.99976ZM6 16.4998C6 17.3282 5.32843 17.9998 4.5 17.9998C3.67157 17.9998 3 17.3282 3 16.4998C3 15.6713 3.67157 14.9998 4.5 14.9998C5.32843 14.9998 6 15.6713 6 16.4998ZM19.5 17.9998C20.3284 17.9998 21 17.3282 21 16.4998C21 15.6713 20.3284 14.9998 19.5 14.9998C18.6716 14.9998 18 15.6713 18 16.4998C18 17.3282 18.6716 17.9998 19.5 17.9998Z"
      fill="currentColor"
    />
  </svg>
);

export const MotorcycleFront = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 3.99976H6.88197L7.93927 6.11437L6.42911 8.96454C6.08552 9.64082 5.94373 10.3991 6.02017 11.1514L7 19.9998H8.5V17.4998C8.5 15.5668 10.067 13.9998 12.0001 13.9998C13.9331 13.9998 15.5001 15.5668 15.5001 17.4998V19.9998H17L17.9798 11.1514C18.0563 10.3991 17.9145 9.64081 17.5709 8.96454L16.0607 6.11437L17.118 3.99976H20V1.99976H17.118C16.3605 1.99976 15.668 2.42776 15.3292 3.10533L14.1584 5.44697C13.989 5.78575 13.6427 5.99976 13.2639 5.99976H10.7361C10.3573 5.99976 10.011 5.78575 9.84164 5.44697L8.67082 3.10533C8.33204 2.42776 7.63951 1.99976 6.88197 1.99976H4V3.99976ZM12 11.9998C12.8284 11.9998 13.5 11.3282 13.5 10.4998C13.5 9.67133 12.8284 8.99976 12 8.99976C11.1716 8.99976 10.5 9.67133 10.5 10.4998C10.5 11.3282 11.1716 11.9998 12 11.9998Z"
      fill="currentColor"
    />
    <path
      d="M10.5001 17.4997L10.5 19.9996L11.0001 22.9996H13.0001L13.5001 19.9996V17.4998C13.5001 16.6713 12.8285 15.9998 12.0001 15.9998C11.1717 15.9998 10.5001 16.6713 10.5001 17.4997Z"
      fill="currentColor"
    />
  </svg>
);

export const NDA = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.49 2.09a3.435 3.435 0 0 1 5.02 0l.04.042a3.435 3.435 0 0 0 2.625 1.088l.058-.002a3.435 3.435 0 0 1 3.55 3.549l-.003.058a3.435 3.435 0 0 0 1.088 2.626l.042.04a3.435 3.435 0 0 1 0 5.019l-.042.04a3.435 3.435 0 0 0-1.088 2.625l.002.058a3.435 3.435 0 0 1-3.549 3.55l-.058-.003a3.435 3.435 0 0 0-2.626 1.088l-.04.042a3.435 3.435 0 0 1-5.019 0l-.04-.042a3.435 3.435 0 0 0-2.625-1.088l-.058.002a3.435 3.435 0 0 1-3.55-3.549l.003-.058a3.435 3.435 0 0 0-1.088-2.626l-.042-.04a3.435 3.435 0 0 1 0-5.019l.042-.04A3.435 3.435 0 0 0 3.22 6.826l-.002-.058a3.435 3.435 0 0 1 3.549-3.55l.058.003A3.435 3.435 0 0 0 9.45 2.132l.04-.042Zm9.8 11.388 1.198-.321-3.41-5.88-1.296.347-.03 6.802 1.036-.278-.004-1.707 1.674-.448.832 1.485Zm-1.342-2.383-1.162.311-.006-2.399 1.168 2.088ZM9.568 9.29l1.522-.408c.546-.146 1.057-.185 1.532-.116.475.069.89.286 1.246.653.361.365.642.919.84 1.663.305 1.133.27 2.05-.101 2.75-.372.7-1 1.17-1.882 1.406l-1.458.39L9.568 9.29Zm2.955 4.94c.528-.142.885-.43 1.07-.866.19-.443.174-1.081-.05-1.913-.141-.531-.317-.924-.527-1.178-.205-.261-.443-.416-.713-.464a1.904 1.904 0 0 0-.884.048l-.442.118 1.168 4.356.378-.102ZM4.3 10.7l1.396-.374 3.012 4.004-1.203-4.488 1.008-.27 1.699 6.338-1.395.374-3.015-4.012 1.205 4.497L6 17.04 4.3 10.7Z"
      fill="currentColor"
    />
  </svg>
);

export const News = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 21H19a2.5 2.5 0 0 0 2.5-2.5V12a3 3 0 0 0-3-3V6a3 3 0 0 0-3-3h-9a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3Zm13-2.5a.5.5 0 0 1-1 .016v-7.515a1 1 0 0 1 1 1v6.5Zm-3-7.5V6a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10v-8Zm-9-3h7v2h-7V8Zm0 4.083h7V16h-7v-3.917Z"
      clipRule="evenodd"
    />
  </svg>
);

export const NewsAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.017 3H6.501a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3H19a2.5 2.5 0 0 0 2.5-2.5V12c0-.515-.13-1-.36-1.424a5.023 5.023 0 0 1-1.642 1.365l.002.06v6.5a.5.5 0 0 1-1 .015V12.33a5.005 5.005 0 0 1-2 .122V19h-10a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6.368a5.022 5.022 0 0 1 2.148-2Zm-2.148 7a4.968 4.968 0 0 1-.644-2H7.5v2h5.368Zm1.632 2.083h-7V16h7v-3.917Z"
      clipRule="evenodd"
    />
    <path fill="#F5523A" d="M20.2 7.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);

export const NewTab = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9 5h2V3H9c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 3.303 5.47C3 6.204 3 7.136 3 9v6c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C6.204 21 7.136 21 9 21h6c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164C21 17.796 21 16.864 21 15v-2h-2v2c0 .96-.001 1.578-.033 2.052-.031.457-.085.63-.12.713a2 2 0 0 1-1.082 1.083c-.083.034-.256.088-.713.119-.474.032-1.093.033-2.052.033H9c-.96 0-1.579-.001-2.052-.033-.456-.031-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.256-.119-.713C5.001 16.578 5 15.96 5 15V9c0-.96.001-1.579.033-2.052.032-.456.085-.63.12-.713a2 2 0 0 1 1.082-1.083c.083-.034.257-.087.713-.119C7.42 5.001 8.04 5 9 5Z"
      fill="currentColor"
    />
    <path
      d="M14 3v2h3.58l-7.902 7.902 1.415 1.414L19 6.41V10h1.992V3.003L14 3Z"
      fill="currentColor"
    />
  </svg>
);

export const NotToHearOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2H6.5L20.5 22H18L16.5254 19.8934C16.5143 19.9046 16.5031 19.9157 16.4918 19.9267C16.0866 20.3229 15.5896 20.6234 15.0406 20.8044C14.4915 20.9853 13.9057 21.0416 13.3297 20.9689C12.7537 20.8961 12.2035 20.6963 11.7232 20.3853C10.5893 19.5549 10.0476 18.546 9.79148 16.8634C9.65607 15.9578 9.19599 15.4758 8.55319 14.8091C8.21246 14.4543 7.93619 14.1565 7.70898 13.8956C6.64745 12.7387 6 11.1939 6 9.5C6 8.28213 6.33494 7.14249 6.91772 6.16817L4 2ZM8.09682 7.85259C7.90492 8.36525 7.8 8.92037 7.8 9.5C7.8 10.515 8.12175 11.4549 8.66883 12.2232C8.87388 12.5079 9.21215 12.8965 9.84995 13.5608L9.91259 13.6256C10.5303 14.2647 11.3487 15.1114 11.5713 16.5945C11.6799 17.3073 11.8321 17.7592 12.0081 18.0815C12.1675 18.3735 12.3855 18.6314 12.742 18.8999C12.9827 19.0475 13.2603 19.1458 13.5552 19.1831C13.867 19.2225 14.1833 19.1916 14.4771 19.0948C14.7708 18.998 15.0287 18.8398 15.2336 18.6395C15.3193 18.5557 15.3948 18.4656 15.4595 18.3708L8.09682 7.85259Z"
      fill="currentColor"
    />
    <path
      d="M9.29189 3.84556L10.3307 5.3295C10.9796 4.99123 11.7175 4.8 12.5 4.8C15.0957 4.8 17.2 6.90426 17.2 9.5C17.2 9.6689 17.1911 9.83571 17.1737 10H18.9811C18.9936 9.83498 19 9.66824 19 9.5C19 5.91015 16.0899 3 12.5 3C11.3333 3 10.2384 3.30737 9.29189 3.84556Z"
      fill="currentColor"
    />
    <path
      d="M14.3931 11.1329L11.6133 7.16182C11.8889 7.05725 12.1877 7 12.5 7C13.8807 7 15 8.11929 15 9.5C15 10.1242 14.7713 10.6949 14.3931 11.1329Z"
      fill="currentColor"
    />
  </svg>
);

export const Outside = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M12 4H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5.17A3 3 0 0 1 9 19v-6a3 3 0 0 1 1.42-2.55L13 8.85V5a1 1 0 0 0-1-1Zm3 3.7V5a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-6a3 3 0 0 0-1.42-2.55l-4-2.47A3 3 0 0 0 15 7.7Zm6 5.3v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 .47-.85l4-2.47a1 1 0 0 1 1.06 0l4 2.47c.3.19.47.5.47.85Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5 6h2v2H5zM5 10h2v2H5zM5 14h2v2H5zM9 6h2v2H9zM13 13h2v2h-2zM17 13h2v2h-2zM15 17h2v3h-2z"
    />
  </svg>
);

export const PauseFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M9.85 3.23C10 3.6 10 4.07 10 5v14c0 .93 0 1.4-.15 1.77a2 2 0 0 1-1.08 1.08C8.4 22 7.93 22 7 22H6c-.93 0-1.4 0-1.77-.15a2 2 0 0 1-1.08-1.08C3 20.4 3 19.93 3 19V5c0-.93 0-1.4.15-1.77a2 2 0 0 1 1.08-1.08C4.6 2 5.07 2 6 2h1c.93 0 1.4 0 1.77.15a2 2 0 0 1 1.08 1.08ZM20.85 3.23C21 3.6 21 4.07 21 5v14c0 .93 0 1.4-.15 1.77a2 2 0 0 1-1.08 1.08c-.37.15-.84.15-1.77.15h-1c-.93 0-1.4 0-1.77-.15a2 2 0 0 1-1.08-1.08C14 20.4 14 19.93 14 19V5c0-.93 0-1.4.15-1.77a2 2 0 0 1 1.08-1.08C15.6 2 16.07 2 17 2h1c.93 0 1.4 0 1.77.15a2 2 0 0 1 1.08 1.08Z"
    />
  </svg>
);

export const PauseOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 18c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C5.605 22 6.07 22 7 22s1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C11 19.395 11 18.93 11 18V6c0-.93 0-1.395-.102-1.777a3 3 0 0 0-2.122-2.12C8.395 2 7.93 2 7 2s-1.395 0-1.776.102a3 3 0 0 0-2.122 2.121C3 4.605 3 5.07 3 6v12Zm6 0V6c0-.483 0-.779-.01-1.003-.01-.213-.026-.263-.024-.256a1 1 0 0 0-.707-.707 1.67 1.67 0 0 0-.256-.023C7.779 4 7.483 4 7 4c-.483 0-.779 0-1.003.01-.213.01-.263.026-.256.024a1 1 0 0 0-.707.707c.002-.007-.014.043-.023.256C5 5.221 5 5.517 5 6v12c0 .483 0 .779.01 1.003.01.213.026.263.024.256a1 1 0 0 0 .707.707c-.007-.002.043.014.256.023.224.01.52.01 1.003.01.483 0 .779 0 1.003-.01.2-.009.257-.023.257-.023a.999.999 0 0 0 .706-.707c-.002.007.014-.043.023-.256C9 18.779 9 18.483 9 18ZM13 18c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.121 2.122C15.605 22 16.07 22 17 22c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 19.395 21 18.93 21 18V6c0-.93 0-1.395-.102-1.777a3 3 0 0 0-2.122-2.12C18.395 2 17.93 2 17 2s-1.395 0-1.777.102a3 3 0 0 0-2.12 2.121C13 4.605 13 5.07 13 6v12Zm6 0V6c0-.483 0-.779-.01-1.003-.01-.213-.026-.263-.024-.256a1 1 0 0 0-.707-.707 1.667 1.667 0 0 0-.256-.023C17.779 4 17.483 4 17 4c-.483 0-.779 0-1.003.01-.2.01-.257.024-.256.024-.001 0 0 0 0 0a.999.999 0 0 0-.707.707c.002-.007-.014.043-.023.256C15 5.221 15 5.517 15 6v12c0 .483 0 .779.01 1.003.01.213.026.263.024.256a1 1 0 0 0 .707.707c-.007-.002.043.014.256.023.224.01.52.01 1.003.01.483 0 .779 0 1.003-.01.2-.009.257-.023.256-.023a.999.999 0 0 0 .707-.707c-.002.007.014-.043.023-.256.01-.224.011-.52.011-1.003Z"
      clipRule="evenodd"
    />
  </svg>
);

export const PDF = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M4 13.54v-4.2c0-2.62 0-3.929.59-4.89a4 4 0 0 1 1.32-1.322c.859-.526 1.994-.582 4.09-.588h1.183c1.142 0 1.713 0 2.246.15a4 4 0 0 1 .869.36c.482.27.886.673 1.694 1.48l2.016 2.017c.808.808 1.212 1.212 1.482 1.694a4 4 0 0 1 .36.87c.15.532.15 1.103.15 2.245v2.183h-2v-1c0-.48 0-.79-.017-1.026-.015-.228-.042-.315-.06-.357a1 1 0 0 0-.54-.54c-.042-.018-.129-.045-.357-.06A16.885 16.885 0 0 0 16 10.539h-.032c-.439 0-.817 0-1.13-.021a3.07 3.07 0 0 1-.986-.207 3 3 0 0 1-1.624-1.624 3.072 3.072 0 0 1-.207-.986C12 7.388 12 7.01 12 6.571v-.032c0-.48 0-.79-.017-1.026-.015-.228-.042-.315-.06-.357a1 1 0 0 0-.54-.54c-.042-.018-.129-.045-.357-.06a11.83 11.83 0 0 0-.733-.017c-1.066.002-1.798.01-2.37.065-.629.06-.854.16-.968.23a2 2 0 0 0-.66.66c-.07.114-.17.34-.23.968C6.002 7.12 6 7.991 6 9.339v4.2zm13.162-4.98.026.002c-.15-.154-.343-.35-.594-.6l-2.017-2.017a56.618 56.618 0 0 0-.6-.594l.002.026c.021.313.021.691.021 1.13v.032c0 .48 0 .79.017 1.026.015.228.042.315.06.357a1 1 0 0 0 .54.54c.042.018.129.045.357.06.237.017.546.017 1.026.017h.032c.439 0 .817 0 1.13.021zM4.018 15.527h2.104c.757 0 1.372.145 1.818.46.474.33.694.858.694 1.532 0 .357-.06.677-.186.954-.119.274-.293.503-.522.683l-.003.002a2.243 2.243 0 0 1-.807.379 4.02 4.02 0 0 1-1.01.118h-.544v2.008H4.018zm5.515 0h2.152c.436 0 .844.047 1.224.142.392.097.735.257 1.027.484.3.23.53.532.692.901.17.374.25.825.25 1.345 0 .527-.081.999-.247 1.411a2.88 2.88 0 0 1-.689 1.023 2.924 2.924 0 0 1-1.046.627h-.002a3.951 3.951 0 0 1-1.289.203H9.533zm6.297 0h4.168v1.36h-2.624v1.104h2.224v1.352h-2.224v2.32H15.83zm-10.268 1.36v1.424h.544c.352 0 .594-.066.75-.172.135-.094.226-.264.226-.572 0-.258-.081-.409-.211-.5l-.005-.004c-.143-.106-.38-.176-.744-.176zm5.515 0v3.424h.584c.253 0 .477-.037.677-.108.196-.07.36-.176.498-.318a1.6 1.6 0 0 0 .332-.568c.082-.235.125-.52.125-.862 0-.33-.043-.592-.122-.79l-.001-.004a1.065 1.065 0 0 0-.309-.46l-.002-.002a1.123 1.123 0 0 0-.47-.238 2.664 2.664 0 0 0-.648-.074z" />
    </g>
  </svg>
);

export const PercentRoundFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM9.75 11.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Zm0-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm4.5-2.25h1.688l-6.188 9H8.062l6.188-9Zm0 9.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Zm0-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
      fill="currentColor"
    />
  </svg>
);

export const PercentRoundOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75 11.25C10.9926 11.25 12 10.2426 12 9C12 7.75736 10.9926 6.75 9.75 6.75C8.50736 6.75 7.5 7.75736 7.5 9C7.5 10.2426 8.50736 11.25 9.75 11.25ZM9.75 9.75C10.1642 9.75 10.5 9.41421 10.5 9C10.5 8.58579 10.1642 8.25 9.75 8.25C9.33579 8.25 9 8.58579 9 9C9 9.41421 9.33579 9.75 9.75 9.75Z"
      fill="currentColor"
    />
    <path
      d="M14.25 7.5H15.9375L9.75 16.5H8.0625L14.25 7.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 15C16.5 16.2426 15.4926 17.25 14.25 17.25C13.0074 17.25 12 16.2426 12 15C12 13.7574 13.0074 12.75 14.25 12.75C15.4926 12.75 16.5 13.7574 16.5 15ZM15 15C15 15.4142 14.6642 15.75 14.25 15.75C13.8358 15.75 13.5 15.4142 13.5 15C13.5 14.5858 13.8358 14.25 14.25 14.25C14.6642 14.25 15 14.5858 15 15Z"
      fill="currentColor"
    />
  </svg>
);

export const PetrolOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M2.60986 5.60681L7.85986 1.23181L9.14023 2.76825L3.89023 7.14325L2.60986 5.60681Z"
      fill="currentColor"
    />
    <path
      d="M12.0019 16.5C10.5015 16.5 9.5 15.5587 9.5 14.1521C9.5 13.4652 9.78345 12.7674 10.0064 12.2913C10.3302 11.5944 10.8445 10.84 11.33 10.1279C11.4167 10.0006 11.5025 9.87474 11.5862 9.75078C11.6995 9.5836 11.8469 9.5 12.0019 9.5C12.1531 9.5 12.3005 9.5836 12.4138 9.75078C12.4903 9.86365 12.5686 9.97814 12.6476 10.0938C13.1387 10.8123 13.6611 11.5765 13.9898 12.284C14.2165 12.7638 14.5 13.4615 14.5 14.1521C14.5 15.5587 13.4984 16.5 12.0019 16.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2948 3.70984C10.8365 3.25151 11.5231 3 12.2326 3H17C18.6569 3 20 4.34315 20 6V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V10.4276C4 9.54515 4.38852 8.70745 5.06217 8.13744L10.2948 3.70984ZM12.2326 5C11.9961 5 11.7672 5.08384 11.5867 5.23661L6.35406 9.66421C6.12951 9.85422 6 10.1334 6 10.4276V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V6C18 5.44772 17.5523 5 17 5H12.2326Z"
      fill="currentColor"
    />
  </svg>
);

export const PictureFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 9c0-1.864 0-2.796.304-3.53A4 4 0 0 1 5.47 3.303C6.204 3 7.136 3 9 3h6c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165C21 6.204 21 7.136 21 9v6c0 1.864 0 2.796-.305 3.53a4 4 0 0 1-2.164 2.165C17.796 21 16.864 21 15 21H9c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.164C3 17.796 3 16.864 3 15zm6.5 3.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m9.499 2.724-3.5-1.272-4 3-4-1-2.42 1.98c.024.154.052.236.072.286a2 2 0 0 0 1.083 1.082c.083.034.256.088.712.119.474.032 1.094.033 2.053.033h6c.96 0 1.578 0 2.052-.033.456-.031.63-.085.713-.119a2 2 0 0 0 1.083-1.082c.034-.084.087-.257.118-.713.033-.474.034-1.094.034-2.053z"
      clipRule="evenodd"
    />
  </svg>
);

export const PictureOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.304 18.53c-.127-.307-.201-.649-.244-1.08L3 17.37l.05-.036C3 16.754 3 16.014 3 15V9c0-1.864 0-2.796.304-3.53A4 4 0 0 1 5.47 3.303C6.204 3 7.136 3 9 3h6c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165C21 6.204 21 7.136 21 9v6c0 1.864 0 2.796-.305 3.53a4 4 0 0 1-2.164 2.165C17.796 21 16.864 21 15 21H9c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.164M15 5H9c-.96 0-1.579.001-2.052.033-.456.032-.63.085-.713.12a2 2 0 0 0-1.083 1.082c-.034.083-.087.257-.119.713C5.001 7.42 5 8.04 5 9v6c0 .327 0 .614.002.87l2.379-1.785 4 1 4.113-3.21L19 13.455V9c0-.96-.001-1.579-.033-2.052-.031-.456-.085-.63-.12-.713a2 2 0 0 0-1.082-1.083c-.083-.034-.256-.087-.713-.119C16.579 5.001 15.96 5 15 5M7.82 16.256l-2.48 1.86a2 2 0 0 0 .895.732c.083.034.257.088.713.119C7.42 18.999 8.04 19 9 19h6c.96 0 1.578-.001 2.052-.033.457-.031.63-.085.713-.12a2 2 0 0 0 1.083-1.082c.034-.083.088-.256.119-.713.024-.356.03-.794.032-1.397l-3.293-1.44-3.887 3.041z"
      clipRule="evenodd"
    />
  </svg>
);

export const PinFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M19.75 4.25C17.27 1.77 14.78.7 14.08 1.4L13 2.47l1.08 2.49L11.29 7a9.28 9.28 0 0 0-7.81.79c-.78.77 1.41 4.24 4.95 7.77 3.53 3.54 7 5.73 7.77 4.95A9.28 9.28 0 0 0 17 12.7l2.05-2.8 2.47 1.07 1.06-1.06c.71-.71-.35-3.19-2.82-5.66ZM3.55 19.1l3.2-3.85a40.41 40.41 0 0 0 2.03 2.03l-3.81 3.24-1.42-1.41Z"
    />
  </svg>
);

export const PinOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m20.485 12-2.121-.707-1.874 2.734a9.064 9.064 0 0 1-1.662 7.873c-.699.699-3.57-1.003-6.713-3.923l-3.155 2.54-1.414-1.415 2.488-3.205C3.107 12.75 1.4 9.872 2.101 9.172a9.07 9.07 0 0 1 7.869-1.66l2.737-1.876L12 3.515 13.414 2.1c.707-.707 3.182.354 5.657 2.829s3.536 4.95 2.828 5.657L20.485 12Zm-7.44 7.354c.31.196.572.345.79.456a7.06 7.06 0 0 0 .718-5.284l-.24-.93L17.63 8.94l2.316.772.079-.079a4.114 4.114 0 0 0-.15-.35c-.366-.765-1.099-1.822-2.217-2.94-1.118-1.118-2.175-1.851-2.94-2.217a4.102 4.102 0 0 0-.35-.15l-.079.079.772 2.316-4.658 3.317-.93-.239a7.069 7.069 0 0 0-5.281.717c.11.217.26.48.455.788.793 1.249 2.122 2.885 3.818 4.582 1.697 1.696 3.333 3.025 4.582 3.818Z"
      fill="currentColor"
    />
  </svg>
);

export const PlanetOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C12.1504 20 12.414 19.9232 12.7719 19.5755C13.126 19.2315 13.5002 18.6873 13.8417 17.9457C14.3355 16.8734 14.7221 15.4726 14.8974 13.8831C13.9959 13.9585 13.0256 14 12 14C10.9744 14 10.0041 13.9585 9.10261 13.8831C9.27791 15.4726 9.66452 16.8734 10.1583 17.9457C10.4998 18.6873 10.874 19.2315 11.2281 19.5755C11.586 19.9232 11.8496 20 12 20ZM19.9522 12.8794C19.6453 15.6863 17.8863 18.0568 15.4425 19.2235C15.517 19.08 15.589 18.9327 15.6583 18.7822C16.3022 17.3841 16.763 15.6039 16.9306 13.6391C17.4616 13.554 17.9559 13.4561 18.4093 13.3475C18.9796 13.211 19.4989 13.0544 19.9522 12.8794ZM19.8947 10.6986C19.4658 8.07722 17.7629 5.88429 15.4425 4.77648C15.517 4.92001 15.589 5.06726 15.6583 5.21776C16.4351 6.90455 16.9455 9.14726 16.9959 11.5995C17.3334 11.5389 17.6498 11.4728 17.9436 11.4025C18.6835 11.2253 19.2511 11.0276 19.6422 10.8362C19.7469 10.7849 19.8297 10.7386 19.8947 10.6986ZM8.55753 19.2235C6.11366 18.0568 4.35468 15.6863 4.04778 12.8794C4.5011 13.0544 5.02038 13.211 5.59067 13.3475C6.04405 13.4561 6.53838 13.5541 7.06943 13.6391C7.23699 15.6039 7.69783 17.3841 8.34168 18.7822C8.41099 18.9327 8.48296 19.08 8.55753 19.2235ZM4.10531 10.6986C4.17031 10.7386 4.25311 10.785 4.3578 10.8362C4.74888 11.0276 5.31646 11.2253 6.05638 11.4025C6.35016 11.4728 6.66657 11.5389 7.00411 11.5995C7.05454 9.14726 7.56492 6.90455 8.34168 5.21776C8.41099 5.06726 8.48295 4.92001 8.55753 4.77648C6.23712 5.88429 4.53416 8.07724 4.10531 10.6986ZM12 4C11.8496 4 11.586 4.07675 11.2281 4.42449C10.874 4.76854 10.4998 5.31272 10.1583 6.05432C9.49006 7.5055 9.01812 9.55811 9.00051 11.8663C9.91358 11.9514 10.919 12 12 12C13.081 12 14.0864 11.9514 14.9995 11.8663C14.9819 9.55811 14.5099 7.5055 13.8417 6.05432C13.5002 5.31272 13.126 4.76854 12.7719 4.42449C12.414 4.07675 12.1504 4 12 4Z"
      fill="currentColor"
    />
  </svg>
);

export const Play = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.66 9.34c1 .86 1.72 1.82 1.72 3.1 0 1.27-.73 2.23-1.72 3.08-.97.84-2.4 1.73-4.15 2.85l-1.74 1.1c-1.99 1.25-3.58 2.25-4.87 2.82-1.31.58-2.6.85-3.8.18-1.22-.66-1.68-1.9-1.9-3.31-.2-1.4-.2-3.28-.2-5.64v-2.18C3 9 3 7.1 3.2 5.71c.22-1.42.68-2.65 1.9-3.32 1.2-.66 2.49-.4 3.8.18 1.3.57 2.88 1.58 4.87 2.83l1.74 1.1c1.76 1.11 3.18 2 4.15 2.84Z"
      clipRule="evenodd"
    />
  </svg>
);

export const PlayOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.34 10.87a38 38 0 0 0-3.98-2.7l-1.59-1.01a43 43 0 0 0-4.69-2.74c-1.13-.5-1.65-.46-2.01-.26S5.39 4.78 5.2 6a43 43 0 0 0-.19 5.43v2c0 2.47 0 4.2.19 5.43.18 1.23.5 1.64.86 1.84s.88.25 2.01-.25c1.14-.5 2.6-1.43 4.69-2.75l1.59-1a38 38 0 0 0 3.98-2.7c.83-.72 1.01-1.17 1.01-1.57s-.18-.84-1.01-1.56m1.32-1.53c1 .86 1.72 1.82 1.72 3.1 0 1.27-.73 2.23-1.72 3.08-.97.84-2.4 1.73-4.15 2.85l-1.74 1.1c-1.99 1.25-3.58 2.25-4.87 2.82-1.31.58-2.6.85-3.8.18-1.22-.66-1.68-1.9-1.9-3.31-.2-1.4-.2-3.28-.2-5.64v-2.18C3 9 3 7.1 3.2 5.71c.22-1.42.68-2.65 1.9-3.32 1.2-.66 2.49-.4 3.8.18 1.3.57 2.88 1.58 4.87 2.83l1.74 1.1c1.76 1.11 3.18 2 4.15 2.84"
      clipRule="evenodd"
    />
  </svg>
);

export const PlusL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 3v8H3v2h8v8h2v-8h8v-2h-8V3z"
      clipRule="evenodd"
    />
  </svg>
);

export const PlusM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M11 6v5H6v2h5v5h2v-5h5v-2h-5V6z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const PlusOutlineL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="m13 7v4h4v2h-4v4h-2v-4h-4v-2h4v-4h2z" fill="currentColor" />
    <path
      d="m12 20c4.4183 0 8-3.5817 8-8 0-4.4183-3.5817-8-8-8-4.4183 0-8 3.5817-8 8 0 4.4183 3.5817 8 8 8zm0 2c5.5228 0 10-4.4772 10-10 0-5.5228-4.4772-10-10-10-5.5228 0-10 4.4772-10 10 0 5.5228 4.4772 10 10 10z"
      clipRule="evenodd"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const PlusSquareOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M11 13V16H13V13H16V11H13V8H11V11H8V13H11Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 9.8C3 7.18126 3 5.87188 3.58944 4.91001C3.91926 4.37178 4.37178 3.91926 4.91001 3.58944C5.87188 3 7.18126 3 9.8 3H14.2C16.8187 3 18.1281 3 19.09 3.58944C19.6282 3.91926 20.0807 4.37178 20.4106 4.91001C21 5.87188 21 7.18126 21 9.8V14.2C21 16.8187 21 18.1281 20.4106 19.09C20.0807 19.6282 19.6282 20.0807 19.09 20.4106C18.1281 21 16.8187 21 14.2 21H9.8C7.18126 21 5.87188 21 4.91001 20.4106C4.37178 20.0807 3.91926 19.6282 3.58944 19.09C3 18.1281 3 16.8187 3 14.2V9.8ZM9.8 5H14.2C15.5481 5 16.4187 5.00211 17.077 5.0647C17.7055 5.12446 17.9311 5.22494 18.045 5.29472C18.3141 5.45963 18.5404 5.68589 18.7053 5.955C18.7751 6.06888 18.8755 6.29446 18.9353 6.92299C18.9979 7.58127 19 8.4519 19 9.8V14.2C19 15.5481 18.9979 16.4187 18.9353 17.077C18.8755 17.7055 18.7751 17.9311 18.7053 18.045C18.5404 18.3141 18.3141 18.5404 18.045 18.7053C17.9311 18.7751 17.7055 18.8755 17.077 18.9353C16.4187 18.9979 15.5481 19 14.2 19H9.8C8.4519 19 7.58127 18.9979 6.92299 18.9353C6.29446 18.8755 6.06888 18.7751 5.955 18.7053C5.68589 18.5404 5.45963 18.3141 5.29472 18.045C5.22494 17.9311 5.12446 17.7055 5.0647 17.077C5.00211 16.4187 5 15.5481 5 14.2V9.8C5 8.4519 5.00211 7.58127 5.0647 6.92299C5.12446 6.29446 5.22494 6.06888 5.29472 5.955C5.45963 5.68589 5.68589 5.45963 5.955 5.29472C6.06888 5.22494 6.29446 5.12446 6.92299 5.0647C7.58127 5.00211 8.4519 5 9.8 5Z"
      fill="currentColor"
    />
  </svg>
);

export const POIFitness = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.721 10.167c.06-1.217.17-2.771.331-4.661a.917.917 0 0 1 .914-.84h.177c.468 0 .86.352.912.816a58.979 58.979 0 0 1 0 13.036.917.917 0 0 1-.912.815h-.177a.917.917 0 0 1-.914-.839c-.16-1.89-.27-3.444-.33-4.66H8.276c-.06 1.205-.17 2.758-.33 4.66a.917.917 0 0 1-.914.84h-.177a.917.917 0 0 1-.91-.816 58.985 58.985 0 0 1 0-13.036.917.917 0 0 1 .91-.815h.177c.477 0 .874.365.914.84.16 1.901.27 3.454.33 4.66h7.444ZM2.426 13.833h-.25c-.41 0-.558-.042-.707-.122a.833.833 0 0 1-.347-.347c-.08-.149-.122-.297-.122-.706v-1.316c0-.409.043-.557.122-.706a.833.833 0 0 1 .347-.347c.15-.08.297-.122.706-.122h.25c.054-.96.15-1.92.287-2.88a.917.917 0 0 1 .907-.787h.131c.506 0 .917.41.917.917v9.166c0 .507-.41.917-.917.917h-.131a.917.917 0 0 1-.907-.787c-.138-.96-.233-1.92-.286-2.88Zm19.148-3.666h.25c.41 0 .558.042.707.122.15.08.267.197.347.347.08.15.122.297.122.706v1.316c0 .409-.043.557-.122.707a.833.833 0 0 1-.347.346c-.15.08-.297.122-.706.122h-.25c-.054.96-.15 1.92-.287 2.88a.917.917 0 0 1-.907.787h-.131a.917.917 0 0 1-.917-.917V7.417c0-.507.41-.917.917-.917h.131c.456 0 .843.336.907.787.138.96.233 1.92.286 2.88Z"
      fill="currentColor"
    />
  </svg>
);

export const POIHome = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.917 9.833 12 1.5 2.083 9.833 2.5 11.5h1v7a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-7h1l.417-1.667ZM14 7.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-5 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7H9v-7Z"
      fill="currentColor"
    />
  </svg>
);

export const POIPinFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 10a10 10 0 0 1-6.56 9.4h-.02a5.05 5.05 0 0 0-2.46 2.62L12 24l-.96-1.98c-.14-.28-.2-.43-.28-.56a5.05 5.05 0 0 0-2.18-2.06h-.02A10 10 0 1 1 22 10Zm-10 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
      clipRule="evenodd"
    />
  </svg>
);

export const POIPinOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m14.65 17.55.1-.03a8 8 0 1 0-5.5 0l.1.03.1.05c1.01.5 1.88 1.22 2.55 2.11a7.05 7.05 0 0 1 2.54-2.1l.11-.06Zm-1.54 4.16-.15.31L12 24l-.96-1.98-.15-.31-.13-.25a5.05 5.05 0 0 0-2.18-2.06h-.02a10 10 0 1 1 6.88 0h-.02a5.05 5.05 0 0 0-2.18 2.06m0 0-.13.25.13-.25Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4-2a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export const POIUniversity = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      d="m11.568 2.108-10.3 5.436a.524.524 0 0 0 0 .912l10.3 5.436a.921.921 0 0 0 .864 0l4.875-2.572-5.226-2.412a1 1 0 0 1-.336-1.564l6.244 2.974a2.3 2.3 0 0 1 1.311 2.076v1.892a1 1 0 1 0 1.4 0v-1.892c0-.896-.323-1.742-.883-2.399l2.916-1.539a.524.524 0 0 0 0-.912l-10.3-5.436a.921.921 0 0 0-.865 0Z"
      fill="currentColor"
    />
    <path
      d="M18 12.5v.678c-.677 1.666-1.82 4.76-1.986 7.02-1.098.471-2.432.802-4.014.802-5.5 0-8-4-8-4v-5.5l7.284 3.642c.263.131.394.197.532.223a.998.998 0 0 0 .368 0c.138-.026.27-.092.532-.223L18 12.5ZM21.548 16.267A1.996 1.996 0 0 1 20 17a1.996 1.996 0 0 1-1.548-.733c-.428 1.104-.952 2.756-.952 4.233 0 0 1 1.5 2.5 1.5s2.5-1.5 2.5-1.5c0-1.477-.524-3.129-.952-4.233Z"
      fill="currentColor"
    />
  </svg>
);

export const POIWork = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 5h6a4 4 0 1 1 8 0h6v3.964l-.003.015a1.054 1.054 0 0 1-.078.23c-.098.213-.33.58-.882.982C19.909 11.011 17.409 12 12 12c-5.409 0-7.91-.989-9.037-1.809-.553-.402-.784-.769-.882-.983A1.048 1.048 0 0 1 2 8.964V5Zm10-2a2 2 0 0 0-2 2h4a2 2 0 0 0-2-2Z"
      fill="currentColor"
    />
    <path
      d="M2 11.957V18a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6.043c-1.447.968-3.881 1.795-8 1.996V16h-4v-2.047c-4.119-.201-6.553-1.028-8-1.996Z"
      fill="currentColor"
    />
  </svg>
);

export const POIWorkOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1a4 4 0 0 0-4 4H2v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V5h-6a4 4 0 0 0-4-4Zm0 2a2 2 0 0 0-2 2h4a2 2 0 0 0-2-2Zm8 5.977V7H4v1.977l.005.036c.008.05.027.142.072.26.087.234.28.595.712.98C5.66 11.026 7.627 12 12 12s6.34-.974 7.21-1.747c.434-.385.626-.746.713-.98A1.373 1.373 0 0 0 20 8.978Zm-10 4.952c-2.91-.216-4.789-.907-6-1.756V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4.827c-1.211.849-3.09 1.54-6 1.756V16h-4v-2.07Z"
      clipRule="evenodd"
    />
  </svg>
);

export const QRCode = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 6c0-.93 0-1.4.15-1.77a2 2 0 0 1 1.08-1.08C4.6 3 5.07 3 6 3s1.4 0 1.77.15a2 2 0 0 1 1.08 1.08C9 4.6 9 5.07 9 6s0 1.4-.15 1.77a2 2 0 0 1-1.08 1.08C7.4 9 6.93 9 6 9s-1.4 0-1.77-.15a2 2 0 0 1-1.08-1.08C3 7.4 3 6.93 3 6Zm3 1-.96-.01h-.02v-.03C5 6.76 5 6.49 5 6l.01-.96v-.02h.03C5.24 5 5.51 5 6 5l.96.01h.02v.03c.02.2.02.47.02.96l-.01.96v.02h-.03C6.76 7 6.49 7 6 7ZM15 6c0-.93 0-1.4.15-1.77a2 2 0 0 1 1.08-1.08C16.6 3 17.07 3 18 3s1.4 0 1.77.15a2 2 0 0 1 1.08 1.08C21 4.6 21 5.07 21 6s0 1.4-.15 1.77a2 2 0 0 1-1.08 1.08C19.4 9 18.93 9 18 9s-1.4 0-1.77-.15a2 2 0 0 1-1.08-1.08C15 7.4 15 6.93 15 6Zm3 1-.96-.01h-.02v-.03C17 6.76 17 6.49 17 6l.01-.96v-.02h.03c.2-.02.47-.02.96-.02l.96.01h.02v.03c.02.2.02.47.02.96l-.01.96v.02h-.03c-.2.02-.47.02-.96.02ZM3.15 16.23C3 16.6 3 17.07 3 18s0 1.4.15 1.77a2 2 0 0 0 1.08 1.08C4.6 21 5.07 21 6 21s1.4 0 1.77-.15a2 2 0 0 0 1.08-1.08C9 19.4 9 18.93 9 18s0-1.4-.15-1.77a2 2 0 0 0-1.08-1.08C7.4 15 6.93 15 6 15s-1.4 0-1.77.15a2 2 0 0 0-1.08 1.08ZM5.05 19 6 19l.96-.01h.02v-.03c.02-.2.02-.47.02-.96l-.01-.96v-.02h-.03C6.76 17 6.49 17 6 17l-.96.01h-.02v.03c-.02.2-.02.47-.02.96l.01.96v.02h.03Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M13 3h-2v6c0 .48 0 .79-.02 1.03-.01.22-.04.31-.06.35a1 1 0 0 1-.54.54c-.04.02-.13.05-.35.06C9.79 11 9.48 11 9 11H3v2h6.03c.44 0 .82 0 1.13-.02.33-.02.66-.07.99-.2a3 3 0 0 0 1.62-1.63c.14-.33.19-.66.2-.99.03-.31.03-.69.03-1.13V3ZM18.97 11H21v2h-2c-.48 0-.79 0-1.03.02-.22.01-.31.04-.35.06a1 1 0 0 0-.54.54c-.02.04-.05.13-.06.35-.02.24-.02.55-.02 1.03v2h-2v-2.03c0-.44 0-.82.02-1.13.02-.33.07-.66.2-.99a3 3 0 0 1 1.63-1.62c.33-.14.66-.19.99-.2.31-.03.69-.03 1.13-.03Z"
    />
    <path
      fill="currentColor"
      d="M17.03 21c.44 0 .82 0 1.13-.02.33-.02.66-.07.99-.2a3 3 0 0 0 1.62-1.63c.14-.33.19-.66.2-.99.03-.31.03-.69.03-1.13V15h-2v2c0 .48 0 .79-.02 1.03-.01.22-.04.31-.06.35a1 1 0 0 1-.54.54c-.04.02-.13.05-.35.06-.24.02-.55.02-1.03.02h-2c-.48 0-.79 0-1.03-.02a1.16 1.16 0 0 1-.35-.06 1 1 0 0 1-.54-.54 1.16 1.16 0 0 1-.06-.35C13 17.79 13 17.48 13 17v-2h-2v2.03c0 .44 0 .82.02 1.13.02.33.07.66.2.99a3 3 0 0 0 1.63 1.62c.33.14.66.19.99.2.31.03.69.03 1.13.03h2.06Z"
    />
  </svg>
);

export const QuestionFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm3.1 4.4c.296.277.526.62.673 1 .152.426.228.877.225 1.33a3.07 3.07 0 0 1-.183 1.167 3.014 3.014 0 0 1-.607 1.003 4.098 4.098 0 0 1-.732.65l-.722.51c-.208.138-.357.303-.524.49a.853.853 0 0 0-.176.281.874.874 0 0 0-.064.33v.34h-2v-.33a2.761 2.761 0 0 1 .21-1.13c.13-.281.305-.538.516-.76.203-.215.432-.4.683-.55.235-.151.46-.318.673-.5a2.49 2.49 0 0 0 .517-.6c.154-.274.228-.586.214-.9 0-.184-.027-.365-.078-.54a1.238 1.238 0 0 0-.285-.47c-.421-.335-.794-.472-1.447-.472-.654 0-1.042.137-1.453.461a1.196 1.196 0 0 0-.267.47c-.056.174-.083.7-.078.883H8c-.003-.454.073-1.247.224-1.673.145-.383.375-.725.673-1a3.091 3.091 0 0 1 1.132-.65 7.478 7.478 0 0 1 1.95-.24 7.621 7.621 0 0 1 1.951.24c.432.13.832.356 1.17.66Zm-1.35 10.595a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
      fill="currentColor"
    />
  </svg>
);

export const QuestionOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M15.783 7.902a2.724 2.724 0 0 0-.673-1 3.09 3.09 0 0 0-1.17-.66 7.62 7.62 0 0 0-1.95-.24 7.477 7.477 0 0 0-1.951.24 3.091 3.091 0 0 0-1.132.65 2.612 2.612 0 0 0-.673 1c-.151.426-.227 1.219-.224 1.672h2.194c-.004-.183.023-.708.079-.882.05-.176.145-.337.267-.47.411-.324.8-.462 1.453-.462s1.026.137 1.447.472c.122.133.234.294.285.47.051.175.078.357.078.54.014.315-.06.627-.214.9a2.49 2.49 0 0 1-.517.6c-.213.182-.438.35-.673.5-.25.151-.48.336-.683.55-.211.223-.386.48-.517.76a2.763 2.763 0 0 0-.209 1.13v.33h2v-.34a.874.874 0 0 1 .064-.33c.04-.104.1-.2.176-.28.167-.188.316-.353.524-.49l.722-.51c.268-.186.514-.404.732-.65.265-.29.472-.631.607-1.004a3.07 3.07 0 0 0 .183-1.166 3.88 3.88 0 0 0-.225-1.33ZM13.5 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.929 4.929A10 10 0 1 1 19.07 19.07 10 10 0 0 1 4.93 4.93ZM12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
      fill="currentColor"
    />
  </svg>
);

export const Refresh = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 9a.75.75 0 0 1-.697-1.026l1.862-4.705a.75.75 0 0 1 1.318-.145l.9 1.328a9 9 0 1 1-3.94 9.234 1 1 0 0 1 1.967-.373 7 7 0 1 0 3.096-7.205l1.167 1.721A.75.75 0 0 1 8.803 9H3.749Z"
      fill="currentColor"
    />
  </svg>
);

export const Route = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m23 8.98-.768 6.692-2.092-1.785-3.558 4.311c-1.635 1.982-4.374 2.392-6.104.915s-1.809-4.29-.174-6.27l2.372-2.875c.98-1.189.997-2.823.035-3.644-.962-.82-2.542-.52-3.523.668l-3.074 3.725a2.84 2.84 0 0 1-.275 3.214c-.982 1.19-2.715 1.357-3.871.37-1.156-.986-1.296-2.75-.314-3.94a2.73 2.73 0 0 1 3.065-.834L7.793 5.8c1.635-1.98 4.373-2.391 6.104-.914s1.809 4.29.174 6.27l-2.372 2.875c-.98 1.189-.997 2.823-.035 3.644.962.82 2.542.52 3.523-.668l3.557-4.311-2.092-1.786z"
      clipRule="evenodd"
    />
  </svg>
);

export const RubFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C17.4706 22 22 17.4608 22 12C22 6.52941 17.4608 2 11.9902 2C6.52941 2 2 6.52941 2 12C2 17.4608 6.53922 22 12 22ZM10.2941 17.0588C9.90196 17.0588 9.61765 16.7843 9.61765 16.3922V15.3726H8.73529C8.44118 15.3726 8.23529 15.1667 8.23529 14.8726C8.23529 14.5882 8.44118 14.3726 8.73529 14.3726H9.61765V13.3922H8.72549C8.42157 13.3922 8.22549 13.1667 8.22549 12.8824C8.22549 12.598 8.42157 12.3824 8.72549 12.3824H9.61765V8.03922C9.61765 7.63726 9.88235 7.36275 10.2843 7.36275H12.6765C14.5686 7.36275 15.7549 8.63726 15.7549 10.3725C15.7549 12.1275 14.5588 13.3824 12.6667 13.3824H10.9412V14.3726H13.3039C13.598 14.3726 13.7941 14.5882 13.7941 14.8726C13.7941 15.1667 13.598 15.3726 13.3039 15.3726H10.9412V16.3922C10.9412 16.7843 10.6765 17.0588 10.2941 17.0588ZM10.951 12.1961L12.4412 12.2157C13.7451 12.2157 14.4216 11.5098 14.4216 10.3824C14.4216 9.27451 13.7549 8.57843 12.4412 8.57843H10.951V12.1961Z"
      fill="currentColor"
    />
  </svg>
);

export const Rudder = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 19.75V18a4 4 0 0 0-4-4H4.25A8.01 8.01 0 0 0 10 19.75Zm-7.92-6.5.12.75a9.96 9.96 0 0 0 9.8 8 10 10 0 1 0-9.92-8.75ZM4.06 11a8 8 0 0 1 15.88 0 11.95 11.95 0 0 0-15.88 0Zm15.69 3H18a4 4 0 0 0-4 4v1.75A8.01 8.01 0 0 0 19.75 14ZM14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Safety = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 20.15c-3.074-1.977-4.526-3.078-5.233-4.274C6.03 14.628 6 13.656 6 12.615V5.159c.334-.058.707-.12 1.106-.183C8.683 4.729 10.557 4.5 12 4.5v15.65M20 3.5s-4.792-1-8-1-8 1-8 1v9.115c0 2.291.121 5.155 8 9.885 7.879-4.73 8-7.594 8-9.885z"
      clipRule="evenodd"
    />
  </svg>
);

export const Sale = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m21.4 11.4-8.8-8.8a2 2 0 0 0-1.4-.6H4a2 2 0 0 0-2 2v7.2c0 .5.2 1 .6 1.4l8.8 8.8c.8.8 2 .8 2.8 0l7.2-7.2c.8-.7.8-2 0-2.8ZM6.5 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
    />
  </svg>
);

export const SBPColor = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10.5 13.195 2.939 1.932v3.585L10.486 24l.014-10.805Z"
      fill="#62B22F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.063 11.668 2.932 1.7-8.705 5.287 2.841-5.172 2.932-1.815Z"
      fill="#974995"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m21.737 6.783-5.602-.028-2.699-1.622L10.504 0l11.233 6.783Z"
      fill="#EE7024"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10.503 0 2.933 5.133.006 7.072-2.956-.903L10.503 0Z"
      fill="#FBB61B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m2.266 5.164 2.875 5.226-.01 3.093-2.841 5.172-.024-13.491Z"
      fill="#5A58A3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.266 5.164 21.693 17.05l-5.567.04-10.985-6.7-2.875-5.226Z"
      fill="#2188CB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m16.135 6.755 5.602.028-8.292 5.098-.008-3.482 2.698-1.644Z"
      fill="#DA0954"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m13.439 18.712 2.687-1.623 5.567-.039L10.486 24l2.953-5.288Z"
      fill="#037F37"
    />
  </svg>
);

export const Scooter = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.13 4.67A2 2 0 0 0 15.15 3H11.5v2h3.65l1.7 10.23A3 3 0 0 0 15.18 17H8.83a3 3 0 1 0 0 2h6.34a3 3 0 1 0 3.7-3.87L17.13 4.67ZM7 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm11 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Search = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.762 17.176a8.5 8.5 0 1 1 1.414-1.414l4.827 4.827-1.414 1.414zM17 10.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
      clipRule="evenodd"
    />
  </svg>
);

export const SelectionTool = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M18 3a2.998 2.998 0 0 1 1 5.825v6.349A2.998 2.998 0 1 1 15.174 19H8.826A2.998 2.998 0 1 1 5 15.174V8.825A2.998 2.998 0 1 1 8.826 5h6.348c.412-1.165 1.52-2 2.826-2zM6 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM8.826 7A3.002 3.002 0 0 1 7 8.825v6.349A3.003 3.003 0 0 1 8.826 17h6.348A3.003 3.003 0 0 1 17 15.174V8.825A3.002 3.002 0 0 1 15.174 7H8.826zM6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
    />
  </svg>
);

export const Settings2Fill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="m19.4 11.09 2.22-2.36-2-3.46-3.15.73a8.002 8.002 0 0 0-1.58-.91L13.96 2h-4l-.93 3.11A7.43 7.43 0 0 0 7.45 6L4.3 5.27l-2 3.46 2.22 2.36a7.91 7.91 0 0 0 0 1.82L2.3 15.27l2 3.46L7.45 18c.491.363 1.021.668 1.58.91L9.96 22h4l.93-3.11a7.431 7.431 0 0 0 1.58-.9l3.15.74 2-3.46-2.22-2.36c.07-.605.07-1.215 0-1.82ZM11.96 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
      fill="currentColor"
    />
  </svg>
);

export const Settings2Outline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m2 0a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 2h4l1.42 2.76q.635.292 1.21.69l3.07-.18 2 3.46L20 11.3v1.4l1.66 2.57-2 3.46-3.07-.18a8 8 0 0 1-1.21.69L14 22h-4l-1.42-2.76a8 8 0 0 1-1.21-.69l-3.07.18-2-3.46L4 12.7v-1.4L2.34 8.73l2-3.46 3.07.18a8 8 0 0 1 1.21-.69zm3.59 3.65L12.76 4h-1.52l-.82 1.61-.31.62-.63.3a6 6 0 0 0-.91.52l-.57.4h-.7l-1.84-.11-.76 1.32 1 1.54.36.58-.06.69a4.7 4.7 0 0 0 0 1.06l.09.65-.39.58-1 1.54.76 1.32 1.84-.11H8l.56.4q.433.299.91.52l.63.3.31.62.83 1.65h1.52l.83-1.57.31-.62.63-.3q.477-.221.91-.52l.57-.4h.7l1.84.11.76-1.32-1-1.54-.39-.58.06-.69q.06-.53 0-1.06l-.06-.69.39-.58 1-1.54-.76-1.32-1.84.11h-.7l-.57-.4a6 6 0 0 0-.91-.52l-.63-.3z"
      clipRule="evenodd"
    />
  </svg>
);

export const SettingsFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 4c.439 0 .85 0 1.162.021.33.023.66.072.986.207a3 3 0 0 1 1.624 1.624c.135.326.184.656.207.986l.009.162H22v2h-2.012l-.01.162c-.022.33-.071.66-.206.986a3 3 0 0 1-1.624 1.624 3.1 3.1 0 0 1-.986.207C16.85 12 16.44 12 16 12s-.85 0-1.162-.021a3.1 3.1 0 0 1-.986-.207 3 3 0 0 1-1.624-1.624 3 3 0 0 1-.207-.986A18 18 0 0 1 12 8.054V9H2V7h10v.946c0-.419 0-.808.021-1.108.023-.33.072-.66.207-.986a3 3 0 0 1 1.624-1.624c.326-.135.656-.184.986-.207C15.15 4 15.56 4 16 4m-8 8c-.439 0-.85 0-1.162.021a3 3 0 0 0-.986.207 3 3 0 0 0-1.624 1.624 3 3 0 0 0-.207.986L4.012 15H2v2h2.012l.01.162c.022.33.071.66.206.986a3 3 0 0 0 1.624 1.624c.326.135.656.184.986.207C7.15 20 7.56 20 8 20s.85 0 1.162-.021c.33-.023.66-.072.986-.207a3 3 0 0 0 1.624-1.624 3 3 0 0 0 .207-.986c.02-.3.021-.69.021-1.107V17h10v-2H12v.945c0-.418 0-.807-.021-1.107a3 3 0 0 0-.207-.986 3 3 0 0 0-1.624-1.624 3 3 0 0 0-.986-.207C8.85 12 8.44 12 8 12"
      clipRule="evenodd"
    />
  </svg>
);

export const SettingsOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 4c.439 0 .85 0 1.162.021.33.023.66.072.986.207a3 3 0 0 1 1.624 1.624c.135.326.184.656.207.986l.009.162H22v2h-2.012l-.01.162c-.022.33-.071.66-.206.986a3 3 0 0 1-1.624 1.624 3.1 3.1 0 0 1-.986.207C16.85 12 16.44 12 16 12s-.85 0-1.162-.021a3.1 3.1 0 0 1-.986-.207 3 3 0 0 1-1.624-1.624 3 3 0 0 1-.207-.986L12.012 9H2V7h10.012l.01-.162c.022-.33.071-.66.206-.986a3 3 0 0 1 1.624-1.624c.326-.135.656-.184.986-.207C15.15 4 15.56 4 16 4m-1.026 2.017c-.228.015-.315.042-.357.06a1 1 0 0 0-.54.54c-.018.042-.045.129-.06.357C14 7.21 14 7.52 14 8s0 .79.017 1.026c.015.228.042.315.06.357a1 1 0 0 0 .54.54c.042.018.129.045.357.06C15.21 10 15.52 10 16 10s.79 0 1.026-.017c.228-.015.315-.042.357-.06a1 1 0 0 0 .54-.54c.018-.042.045-.129.06-.357C18 8.79 18 8.48 18 8s0-.79-.017-1.026c-.015-.228-.042-.315-.06-.357a1 1 0 0 0-.54-.54c-.042-.018-.129-.045-.357-.06A17 17 0 0 0 16 6c-.48 0-.79 0-1.026.017M4.012 15H2v2h2.012l.01.162c.022.33.071.66.206.986a3 3 0 0 0 1.624 1.624c.326.135.656.184.986.207C7.15 20 7.56 20 8 20s.85 0 1.162-.021c.33-.023.66-.072.986-.207a3 3 0 0 0 1.624-1.624c.135-.326.184-.656.207-.986l.009-.162H22v-2H11.988l-.01-.162a3.1 3.1 0 0 0-.206-.986 3 3 0 0 0-1.624-1.624 3 3 0 0 0-.986-.207C8.85 12 8.44 12 8 12s-.85 0-1.162.021a3 3 0 0 0-.986.207 3 3 0 0 0-1.624 1.624 3 3 0 0 0-.207.986zm2.605-.924c.042-.017.129-.044.357-.06C7.21 14.002 7.52 14 8 14s.79 0 1.026.017c.228.015.315.042.357.06a1 1 0 0 1 .54.54c.018.042.045.129.06.357C10 15.21 10 15.52 10 16s0 .79-.017 1.026c-.015.228-.042.315-.06.357a1 1 0 0 1-.54.54c-.042.018-.129.045-.357.06C8.79 18 8.48 18 8 18s-.79 0-1.026-.017c-.228-.015-.315-.042-.357-.06a1 1 0 0 1-.54-.54c-.018-.042-.045-.129-.06-.357A17 17 0 0 1 6 16c0-.48 0-.79.017-1.026.015-.228.042-.315.06-.357a1 1 0 0 1 .54-.54"
      clipRule="evenodd"
    />
  </svg>
);

export const ShoppingBagOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M10 9H8V12H10V9Z" fill="currentColor" />
    <path d="M16 9H14V12H16V9Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1C9.79086 1 8 2.79086 8 5H4.00097L3.68263 15.8236C3.62637 17.7365 3.59824 18.693 3.89197 19.4489C4.28363 20.4567 5.06661 21.2631 6.06249 21.6842C6.8094 22 7.76628 22 9.68004 22H14.3219C16.2357 22 17.1925 22 17.9395 21.6842C18.9353 21.2631 19.7183 20.4567 20.11 19.4489C20.4037 18.693 20.3756 17.7365 20.3193 15.8236L20.001 5H16C16 2.79086 14.2091 1 12 1ZM12 3C10.8954 3 10 3.89543 10 5H14C14 3.89543 13.1046 3 12 3ZM5.94301 7L5.68177 15.8824C5.65282 16.8666 5.6352 17.5034 5.65449 17.9911C5.67309 18.4614 5.72338 18.6401 5.75616 18.7244C5.95199 19.2284 6.34348 19.6315 6.84142 19.8421C6.92476 19.8773 7.10194 19.9329 7.57146 19.9653C8.05838 19.9989 8.69539 20 9.68004 20H14.3219C15.3066 20 15.9436 19.9989 16.4305 19.9653C16.9 19.9329 17.0772 19.8773 17.1605 19.8421C17.6585 19.6315 18.05 19.2284 18.2458 18.7244C18.2786 18.6401 18.3289 18.4614 18.3475 17.9911C18.3667 17.5034 18.3491 16.8666 18.3202 15.8824L18.0589 7H5.94301Z"
      fill="currentColor"
    />
  </svg>
);

export const SignalLight = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm.635-14.44V5.64A.65.65 0 0 0 11.997 5a.644.644 0 0 0-.632.639V7.56c0 .344.288.632.632.632a.644.644 0 0 0 .638-.632Zm-5.614.351 1.333 1.347c.238.244.651.244.89.006a.633.633 0 0 0 .005-.895L7.916 7.022a.638.638 0 0 0-.895-.006.639.639 0 0 0 0 .895Zm9.019-.839L14.694 8.42a.64.64 0 0 0 0 .895.652.652 0 0 0 .901-.006l1.34-1.34a.647.647 0 0 0-.006-.902.63.63 0 0 0-.89.006Zm.407 5.567h1.915A.65.65 0 0 0 19 12a.644.644 0 0 0-.638-.632h-1.915a.644.644 0 0 0-.639.632.65.65 0 0 0 .639.639ZM7.56 11.368H5.638A.64.64 0 0 0 5 12c0 .344.288.639.638.639H7.56A.65.65 0 0 0 8.198 12a.644.644 0 0 0-.638-.632Zm9.375 4.664-1.346-1.346a.644.644 0 0 0-.895.006.64.64 0 0 0 0 .896l1.346 1.346a.658.658 0 0 0 .901-.007.645.645 0 0 0-.006-.895Zm-8.53-1.34-1.34 1.34a.643.643 0 0 0-.012.89c.244.244.663.25.901.012l1.346-1.34a.639.639 0 0 0 0-.895.644.644 0 0 0-.895-.007Zm4.23 3.67v-1.923a.644.644 0 0 0-.638-.632.639.639 0 0 0-.632.632v1.922c0 .345.288.639.632.639a.65.65 0 0 0 .638-.639Z"
      fill="currentColor"
    />
  </svg>
);

export const SoundOffFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 2c2.21 0 4 4.477 4 10s-1.79 10-4 10c-.628 0-1.223-.362-1.752-1.008C7.918 19.368 7 15.952 7 12c0-3.97.925-7.399 2.266-9.014C9.79 2.354 10.379 2 11 2ZM9.2 9.001A21.95 21.95 0 0 0 9 12c0 1.067.072 2.077.2 3.001h.4c.663 0 1.2-1.343 1.2-3 0-1.656-.537-3-1.2-3h-.4Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M6.519 5.081C5.869 7.01 5.5 9.423 5.5 12s.369 4.992 1.019 6.92L4 17H3c-1.105 0-2-2.239-2-5s.895-5 2-5h1l2.519-1.919ZM23.071 9.879 20.951 12l2.12 2.121-1.414 1.414-2.122-2.12-2.12 2.12L16 14.121 18.121 12 16 9.879l1.414-1.414 2.121 2.12 2.122-2.12 1.414 1.414Z"
    />
  </svg>
);

export const SoundOffOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M23.071 9.879 20.951 12l2.12 2.121-1.414 1.414-2.122-2.12-2.12 2.12L16 14.121 18.121 12 16 9.879l1.414-1.414 2.121 2.12 2.122-2.12 1.414 1.414Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.073 2.002C13.25 2.1 15 6.538 15 12s-1.751 9.9-3.927 9.998a1.486 1.486 0 0 1-.063.002H11c-.625 0-1.225-.36-1.752-1L5 17H3c-1.105 0-2-2.239-2-5s.895-5 2-5h2l4.248-4 .001.006.003-.003.004-.005C9.783 2.358 10.375 2 11 2c.024 0 .049 0 .073.002ZM7 12c0 1.637.157 3.183.437 4.547L5.793 15H3.534a2.951 2.951 0 0 1-.092-.207C3.196 14.178 3 13.191 3 12s.196-2.178.442-2.793c.032-.08.063-.148.092-.207h2.26l1.643-1.547A22.908 22.908 0 0 0 7 12Zm3.896-7.84.01-.01c.036-.037.067-.067.094-.09.019.016.04.036.065.06l.039.04c.061.065.128.144.197.238.207.283.441.7.67 1.274C12.58 7.192 13 9.428 13 12c0 2.572-.42 4.808-1.028 6.328-.306.765-.621 1.25-.868 1.512-.04.042-.075.075-.104.1a1.414 1.414 0 0 1-.094-.09l-.01-.01-.038-.041a2.29 2.29 0 0 1-.062-.073l-.007-.01c-.227-.279-.497-.73-.76-1.388-.356-.89-.648-2.024-.829-3.328h.4c.663 0 1.2-1.344 1.2-3s-.537-3-1.2-3h-.4c.18-1.304.473-2.439.828-3.328.264-.658.534-1.11.761-1.389l.007-.009.062-.073.037-.039.002-.002Z"
    />
  </svg>
);

export const Sound1Outline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 7H7.00034L11.2479 3L11.2493 3.00612L11.2502 3.00503L11.2514 3.00364L11.2517 3.00321L11.2554 2.99876L11.2558 2.99822C11.7829 2.35868 12.3747 2 13 2C13.0244 2 13.0487 2.00055 13.073 2.00163C15.2485 2.099 17 6.53814 17 12C17 17.4619 15.2485 21.901 13.073 21.9984C13.0519 21.9993 13.0307 21.9999 13.0095 22L13 22C12.3747 22 11.783 21.6413 11.2558 21.0018L11.2518 20.997L11.2514 20.9964L9.13907 16.2671L9.4365 16.5472C9.15743 15.183 9 13.6375 9 12C9 10.3627 9.1574 8.81723 9.43644 7.45313L7.79382 9H5.89328L5 7ZM5.89321 9L5 7C3.89543 7 3 9.23858 3 12C3 14.7614 3.89543 17 5 17H7L11.2479 21L11.2493 20.9939L11.2502 20.9949L9.13846 16.2665L9.13907 16.2671L5.89328 9H5.89321ZM5.89321 9L9.13846 16.2665L7.79344 15H5.53443C5.50551 14.9413 5.47462 14.8725 5.44274 14.7928C5.19681 14.1779 5 13.1914 5 12C5 10.8086 5.19681 9.82207 5.44274 9.20725C5.47462 9.12754 5.50551 9.05869 5.53443 9H5.89321ZM12.8581 19.7985C12.8382 19.7762 12.8173 19.7519 12.7955 19.7253L12.7889 19.7172C12.5615 19.4378 12.2919 18.9867 12.0285 18.3283C11.6728 17.4389 11.3811 16.3039 11.2004 14.9998L11.2118 14.9998L11.6002 15C12.2629 15 12.8002 13.6568 12.8002 12C12.8002 10.3431 12.2629 8.99998 11.6002 8.99998L11.2005 8.99978C11.3812 7.69586 11.6728 6.56103 12.0285 5.67171C12.2919 5.01328 12.5615 4.56222 12.7889 4.28279L12.7955 4.27469C12.8173 4.24811 12.8382 4.22377 12.8581 4.20151C12.8709 4.18712 12.8836 4.1733 12.8961 4.16007L12.9065 4.14918C12.9419 4.11233 12.9734 4.08288 13.0003 4.05958C13.0192 4.07609 13.0406 4.09588 13.0644 4.11953C13.0769 4.13195 13.09 4.14543 13.1039 4.16007C13.1656 4.22534 13.2316 4.30462 13.3006 4.39879C13.5075 4.68127 13.7419 5.09769 13.9715 5.67171C14.5793 7.19136 15 9.42788 15 12C15 14.5721 14.5793 16.8086 13.9715 18.3283C13.6653 19.0937 13.3508 19.5788 13.1039 19.8399C13.0637 19.8824 13.0292 19.9152 13.0003 19.9404C12.9734 19.9171 12.9419 19.8877 12.9065 19.8508L12.8961 19.8399C12.8836 19.8267 12.8709 19.8129 12.8581 19.7985ZM12.8909 3.98216C12.8909 3.98184 12.8944 3.98303 12.9013 3.98668C12.8944 3.98431 12.8909 3.98248 12.8909 3.98216ZM12.8909 20.0178C12.8909 20.0175 12.8944 20.0157 12.9013 20.0133C12.8944 20.017 12.8909 20.0182 12.8909 20.0178ZM18.9565 11.9905C18.9545 10.9369 18.6198 9.91084 18 9.0588L19.6174 7.88232C20.4851 9.07518 20.9537 10.5117 20.9565 11.9867C20.9593 13.4618 20.4961 14.9 19.633 16.0961L18.0111 14.9258C18.6277 14.0714 18.9585 13.0441 18.9565 11.9905Z"
      fill="currentColor"
    />
  </svg>
);

export const Sound2Outline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7H5.00034L9.24794 3L9.24932 3.00612L9.25021 3.00503L9.25136 3.00364L9.25171 3.00321L9.25537 2.99876L9.25581 2.99822C9.78295 2.35868 10.3747 2 11 2C11.0244 2 11.0487 2.00055 11.073 2.00163C13.2485 2.099 15 6.53814 15 12C15 17.4619 13.2485 21.901 11.073 21.9984C11.0519 21.9993 11.0307 21.9999 11.0095 22L11 22C10.3747 22 9.78295 21.6413 9.25581 21.0018L9.25185 20.997L9.25136 20.9964L7.13907 16.2671L7.4365 16.5472C7.15743 15.183 7 13.6375 7 12C7 10.3627 7.1574 8.81723 7.43644 7.45313L5.79382 9H3.89328L3 7ZM3.89321 9L3 7C1.89543 7 1 9.23858 1 12C1 14.7614 1.89543 17 3 17H5L9.24794 21L9.24932 20.9939L9.25018 20.9949L7.13846 16.2665L7.13907 16.2671L3.89328 9H3.89321ZM3.89321 9L7.13846 16.2665L5.79344 15H3.53443C3.50551 14.9413 3.47462 14.8725 3.44274 14.7928C3.19681 14.1779 3 13.1914 3 12C3 10.8086 3.19681 9.82207 3.44274 9.20725C3.47462 9.12754 3.50551 9.05869 3.53443 9H3.89321ZM10.8581 19.7985C10.8382 19.7762 10.8173 19.7519 10.7955 19.7253L10.7889 19.7172C10.5615 19.4378 10.2919 18.9867 10.0285 18.3283C9.67276 17.4389 9.38112 16.3039 9.20041 14.9998L9.21184 14.9998L9.60018 15C10.2629 15 10.8002 13.6568 10.8002 12C10.8002 10.3431 10.2629 8.99998 9.60018 8.99998L9.20046 8.99978C9.38118 7.69586 9.6728 6.56103 10.0285 5.67171C10.2919 5.01328 10.5615 4.56222 10.7889 4.28279L10.7955 4.27469C10.8173 4.24811 10.8382 4.22377 10.8581 4.20151C10.8709 4.18712 10.8836 4.1733 10.8961 4.16007L10.9065 4.14918C10.9419 4.11233 10.9734 4.08288 11.0003 4.05958C11.0192 4.07609 11.0406 4.09588 11.0644 4.11953C11.0769 4.13195 11.09 4.14543 11.1039 4.16007C11.1656 4.22534 11.2316 4.30462 11.3006 4.39879C11.5075 4.68127 11.7419 5.09769 11.9715 5.67171C12.5793 7.19136 13 9.42788 13 12C13 14.5721 12.5793 16.8086 11.9715 18.3283C11.6653 19.0937 11.3508 19.5788 11.1039 19.8399C11.0637 19.8824 11.0292 19.9152 11.0003 19.9404C10.9734 19.9171 10.9419 19.8877 10.9065 19.8508L10.8961 19.8399C10.8836 19.8267 10.8709 19.8129 10.8581 19.7985ZM10.8909 3.98216C10.8909 3.98184 10.8944 3.98303 10.9013 3.98668C10.8944 3.98431 10.8909 3.98248 10.8909 3.98216ZM10.8909 20.0178C10.8909 20.0175 10.8944 20.0157 10.9013 20.0133C10.8944 20.017 10.8909 20.0182 10.8909 20.0178ZM20.9565 11.983C20.9529 10.0865 20.3503 8.23957 19.2347 6.70589L20.8521 5.52942C22.2156 7.40391 22.9521 9.66122 22.9565 11.9792C22.9609 14.2971 22.233 16.5572 20.8766 18.4368L19.2548 17.2665C20.3645 15.7286 20.9601 13.8794 20.9565 11.983ZM16 9.05883C16.6198 9.91087 16.9545 10.9369 16.9565 11.9905C16.9585 13.0441 16.6277 14.0715 16.0111 14.9258L17.633 16.0962C18.4961 14.9 18.9593 13.4618 18.9565 11.9867C18.9537 10.5117 18.4851 9.07521 17.6174 7.88235L16 9.05883Z"
      fill="currentColor"
    />
  </svg>
);

export const Sparks = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 9.5L12 12L14.5 17H15.5L18 12L23 9.5V8.5L18 6L15.5 1H14.5L12 6L7 8.5V9.5ZM13.4907 10.5093L15 13.5279L16.5093 10.5093L19.5279 9L16.5093 7.49071L15 4.47214L13.4907 7.49071L10.4721 9L13.4907 10.5093Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 17.375L4.5 19.5L6.625 23H7.375L9.5 19.5L13 17.375V16.625L9.5 14.5L7.375 11H6.625L4.5 14.5L1 16.625V17.375ZM5.95585 18.0441L7 19.7639L8.04415 18.0441L9.76392 17L8.04415 15.9559L7 14.2361L5.95585 15.9559L4.23608 17L5.95585 18.0441Z"
      fill="currentColor"
    />
  </svg>
);

export const Speedometer = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M16.2881 8L17.7023 9.41421L12.3988 15.4246L10.2775 13.3033L16.2881 8Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.2775 13C22.2775 16.2712 20.7068 19.1755 18.2784 21H6.27649C3.84815 19.1755 2.27747 16.2712 2.27747 13C2.27747 7.47715 6.75462 3 12.2775 3C17.8003 3 22.2775 7.47715 22.2775 13ZM20.2775 13C20.2775 15.3881 19.2329 17.5317 17.5692 19H6.98571C5.32207 17.5317 4.27747 15.3881 4.27747 13C4.27747 8.58172 7.85919 5 12.2775 5C16.6957 5 20.2775 8.58172 20.2775 13Z"
      fill="currentColor"
    />
  </svg>
);

export const Spinner = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M20 12C20 16.4183 16.4183 20 12 20M4 12C4 7.58172 7.58172 4 12 4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StarFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      d="m12 16-5.878 4.09 2.074-6.854L2.489 8.91l7.16-.146L12 2l2.351 6.764 7.16.146-5.707 4.326 2.074 6.854L12 16Z"
      fill="currentColor"
    />
  </svg>
);

export const StarOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3139 12.4163L19.1164 9.6775L14.2239 8.96708L12.0135 4.50603L9.81882 8.95588L4.88661 9.67586L8.43742 13.1394L7.60401 18.0458L12 15.7403L16.3891 18.0422L15.5536 13.1766L16.3139 12.4163ZM18.95 21.1387L18.54 21.4287L12 17.9987L5.46 21.4287L5.05 21.1387L6.29 13.8387L1 8.67866L1.16 8.19866L8.49 7.12866L11.76 0.498657H12.26L15.55 7.13866L22.85 8.19866L23 8.67866L17.72 13.8387L17.7 13.8587L18.95 21.1387Z"
      fill="currentColor"
    />
  </svg>
);

export const SurgeL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M13.29 9.778 15.067 0 3 14.222h6.68L7.31 24 20.24 9.778z"
    />
  </svg>
);

export const SurgeM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12.733 10.519 13.918 4l-8.045 9.482h4.454L8.747 20l8.619-9.481z"
    />
  </svg>
);

export const SystemYango = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 23c6.075 0 11-4.925 11-11 0-6.076-4.925-11-11-11S1 5.924 1 12c0 6.075 4.925 11 11 11ZM9.505 5.125h2.957l-.151 3.427c-.038.64-.095 1.414-.133 1.666.095-.233.38-.833.74-1.491l1.914-3.602h3.355l-5.8 9.082-1.517 4.668H7.875l1.592-4.9.038-8.85Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Table = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 8C2 5.79086 3.79086 4 6 4H18C20.2091 4 22 5.79086 22 8V16.0078C22 18.217 20.2091 20.0039 18 20.0039H6C3.79086 20.0039 2 18.217 2 16.0078V8ZM10 6H18C19.1046 6 20 6.89543 20 8V8.50032H10V6ZM8 6H6C4.89543 6 4 6.89543 4 8V8.50032H8V6ZM8 10.5003H4V13.5003H8V10.5003ZM8 15.5003H4V16.0078C4 17.1124 4.89543 18.0078 6 18.0078H8V15.5003ZM10 18.0078H18C19.1046 18.0078 20 17.1124 20 16.0078V15.5003H10V18.0078ZM10 13.5003V10.5003H20V13.5003H10Z"
    />
  </svg>
);

export const Telegram = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="m9.558 14.303 6.362 4.7c.726.4 1.25.193 1.431-.674l2.59-12.203c.265-1.063-.405-1.545-1.1-1.23L3.635 10.76c-1.038.416-1.032.995-.19 1.253l3.903 1.218 9.034-5.7c.426-.258.818-.12.497.166"
      fill="currentColor"
    />
  </svg>
);

export const TikTok = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M17.61 6.177A4.397 4.397 0 0 1 15.61 2.5h-3.154l-.005 12.64a2.652 2.652 0 0 1-2.646 2.553 2.652 2.652 0 0 1-2.652-2.651 2.655 2.655 0 0 1 2.652-2.652c.273 0 .534.045.782.122v-3.22a5.729 5.729 0 0 0-.782-.056A5.812 5.812 0 0 0 4 15.042a5.8 5.8 0 0 0 2.479 4.753 5.767 5.767 0 0 0 3.327 1.052 5.812 5.812 0 0 0 5.805-5.805v-6.41A7.503 7.503 0 0 0 20 10.041V6.888a4.361 4.361 0 0 1-2.39-.71Z"
    />
  </svg>
);

export const TikTokColor = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="#FF004F"
      d="M15.86 9.03A7.1 7.1 0 0 0 20 10.35V7.38c-.3 0-.58-.03-.87-.1v2.35a7.1 7.1 0 0 1-4.14-1.33v6.07a5.5 5.5 0 0 1-8.55 4.56 5.48 5.48 0 0 0 9.42-3.84V9.03Zm1.07-3c-.6-.65-.99-1.5-1.07-2.42v-.39h-.83c.21 1.19.92 2.2 1.9 2.8ZM8.35 16.6a2.51 2.51 0 0 1 2.76-3.91V9.65a5.54 5.54 0 0 0-.86-.05v2.36a2.51 2.51 0 0 0-1.9 4.64Z"
    />
    <path
      fill="#000"
      d="M14.99 8.3a7.1 7.1 0 0 0 4.14 1.33V7.29a4.16 4.16 0 0 1-2.2-1.26 4.16 4.16 0 0 1-1.9-2.8h-2.16v11.86a2.51 2.51 0 0 1-4.52 1.51 2.51 2.51 0 0 1 1.9-4.64V9.6a5.5 5.5 0 0 0-3.81 9.33 5.5 5.5 0 0 0 8.55-4.56V8.3Z"
    />
    <path
      fill="#00F2EA"
      d="M19.13 7.29v-.63c-.78 0-1.54-.22-2.2-.63a4.15 4.15 0 0 0 2.2 1.26m-4.1-4.07a4.2 4.2 0 0 1-.04-.34V2.5h-3v11.87a2.51 2.51 0 0 1-3.64 2.23 2.51 2.51 0 0 0 4.52-1.51V3.22h2.16ZM10.25 9.6v-.67a5.5 5.5 0 0 0-3.81 10 5.5 5.5 0 0 1 3.81-9.33Z"
    />
  </svg>
);

export const TimeMFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m1.25 9.482L13 5l-2-.008-.25 7.526 4.18 3.794L16.242 15z"
      clipRule="evenodd"
    />
  </svg>
);

export const TimeMOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315ZM13.25 11.4822L13 6.00757L11 6L10.75 12.5178L14.3164 15.699L15.6289 14.3865L13.25 11.4822Z"
      fill="currentColor"
    />
  </svg>
);

export const TimeOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V12C11 12.3344 11.1671 12.6466 11.4453 12.8321L14.4453 14.8321C14.9048 15.1384 15.5257 15.0142 15.8321 14.5547C16.1384 14.0952 16.0142 13.4743 15.5547 13.1679L13 11.4648V7Z"
      fill="currentColor"
    />
  </svg>
);

export const TimePaidFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 6.4v-1h.8v-.7H18v-1h.8V0H21.1c.6 0 1.1.1 1.5.3.4.2.8.4 1 .8.3.3.4.7.4 1.3 0 .6-.1 1-.4 1.3-.2.3-.6.6-1 .7-.4.1-1 .2-1.5.2h-.5v.7h2.3v1h-2.3V8h-1.7V6.4H18Zm3.1-2.8h-.6V1.2h.6c.4 0 .7.1.9.3.2.2.3.5.3.9s-.1.7-.3.9c-.2.2-.5.3-.9.3ZM12 2c1.1 0 2.3.2 3.3.6-.2.6-.3 1.2-.3 1.9 0 3.3 2.7 6 6 6 .3 0 .6 0 .9-.1.1.6.1 1.1.1 1.6 0 2.7-1.1 5.2-2.9 7.1-1.9 1.8-4.4 2.9-7.1 2.9-2.7 0-5.2-1.1-7.1-2.9C3.1 17.2 2 14.7 2 12c0-2.7 1.1-5.2 2.9-7.1C6.8 3.1 9.3 2 12 2Zm1.2 9.5L13 5h-2l-.2 7.5 4.2 3.8 1.3-1.3-3.1-3.5Z"
      fill="currentColor"
    />
  </svg>
);

export const TimePaidOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 6.4v-1h.8v-.7H18v-1h.8V0H21.1c.6 0 1.1.1 1.5.3.4.2.8.4 1 .8.3.3.4.7.4 1.3 0 .6-.1 1-.4 1.3-.2.3-.6.6-1 .7-.4.1-1 .2-1.5.2h-.5v.7h2.3v1h-2.3V8h-1.7V6.4H18Zm3.1-2.8h-.6V1.2h.6c.4 0 .7.1.9.3.2.2.3.5.3.9s-.1.7-.3.9c-.2.2-.5.3-.9.3ZM12 4c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8c0-.5 0-.9-.1-1.3l2-.3c.1.5.1 1 .1 1.6 0 5.5-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2c1.2 0 2.3.2 3.3.6.2.1.4.1.6.2l-.8 1.8c-.1-.1-.3-.1-.4-.2-.9-.2-1.8-.4-2.7-.4Zm1 2 .2 5.5 2.4 2.9-1.3 1.3-3.6-3.2L11 6h2Z"
      fill="currentColor"
    />
  </svg>
);

export const TollRoadOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.99963 2.99988C3.34278 2.99988 1.99963 4.34302 1.99963 5.99988V20.9999H9.99963V15.9999H22.9996V9.99988L9.99963 9.99988V5.99988C9.99963 4.34302 8.65649 2.99988 6.99963 2.99988H4.99963ZM6.99963 4.99988H4.99963C4.44735 4.99988 3.99963 5.44759 3.99963 5.99988V18.9999H7.99963V5.99988C7.99963 5.44759 7.55192 4.99988 6.99963 4.99988ZM15.0854 13.9999H9.99963V11.9999H13.0854L15.0854 13.9999ZM17.9138 13.9999H20.9996V11.9999H15.9138L17.9138 13.9999Z"
      fill="currentColor"
    />
  </svg>
);

export const TransmissionOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9 11V8C9 7.44772 8.55229 7 8 7C7.44772 7 7 7.44772 7 8V16C7 16.5523 7.44772 17 8 17C8.55229 17 9 16.5523 9 16V13H11V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V13H16C16.5523 13 17 12.5523 17 12V8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8V11H13V8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V11H9Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
      fill="currentColor"
    />
  </svg>
);

export const TrashOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.091 2h1.817c.431-.001.862-.002 1.254.13a2.5 2.5 0 0 1 1.268.955c.233.341.35.756.469 1.17l.028.102.242.846C19.05 5.511 21 6.148 21 7v2l-1.49 1-1.415 9.84c-.063.44-.145.894-.453 1.214C17.07 21.646 15.62 22.5 12 22.5c-3.599 0-5.054-.844-5.632-1.436-.317-.324-.4-.79-.464-1.239L4.51 10 3 9V7.06c0-.93 1.952-1.565 4.832-1.865l.24-.838.029-.101c.117-.415.235-.83.469-1.17a2.5 2.5 0 0 1 1.267-.957c.392-.131.823-.13 1.254-.13m2.913 2.907.04.138Q13.058 5 12 5t-2.044.043l.039-.136c.169-.59.2-.655.224-.69a.5.5 0 0 1 .253-.191c.04-.013.11-.026.725-.026h1.605c.614 0 .685.013.725.026a.5.5 0 0 1 .253.191c.024.035.056.1.224.69m3.647 3.932L19 7.934v-.15a8 8 0 0 0-1.043-.286C16.517 7.19 14.418 7 12 7c-2.428 0-4.522.18-5.955.487A7.5 7.5 0 0 0 5 7.778v.148l1.37.907 1.548 10.93c.975.664 2.951.737 4.082.737 2.704 0 3.762-.52 4.083-.738zM10.52 9l.48 9.75-1.5-.25-.98-9.37zM13 18.75 13.48 9l2 .13-.98 9.37z"
      clipRule="evenodd"
    />
  </svg>
);

export const Traffic = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 8.875c0 1.105.254 2.138 1 3.065V12c0 5.523 4.477 10 10 10s10-4.477 10-10c0-.086-.001-.171-.003-.257C21.862 6.348 17.482 2 12.117 2h-2.47C3.517 2 1 5.085 1 8.875Zm5.431 8.867A8 8 0 0 1 12.135 4c1.045.617 1.983 1.533 2.753 2.443.555.66 1.093 1.336 1.614 2.024.555.724 1.007 1.314 1.57 1.883a5.566 5.566 0 0 0 1.92 1.27 8 8 0 0 1-13.56 6.122h-.001Z"
      clipRule="evenodd"
    />
  </svg>
);

export const TucktuckProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M6 17.9998C6 19.1043 5.10457 19.9998 4 19.9998C2.89543 19.9998 2 19.1043 2 17.9998C2 16.8952 2.89543 15.9998 4 15.9998C5.10457 15.9998 6 16.8952 6 17.9998Z"
      fill="currentColor"
    />
    <path
      d="M23 17.9998C23 19.1043 22.1046 19.9998 21 19.9998C19.8954 19.9998 19 19.1043 19 17.9998C19 16.8952 19.8954 15.9998 21 15.9998C22.1046 15.9998 23 16.8952 23 17.9998Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 17.9998C17.5 16.0668 19.067 14.4998 21 14.4998H22C22 13.9745 21.7856 13.457 21.4142 13.0855C21.0063 12.6776 20.419 12.4613 19.8455 12.5057L18.117 6.97458C17.7456 5.78584 16.6782 4.95024 15.4351 4.8749L4.18149 4.19286C2.45643 4.08831 1 5.45914 1 7.18737V16.196C1.61245 15.1795 2.72684 14.4998 4 14.4998C5.933 14.4998 7.5 16.0668 7.5 17.9998H17.5ZM16 15.9998L14.9986 16L15 15.9998L13.5 12.9998H12V9.99976H10V16H8.99928L7.55279 13.1053C7.24956 12.4989 6.66296 12.0924 6 12.0137V6.30675L15.3141 6.87124C15.7288 6.91631 16 7.12963 16 7.71745V15.9998Z"
      fill="currentColor"
    />
  </svg>
);

export const TuckTuckFront = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5 22.9998L17.5 20.9998H15.5001V18.4998C15.5001 16.5667 13.933 14.9997 11.9999 14.9998C10.067 14.9998 8.5 16.5668 8.5 18.4998V20.9998H6.5L5.50175 22.9998H3.5024C3.04962 20.5751 2.98409 16.6849 3.00279 13.4998C3.02198 10.2304 3.49095 7.42423 3.77957 5.99976C3.80038 5.89704 3.82032 5.79198 3.8405 5.68559C3.95014 5.10772 4.06717 4.49092 4.3725 3.99976C5.61581 1.99976 9.38021 1.99976 11.9999 1.99976C14.6197 1.99976 18.3842 1.99976 19.6275 3.99976C19.9328 4.49094 20.0499 5.10776 20.1595 5.68565C20.1797 5.79201 20.1996 5.89706 20.2204 5.99976C20.509 7.42423 20.978 10.2304 20.9972 13.4998C21.0159 16.6849 20.9504 20.5751 20.4976 22.9998H18.5ZM18.5453 7.99957C18.4229 7.21044 18.296 6.57594 18.2078 6.13485L18.1729 5.96004C18.062 5.40035 18.024 5.20853 17.929 5.05568C17.7838 4.82211 17.2931 4.44945 15.984 4.21963C14.7618 4.00506 13.3443 3.99976 11.9999 3.99976C10.6556 3.99976 9.23807 4.00506 8.0159 4.21963C6.70685 4.44945 6.21624 4.8221 6.07105 5.05566C5.97602 5.20852 5.93801 5.40031 5.82708 5.95999L5.79223 6.13471C5.704 6.5758 5.57707 7.21036 5.45469 7.99957C5.3149 9.05745 6.14267 9.99976 7.20975 9.99976H16.7902C17.8573 9.99976 18.6851 9.05745 18.5453 7.99957ZM8 13.9998C8 14.8282 7.32843 15.4998 6.5 15.4998C5.67157 15.4998 5 14.8282 5 13.9998C5 13.1713 5.67157 12.4998 6.5 12.4998C7.32843 12.4998 8 13.1713 8 13.9998ZM19 13.9998C19 14.8282 18.3284 15.4998 17.5 15.4998C16.6716 15.4998 16 14.8282 16 13.9998C16 13.1713 16.6716 12.4998 17.5 12.4998C18.3284 12.4998 19 13.1713 19 13.9998Z"
      fill="currentColor"
    />
    <path
      d="M10.5001 18.4997L10.5 20.9998L11.0001 22.9997H13.0001L13.5001 20.9998V18.4998C13.5001 17.6713 12.8285 16.9998 12.0001 16.9998C11.1717 16.9998 10.5001 17.6713 10.5001 18.4997Z"
      fill="currentColor"
    />
  </svg>
);

export const Upload = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m14.707 4.707-1.414 1.414L11 3.828V15H9V3.828L6.707 6.121 5.293 4.707 10 0l4.707 4.707Z"
    />
    <path
      fill="currentColor"
      d="M14 18H6c-.96 0-1.579-.001-2.052-.033-.456-.031-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.256-.119-.713C2.001 15.58 2 14.96 2
        14V9H0v5c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C3.204 20 4.136 20 6 20h8c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164C20 16.796 20 15.864
        20 14V9h-2v5c0 .96-.001 1.579-.033 2.052-.031.457-.085.63-.12.713a2 2 0 0 1-1.082 1.083c-.083.034-.256.088-.713.119C15.58 17.999 14.96 18 14 18Z"
    />
  </svg>
);

export const UpPrice = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12.421 12.302 1 22 12.421l-5.431-1L15.506 17h-6.72L7.43 11.421l-5.431 1ZM9.028 18h6.287l-.381 2h-5.42l-.486-2Zm.728 3 .485 2h4.121l.381-2H9.756Z"
      clipRule="evenodd"
    />
  </svg>
);

export const UserAddOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.569 4.115A4.57 4.57 0 0 1 9.5 3c.922 0 2.035.336 2.931 1.115C13.357 4.92 14 6.155 14 7.826 14 10.78 11.9 13 9.5 13S5 10.78 5 7.826c0-1.67.643-2.906 1.569-3.711m1.312 1.51C7.407 6.035 7 6.713 7 7.825 7 9.882 8.4 11 9.5 11S12 9.882 12 7.826c0-1.112-.407-1.79-.881-2.202A2.57 2.57 0 0 0 9.5 5c-.478 0-1.115.186-1.619.624M9.5 14C4.503 14 2 15.609 2 18.512 2 19.889 5.356 21 9.5 21s7.5-1.111 7.5-2.488C17 15.609 14.497 14 9.5 14m-5.46 4.046c.172.094.428.21.786.328C5.929 18.74 7.582 19 9.5 19s3.57-.26 4.674-.626c.358-.119.614-.234.785-.328-.096-.501-.37-.861-.879-1.173-.794-.486-2.238-.873-4.58-.873s-3.785.387-4.58.873c-.51.312-.783.672-.88 1.173m11.176-.172-.001.001-.006.006z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M18 13v3h2v-3h3v-2h-3V8h-2v3h-3v2z" />
  </svg>
);

export const UserCheckFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M9.5 12.5c2 0 4-1.983 4-4.957C13.5 4.24 11.1 3 9.5 3s-4 1.24-4 4.543c0 2.974 2 4.957 4 4.957m0 1.488c-4.997 0-7.5 1.609-7.5 4.512 0 1.377 3.356 2.488 7.5 2.488S17 19.877 17 18.5c0-2.903-2.503-4.512-7.5-4.512m12.996-3.574L21.082 9l-3.54 3.54L16 11l-1.414 1.414 2.953 2.953.002-.002.002.002z"
    />
  </svg>
);

export const UserCheckOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.5 3c-.922 0-2.035.336-2.931 1.115C5.643 4.92 5 6.155 5 7.826 5 10.78 7.1 13 9.5 13S14 10.78 14 7.826c0-1.67-.643-2.906-1.569-3.711A4.57 4.57 0 0 0 9.5 3M7 7.826c0-1.112.407-1.79.881-2.202A2.57 2.57 0 0 1 9.5 5c.478 0 1.115.186 1.619.624.474.412.881 1.09.881 2.202C12 9.882 10.6 11 9.5 11S7 9.882 7 7.826M2 18.512C2 15.609 4.503 14 9.5 14s7.5 1.609 7.5 4.512C17 19.889 13.644 21 9.5 21S2 19.889 2 18.512m2.826-.138a5 5 0 0 1-.785-.328c.096-.501.37-.861.879-1.173C5.715 16.387 7.158 16 9.5 16s3.786.387 4.58.873c.51.312.783.672.88 1.173a5 5 0 0 1-.786.328C13.071 18.74 11.418 19 9.5 19s-3.57-.26-4.674-.626m10.389-.499v-.001l-.006.007z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m21.082 9 1.414 1.414-4.953 4.953-.002-.002-.002.002-2.953-2.953L16 10.999l1.541 1.541z"
    />
  </svg>
);

export const UserFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12 14c-5.996 0-9 1.5-9 5 0 1.66 4.028 3 9 3s9-1.34 9-3c0-3.5-3.004-5-9-5m0-1c2.25 0 4.5-2.7 4.5-6 0-4-2.812-5-4.5-5-1.687 0-4.5 1-4.5 5 0 3.3 2.25 6 4.5 6"
    />
  </svg>
);

export const UserGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M15.035 8.615c0 2.256-1.517 3.76-3.034 3.76-1.518 0-3.035-1.504-3.035-3.76 0-2.507 1.82-3.447 3.035-3.447 1.213 0 3.034.94 3.034 3.447m-8.724 8.311c0-2.202 1.899-3.422 5.69-3.422 3.79 0 5.689 1.22 5.689 3.422 0 1.045-2.546 1.888-5.69 1.888-3.143 0-5.689-.843-5.689-1.888m14.793-7.304c0 1.673-1.138 2.753-2.276 2.753s-2.276-1.08-2.276-2.753c0-1.86 1.366-2.557 2.276-2.557s2.276.697 2.276 2.557m-2.276 8.442q-.196 0-.39-.007c.224-.3.39-.676.39-1.13 0-1.353-.555-2.482-1.613-3.269a8 8 0 0 1 1.613-.145c2.78 0 4.172 1.046 4.172 2.933 0 .895-1.867 1.618-4.172 1.618M2.896 9.622c0 1.673 1.138 2.753 2.276 2.753s2.276-1.08 2.276-2.753c0-1.86-1.365-2.557-2.276-2.557s-2.276.697-2.276 2.557m2.276 8.442q.197 0 .39-.007a1.87 1.87 0 0 1-.39-1.13c0-1.353.555-2.482 1.613-3.269a8 8 0 0 0-1.613-.145C2.392 13.513 1 14.559 1 16.446c0 .895 1.867 1.618 4.172 1.618"
    />
  </svg>
);

export const UserRemoveFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M9.5 12.5c2 0 4-1.983 4-4.957C13.5 4.24 11.1 3 9.5 3s-4 1.24-4 4.543c0 2.974 2 4.957 4 4.957m0 1.488c-4.997 0-7.5 1.609-7.5 4.512 0 1.377 3.356 2.488 7.5 2.488S17 19.877 17 18.5c0-2.903-2.503-4.512-7.5-4.512M15 11v2h8v-2z"
    />
  </svg>
);

export const UserRemoveOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.569 4.115A4.57 4.57 0 0 1 9.5 3c.922 0 2.035.336 2.931 1.115C13.357 4.92 14 6.155 14 7.826 14 10.78 11.9 13 9.5 13S5 10.78 5 7.826c0-1.67.643-2.906 1.569-3.711m1.312 1.51C7.407 6.035 7 6.713 7 7.825 7 9.882 8.4 11 9.5 11S12 9.882 12 7.826c0-1.112-.407-1.79-.881-2.202A2.57 2.57 0 0 0 9.5 5c-.478 0-1.115.186-1.619.624M9.5 14C4.503 14 2 15.609 2 18.512 2 19.889 5.356 21 9.5 21s7.5-1.111 7.5-2.488C17 15.609 14.497 14 9.5 14m-5.46 4.046c.172.094.428.21.786.328C5.929 18.74 7.582 19 9.5 19s3.57-.26 4.674-.626c.358-.119.614-.234.785-.328-.096-.501-.37-.861-.879-1.173-.794-.486-2.238-.873-4.58-.873s-3.785.387-4.58.873c-.51.312-.783.672-.88 1.173m11.176-.172-.001.001-.006.006z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M15 11v2h8v-2z" />
  </svg>
);

export const UserRoundDotFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 12q0 .489-.046.966a5.002 5.002 0 0 0-7.585 2.146A22 22 0 0 0 12 15c-3.276 0-5.404.493-6.38 1.827A7.99 7.99 0 0 0 12 20a8 8 0 0 0 2.69-.464 5 5 0 0 0 1.453 1.568A10 10 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10m-10 1.5c1.8 0 3.5-2 3.5-4.5 0-3.2-2.15-4-3.5-4s-3.5.8-3.5 4c0 2.64 1.7 4.5 3.5 4.5m7 6.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
      clipRule="evenodd"
    />
  </svg>
);

export const UserRoundFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M5.62 16.827C6.596 15.493 8.724 15 12 15s5.404.493 6.38 1.827A7.99 7.99 0 0 1 12 20a7.99 7.99 0 0 1-6.38-3.173M12 13.5c1.8 0 3.5-2 3.5-4.5 0-3.2-2.15-4-3.5-4s-3.5.8-3.5 4c0 2.64 1.7 4.5 3.5 4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserRoundOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 9.5c0 2.5-2 4.5-4 4.5s-4-2-4-4.5C8 6 10.5 5 12 5s4 1 4 4.5M12 12c.748 0 2-.95 2-2.5 0-1.221-.41-1.765-.73-2.036A2.07 2.07 0 0 0 12 7c-.364 0-.88.134-1.27.464-.32.271-.73.815-.73 2.036 0 1.55 1.252 2.5 2 2.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m6.43-5.24a8 8 0 1 0-12.86 0 3.2 3.2 0 0 1 .843-.737C7.471 15.373 9.205 15 12 15s4.53.373 5.587 1.023q.524.326.843.737m-1.45 1.502a.6.6 0 0 0-.048-.148c-.042-.088-.135-.228-.394-.387C15.971 17.377 14.705 17 12 17s-3.97.377-4.538.727c-.259.159-.352.3-.394.387a.6.6 0 0 0-.048.148A7.97 7.97 0 0 0 12 20c1.883 0 3.613-.65 4.98-1.738"
      clipRule="evenodd"
    />
  </svg>
);

export const UserCourier = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M11 13c2.25 0 4.5-2.7 4.5-6h1A2.5 2.5 0 0 0 19 4.5h-3.5V3a1 1 0 0 0-1-1H11C9.313 2 6.5 3 6.5 7c0 3.3 2.25 6 4.5 6m.257 1.008C5.756 14.13 3 15.648 3 19c0 1.658 4.02 2.997 8.986 3l-.08-.075a3 3 0 0 1-.8-1.359c-.107-.39-.106-.805-.106-1.278v-3.576c0-.473 0-.887.106-1.278q.06-.219.15-.426"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.498 11.064c-.246.064-.483.195-.955.457l-3 1.667c-.499.277-.748.416-.94.603a2 2 0 0 0-.533.906c-.07.258-.07.543-.07 1.114v3.378c0 .571 0 .856.07 1.114a2 2 0 0 0 .533.906c.192.187.441.326.94.603l3 1.666c.472.263.709.394.955.458a2 2 0 0 0 1.004 0c.246-.064.483-.195.955-.457l3-1.667c.499-.277.748-.416.94-.603a2 2 0 0 0 .533-.906c.07-.258.07-.543.07-1.114v-3.378c0-.571 0-.856-.07-1.114a2 2 0 0 0-.533-.906c-.192-.187-.441-.326-.94-.603l-3-1.667c-.472-.262-.709-.393-.955-.457a2 2 0 0 0-1.004 0m4.23 3.435-3-1.666a13 13 0 0 0-.498-.27 1 1 0 0 0-.108-.048.5.5 0 0 0-.247 0 1 1 0 0 0-.105.048c-.11.054-.25.132-.498.27l-.705.391 3.089 1.716c.269.15.519.288.72.483.264.258.454.582.551.938.074.27.073.556.073.864v3.68l.729-.404c.262-.146.41-.23.52-.297a1 1 0 0 0 .103-.07.5.5 0 0 0 .13-.221 1 1 0 0 0 .011-.125c.007-.128.007-.299.007-.599v-3.378c0-.3 0-.47-.007-.6a1 1 0 0 0-.01-.121.5.5 0 0 0-.131-.223 1 1 0 0 0-.103-.07c-.11-.069-.258-.152-.52-.298m-7.457 0 .751-.417 3.845 2.136c.367.204.424.243.461.28a.57.57 0 0 1 .152.257c.014.05.02.12.02.539v4.445l-.771.428c-.249.138-.39.216-.499.27a1 1 0 0 1-.105.047.5.5 0 0 1-.25 0 1 1 0 0 1-.105-.047c-.11-.054-.25-.132-.498-.27l-3-1.666c-.263-.146-.411-.23-.52-.297a1 1 0 0 1-.102-.07.5.5 0 0 1-.132-.224 1 1 0 0 1-.011-.122 14 14 0 0 1-.007-.599v-3.378c0-.3 0-.47.007-.6a1 1 0 0 1 .01-.121.5.5 0 0 1 .131-.223 1 1 0 0 1 .103-.07c.11-.069.258-.152.52-.298"
      clipRule="evenodd"
    />
  </svg>
);

export const UserAddFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M9.50001 12.5C11.5 12.5 13.5 10.5174 13.5 7.54348C13.5 4.23913 11.1 3 9.50001 3C7.90001 3 5.5 4.23913 5.5 7.54348C5.5 10.5174 7.50001 12.5 9.50001 12.5Z"
      fill="currentColor"
    />
    <path
      d="M9.5 13.9883C4.50313 13.9883 2 15.5969 2 18.5C2 19.8769 5.35625 20.9883 9.5 20.9883C13.6437 20.9883 17 19.8769 17 18.5C17 15.5969 14.4969 13.9883 9.5 13.9883Z"
      fill="currentColor"
    />
    <path d="M18 13V16H20V13H23V11H20V8H18V11H15V13H18Z" fill="currentColor" />
  </svg>
);

export const UserDriver = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 7c0 3.3-2.25 6-4.5 6s-4.5-2.7-4.5-6c0-4 2.813-5 4.5-5 1.688 0 4.5 1 4.5 5Zm.5 15.388v-2.656a2.004 2.004 0 0 1-.932-1.215l-2.565-.687A4.502 4.502 0 0 0 17 22.388Zm-2.98-6.49a4.5 4.5 0 0 1 7.96 0l-2.566.688A1.994 1.994 0 0 0 18 16c-.552 0-1.052.224-1.414.585l-2.566-.687Zm8.477 1.932-2.565.687c-.138.518-.479.953-.932 1.215v2.656a4.502 4.502 0 0 0 3.497-4.558ZM24 18a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-11.746-4H12c-5.996 0-9 1.5-9 5 0 1.66 4.027 3 9 3l.254-.001a6.968 6.968 0 0 1-1.254-4c0-1.486.464-2.865 1.254-3.998Z"
    />
  </svg>
);

export const UserOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.01612 18.651C5.24 18.8081 5.64216 19.0167 6.26744 19.225C7.6418 19.6828 9.66832 20 12 20C14.3317 20 16.3582 19.6828 17.7326 19.225C18.3578 19.0167 18.76 18.8081 18.9839 18.651C18.9456 18.2578 18.8431 17.9755 18.7167 17.7624C18.5562 17.4916 18.285 17.2108 17.7963 16.9462C16.7447 16.3768 14.9066 16 12 16C9.09344 16 7.25528 16.3768 6.20374 16.9462C5.71501 17.2108 5.44382 17.4916 5.28326 17.7624C5.15685 17.9755 5.05435 18.2578 5.01612 18.651ZM3 19C3 15.5 6.00375 14 12 14C17.9963 14 21 15.5 21 19C21 20.66 16.9725 22 12 22C7.0275 22 3 20.66 3 19Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 11.0044C13.1883 11.0044 15 9.71899 15 7.00439C15 5.5582 14.482 4.73993 13.933 4.25954C13.3247 3.7273 12.5529 3.50439 12 3.50439C11.4472 3.50439 10.6753 3.7273 10.067 4.25955C9.51799 4.73994 9 5.55821 9 7.00439C9 9.71897 10.8117 11.0044 12 11.0044ZM17 7.00439C17 10.6044 14.5 13.0044 12 13.0044C9.50002 13.0044 7 10.6044 7 7.00439C7 3.00439 10 1.50439 12 1.50439C14 1.50439 17 3.00439 17 7.00439Z"
      fill="currentColor"
    />
  </svg>
);

export const UserReplace = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M9.5 12.5c2 0 4-1.983 4-4.957C13.5 4.24 11.1 3 9.5 3s-4 1.24-4 4.543c0 2.974 2 4.957 4 4.957ZM9.5 13.988c-4.997 0-7.5 1.609-7.5 4.512 0 1.377 3.356 2.488 7.5 2.488S17 19.877 17 18.5c0-2.903-2.503-4.512-7.5-4.512ZM23.782 7.59a.375.375 0 0 1-.349.513h-2.526c-.3 0-.479-.337-.31-.586l.326-.481c-.613-.341-1.432-.53-2.485-.227-1.433.588-1.833 1.719-1.951 2.333a.75.75 0 1 1-1.473-.284c.173-.898.788-2.61 2.9-3.454l.031-.013.033-.01c1.605-.476 2.873-.132 3.788.411l.426-.627a.375.375 0 0 1 .66.072l.93 2.353ZM17.995 12.29c.61.328 1.418.505 2.45.207 1.489-.61 1.864-1.81 1.964-2.403a.75.75 0 0 1 1.48.25c-.146.865-.723 2.68-2.919 3.559l-.032.012-.033.01c-1.584.47-2.84.14-3.753-.39l-.344.505a.375.375 0 0 1-.659-.072l-.93-2.352a.375.375 0 0 1 .348-.514h2.526c.3 0 .48.337.31.586l-.408.602Z"
      fill="currentColor"
    />
  </svg>
);

export const UserRoundDotOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c1.478 0 2.88-.32 4.143-.896a5.025 5.025 0 0 1-1.453-1.568c-.84.3-1.746.464-2.69.464a7.966 7.966 0 0 1-4.98-1.738.64.64 0 0 1 .048-.148c.042-.088.135-.228.394-.387C8.029 17.377 9.295 17 12 17c.78 0 1.442.031 2 .085V17c0-.668.131-1.306.369-1.889A22.59 22.59 0 0 0 12 15c-2.795 0-4.53.373-5.587 1.023a3.17 3.17 0 0 0-.843.737A8 8 0 1 1 20 12.1a4.97 4.97 0 0 1 1.954.866c.03-.318.046-.64.046-.966 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10Zm4-12.5c0 2.5-2 4.5-4 4.5s-4-2-4-4.5C8 6 10.5 5 12 5s4 1 4 4.5ZM12 12c.748 0 2-.95 2-2.5 0-1.221-.41-1.765-.73-2.036A2.071 2.071 0 0 0 12 7c-.364 0-.88.134-1.27.464-.32.271-.73.815-.73 2.036 0 1.55 1.252 2.5 2 2.5Zm7 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      fill="currentColor"
    />
  </svg>
);

export const UsersFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12.5 7.543c0 2.974-2 4.957-4 4.957s-4-1.983-4-4.957C4.5 4.24 6.9 3 8.5 3s4 1.24 4 4.543ZM1 18.5c0-2.903 2.503-4.512 7.5-4.512S16 15.597 16 18.5c0 1.377-3.356 2.488-7.5 2.488S1 19.877 1 18.5ZM20.5 8.87c0 2.207-1.5 3.63-3 3.63s-3-1.423-3-3.63c0-2.45 1.8-3.37 3-3.37s3 .92 3 3.37ZM17.5 20c-.173 0-.344-.003-.513-.01.294-.394.513-.89.513-1.49 0-1.782-.732-3.271-2.126-4.308A10.697 10.697 0 0 1 17.5 14c3.664 0 5.5 1.379 5.5 3.867C23 19.047 20.539 20 17.5 20Z"
    />
  </svg>
);

export const UsersOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 3c-.92 0-2.04.34-2.93 1.11A4.74 4.74 0 0 0 4 7.83C4 10.78 6.1 13 8.5 13S13 10.78 13 7.83c0-1.67-.64-2.91-1.57-3.72-.9-.77-2-1.11-2.93-1.11ZM6 7.83c0-1.12.4-1.8.88-2.2C7.38 5.18 8.02 5 8.5 5c.48 0 1.11.19 1.62.62.47.42.88 1.1.88 2.2C11 9.89 9.6 11 8.5 11S6 9.88 6 7.83ZM1 18.51C1 15.61 3.5 14 8.5 14s7.5 1.6 7.5 4.51C16 19.9 12.64 21 8.5 21 4.36 21 1 19.89 1 18.51Zm2.83-.14a4.8 4.8 0 0 1-.79-.32c.1-.5.37-.87.88-1.18.8-.48 2.24-.87 4.58-.87s3.79.39 4.58.87c.5.31.78.67.88 1.18-.17.09-.43.2-.79.32-1.1.37-2.75.63-4.67.63a15.6 15.6 0 0 1-4.67-.63Zm10.38-.5v.01ZM15.2 5.92c.7-.64 1.56-.92 2.3-.92.74 0 1.6.28 2.3.92A3.9 3.9 0 0 1 21 8.89c0 2.3-1.57 4.11-3.5 4.11S14 11.2 14 8.89c0-1.31.48-2.3 1.2-2.97Zm1.35 1.47c-.28.26-.55.7-.55 1.5 0 1.48.93 2.11 1.5 2.11s1.5-.63 1.5-2.11c0-.8-.27-1.24-.55-1.5-.3-.28-.69-.39-.95-.39s-.64.11-.95.4Z"
      fill="currentColor"
    />
    <path
      d="M17.5 20H17c.29-.4.5-.9.5-1.49 0-.17 0-.34-.02-.51h.02a9.2 9.2 0 0 0 3.45-.61 1.17 1.17 0 0 0-.49-.76c-.43-.31-1.33-.63-2.96-.63l-.57.01a5.2 5.2 0 0 0-1.57-1.82C16 14.07 16.7 14 17.5 14c3.66 0 5.5 1.38 5.5 3.87 0 1.18-2.46 2.13-5.5 2.13Z"
      fill="currentColor"
    />
  </svg>
);

export const VerifiedM = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.282 2.99a3.123 3.123 0 0 0-4.564 0l-.036.04a3.12 3.12 0 0 1-2.387.988l-.052-.002a3.123 3.123 0 0 0-3.227 3.227l.002.052c.03.901-.33 1.772-.989 2.387l-.038.036a3.123 3.123 0 0 0 0 4.563l.038.037a3.12 3.12 0 0 1 .989 2.387l-.002.052a3.123 3.123 0 0 0 3.227 3.227l.052-.002c.901-.03 1.772.33 2.387.989l.036.038a3.123 3.123 0 0 0 4.563 0l.037-.038a3.12 3.12 0 0 1 2.387-.989l.052.002a3.123 3.123 0 0 0 3.227-3.227l-.002-.052c-.03-.901.33-1.772.989-2.387l.038-.037a3.123 3.123 0 0 0 0-4.563l-.038-.036a3.12 3.12 0 0 1-.989-2.387l.002-.052a3.123 3.123 0 0 0-3.227-3.227l-.052.002a3.12 3.12 0 0 1-2.387-.989zM11 16.5l6.5-6.5L16 8.5l-4.99 5-3.01-3L6.5 12z"
      clipRule="evenodd"
    />
  </svg>
);

export const VerifiedS = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.052.35H7.95c-.459.012-.82.2-1.105.4-.253.177-.524.424-.8.675q-.036.03-.07.064c-.086.078-.171.157-.261.227H5.71a4 4 0 0 1-.337-.006l-.1-.005c-.373-.014-.739-.029-1.046-.002-.347.03-.744.118-1.104.405l-.077.065c-.345.304-.501.68-.59 1.016a9 9 0 0 0-.186 1.076c-.018.13-.036.266-.063.394q-.127.11-.262.212l-.08.06c-.294.229-.584.453-.803.671-.247.246-.494.57-.585 1.02l-.018.1c-.068.454.054.842.202 1.158.13.279.326.589.525.905l.024.037c.07.112.144.228.205.343q-.026.166-.065.33l-.021.098c-.08.365-.157.723-.184 1.03-.032.347-.013.754.206 1.157l.051.088c.24.392.583.611.899.758.28.13.629.242.984.356l.042.013c.126.04.257.082.378.13.06.096.111.196.163.296l.046.088c.174.33.345.655.52.908.2.286.476.585.903.753q.048.019.096.035c.435.146.839.094 1.175.003a9 9 0 0 0 1.071-.397c.106-.044.214-.089.322-.124.108.035.216.08.322.124l.089.037c.345.14.684.28.982.36.336.09.74.143 1.176-.003l.095-.035c.428-.168.703-.467.902-.753a9 9 0 0 0 .566-.992q.078-.156.167-.303l.003-.001q.113-.036.216-.073.098-.034.198-.066c.356-.114.705-.226.984-.356.316-.147.66-.366.9-.758l.05-.088c.22-.403.238-.81.207-1.157a9 9 0 0 0-.184-1.03l-.01-.048c-.033-.149-.044-.208-.059-.284l-.018-.096c.062-.115.135-.231.205-.343l.024-.037c.2-.316.395-.626.525-.905.148-.316.27-.704.202-1.159l-.018-.1c-.091-.45-.338-.773-.585-1.019-.218-.218-.508-.442-.803-.67l-.08-.061c-.088-.069-.178-.137-.261-.212a6 6 0 0 1-.07-.439c-.05-.37-.1-.733-.179-1.03-.09-.337-.246-.713-.59-1.017l-.078-.065c-.36-.287-.756-.375-1.104-.405-.307-.027-.673-.012-1.046.002l-.096.004q-.173.01-.345.007a4 4 0 0 1-.26-.227l-.07-.064c-.277-.251-.548-.498-.8-.675-.286-.2-.647-.388-1.106-.4M7.27 11.356l5.05-5.05-1.415-1.413L7.27 8.527 5.383 6.639 3.968 8.053z"
      clipRule="evenodd"
    />
  </svg>
);

export const VideoFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.59 5.91C2 6.872 2 8.181 2 10.8v2.4c0 2.619 0 3.928.59 4.89a4 4 0 0 0 1.32 1.32c.962.59 2.271.59 4.89.59h6.4c2.619 0 3.928 0 4.89-.59.538-.33.99-.782 1.32-1.32.59-.962.59-2.271.59-4.89v-2.4c0-2.619 0-3.928-.59-4.89a4 4 0 0 0-1.32-1.32C19.128 4 17.819 4 15.2 4H8.8c-2.619 0-3.928 0-4.89.59a4 4 0 0 0-1.32 1.32m13.807 5.86c-.11-.835-1.058-1.42-2.956-2.591-2.072-1.28-3.109-1.919-3.932-1.596a1.8 1.8 0 0 0-.418.233c-.707.531-.707 1.749-.707 4.184s0 3.653.707 4.184q.193.145.418.233c.823.323 1.86-.317 3.932-1.596 1.898-1.17 2.847-1.756 2.956-2.592q.03-.229 0-.458"
      clipRule="evenodd"
    />
  </svg>
);

export const VideoOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.005 12.252a2.5 2.5 0 0 0 0-.504c-.08-.786-.582-1.325-1.1-1.733-.5-.395-1.206-.811-2.03-1.298l-.123-.072c-.85-.502-1.574-.93-2.176-1.184-.619-.26-1.35-.446-2.087-.12a2.5 2.5 0 0 0-.443.253c-.656.47-.869 1.193-.959 1.858C8 10.1 8 10.942 8 11.928v.144c0 .986 0 1.828.087 2.476.09.665.303 1.389.959 1.858q.208.149.443.253c.737.326 1.468.14 2.087-.12.602-.254 1.327-.682 2.176-1.184l.123-.072c.824-.486 1.53-.903 2.03-1.298.518-.408 1.02-.947 1.1-1.733m-1.99-.302a.5.5 0 0 1 0 .105l-.002.004a.3.3 0 0 1-.029.05 1.6 1.6 0 0 1-.317.305c-.382.302-.968.65-1.87 1.183-.928.548-1.536.904-1.998 1.1a1.7 1.7 0 0 1-.435.133.3.3 0 0 1-.066 0 .5.5 0 0 1-.089-.05l-.002-.002-.003-.004a.3.3 0 0 1-.029-.051 1.7 1.7 0 0 1-.106-.443C10.002 13.783 10 13.078 10 12s.002-1.783.07-2.28c.032-.239.073-.371.105-.443a.3.3 0 0 1 .034-.056.5.5 0 0 1 .096-.053.3.3 0 0 1 .059.002c.077.008.212.04.435.134.462.195 1.07.551 1.998 1.1.902.532 1.488.88 1.87 1.182.183.144.274.243.317.305.02.028.027.045.03.05z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 10.8c0-2.619 0-3.928.59-4.89a4 4 0 0 1 1.32-1.32C4.872 4 6.181 4 8.8 4h6.4c2.619 0 3.928 0 4.89.59a4 4 0 0 1 1.32 1.32c.59.962.59 2.271.59 4.89v2.4c0 2.619 0 3.928-.59 4.89-.33.538-.782.99-1.32 1.32-.962.59-2.271.59-4.89.59H8.8c-2.619 0-3.928 0-4.89-.59a4 4 0 0 1-1.32-1.32C2 17.128 2 15.819 2 13.2zM8.8 6h6.4c1.348 0 2.219.002 2.877.065.628.06.854.16.968.23a2 2 0 0 1 .66.66c.07.114.17.34.23.968.063.658.065 1.529.065 2.877v2.4c0 1.348-.002 2.219-.065 2.877-.06.628-.16.854-.23.968a2 2 0 0 1-.66.66c-.114.07-.34.17-.968.23-.658.063-1.529.065-2.877.065H8.8c-1.348 0-2.219-.002-2.877-.065-.629-.06-.854-.16-.968-.23a2 2 0 0 1-.66-.66c-.07-.114-.17-.34-.23-.968C4.002 15.419 4 14.548 4 13.2v-2.4c0-1.348.002-2.219.065-2.877.06-.629.16-.854.23-.968a2 2 0 0 1 .66-.66c.114-.07.34-.17.968-.23C6.581 6.002 7.452 6 8.8 6"
      clipRule="evenodd"
    />
  </svg>
);

export const VK = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12.89 17.99C6.06 17.99 2.16 13.49 2 6h3.42c.11 5.5 2.63 7.8 4.63 8.3V6h3.22v4.74c1.98-.2 4.05-2.36 4.75-4.74h3.22a8.95 8.95 0 0 1-1.53 3.44A9.37 9.37 0 0 1 16.87 12a9.8 9.8 0 0 1 3.23 2.46A9.34 9.34 0 0 1 22 18h-3.56a5.9 5.9 0 0 0-1.9-2.89 6.29 6.29 0 0 0-3.27-1.39V18l-.38-.01Z"
      fill="currentColor"
    />
  </svg>
);

export const WalletFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.304 6.47C2 7.203 2 8.135 2 10v4c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C5.204 20 6.136 20 8 20h8c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164c.17-.408.245-.877.278-1.531H16a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h5.973c-.033-.655-.109-1.123-.277-1.53a4 4 0 0 0-2.165-2.166C18.796 4 17.864 4 16 4H8c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 2.303 6.47Z"
      fill="currentColor"
    />
    <path
      d="M22 10h-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6v-4Z"
      fill="currentColor"
    />
  </svg>
);

export const WalletOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 10c0-1.86 0-2.8.3-3.53A4 4 0 0 1 4.47 4.3C5.2 4 6.14 4 8 4h8c1.86 0 2.8 0 3.53.3a4 4 0 0 1 2.17 2.17c.3.73.3 1.67.3 3.53v4c0 1.86 0 2.8-.3 3.53a4 4 0 0 1-2.17 2.17c-.73.3-1.67.3-3.53.3H8c-1.86 0-2.8 0-3.53-.3a4 4 0 0 1-2.17-2.17C2 16.8 2 15.86 2 14v-4Zm6-4h8c.96 0 1.58 0 2.05.03.46.03.63.09.72.12a2 2 0 0 1 1.08 1.08 2.32 2.32 0 0 1 .12.77H15a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h4.97v.05c-.03.46-.09.63-.12.72a2 2 0 0 1-1.08 1.08c-.09.03-.26.09-.72.12-.47.03-1.1.03-2.05.03H8c-.96 0-1.58 0-2.05-.03a2.32 2.32 0 0 1-.72-.12 2 2 0 0 1-1.08-1.08 2.32 2.32 0 0 1-.12-.72C4 15.58 4 14.95 4 14v-4c0-.96 0-1.58.03-2.05.03-.46.09-.63.12-.72a2 2 0 0 1 1.08-1.08c.09-.03.26-.09.72-.12C6.42 6 7.05 6 8 6Zm12 8v-4h-5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5Z"
      fill="currentColor"
    />
  </svg>
);

export const WarningFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.828 3h6.344a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 21 8.828v6.344a2 2 0 0 1-.586 1.414l-3.828 3.828a2 2 0 0 1-1.414.586H8.828a2 2 0 0 1-1.414-.586l-3.828-3.828A2 2 0 0 1 3 15.172V8.828a2 2 0 0 1 .586-1.414l3.828-3.828A2 2 0 0 1 8.828 3ZM11 14l-.25-8h2.5L13 14h-2Zm2.5 3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      fill="currentColor"
    />
  </svg>
);

export const WarningOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4 7 17 2.6c-.3-.4-.9-.6-1.4-.6H8.4c-.6 0-1.1.2-1.4.6L2.6 7c-.4.3-.6.8-.6 1.4v7.2c0 .5.2 1 .6 1.4L7 21.4c.3.4.8.6 1.4.6h7.2c.5 0 1-.2 1.4-.6l4.4-4.4c.4-.4.6-.9.6-1.4V8.4c0-.6-.2-1.1-.6-1.4ZM20 15.6 15.6 20H8.4L4 15.6V8.4L8.4 4h7.2L20 8.4v7.2Z"
      fill="currentColor"
    />
    <path
      fill="currentColor"
      d="m10.75 6 .25 8h2l.25-8h-2.5ZM12 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    />
  </svg>
);

export const WhatsAppColor = (props: SVGProps<SVGSVGElement>) => {
  const id = useId();

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fill={`url(#${id})`}
        fillRule="evenodd"
        d="M12.04 20.15a8.3 8.3 0 0 1-4.21-1.14l-.3-.18-3.14.82.84-3.04-.2-.32a8.27 8.27 0 1 1 15.29-4.38 8.27 8.27 0 0 1-8.28 8.24Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M19.09 4.9a9.95 9.95 0 0 0-17 7c0 1.76.45 3.46 1.32 4.96L2 22l5.28-1.38A9.95 9.95 0 0 0 22 11.92a9.83 9.83 0 0 0-2.91-7.01Zm-7.05 15.25a8.3 8.3 0 0 1-4.21-1.14l-.3-.18-3.14.82.84-3.04-.2-.32a8.27 8.27 0 1 1 15.29-4.38 8.27 8.27 0 0 1-8.28 8.24ZM16.58 14a41.2 41.2 0 0 0-1.7-.81c-.23-.08-.4-.12-.56.12-.16.25-.64.81-.79.97-.14.17-.29.19-.53.07-.25-.13-1.06-.39-2-1.23a7.47 7.47 0 0 1-1.39-1.72c-.15-.25-.02-.38.1-.5.12-.11.26-.3.38-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43l-.77-1.84c-.2-.49-.4-.42-.56-.43h-.47a.92.92 0 0 0-.67.3c-.23.25-.87.85-.87 2.07 0 1.22.9 2.4 1.02 2.56.12.17 1.75 2.67 4.25 3.74.6.26 1.06.4 1.42.52.6.2 1.14.16 1.56.1.48-.07 1.48-.6 1.68-1.18.21-.58.21-1.07.15-1.17-.06-.1-.23-.17-.48-.3Z"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient
          id={id}
          x1="831.46"
          x2="831.46"
          y1="1651.78"
          y2="3.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1FAF38" />
          <stop offset="1" stopColor="#60D669" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const WhatsAppL = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.09 4.9a9.95 9.95 0 0 0-17 7c0 1.76.45 3.46 1.32 4.96L2 22l5.28-1.38A9.95 9.95 0 0 0 22 11.92a9.83 9.83 0 0 0-2.91-7.01Zm-7.05 15.25a8.3 8.3 0 0 1-4.21-1.14l-.3-.18-3.14.82.84-3.04-.2-.32a8.27 8.27 0 1 1 15.29-4.38 8.27 8.27 0 0 1-8.28 8.24ZM16.58 14c-.25-.13-1.47-.73-1.7-.81-.23-.08-.4-.12-.56.12-.16.25-.64.81-.79.97-.14.17-.29.2-.53.07-.25-.13-1.06-.39-2-1.23a7.47 7.47 0 0 1-1.39-1.72c-.15-.25-.02-.38.1-.5.12-.11.26-.3.38-.44.13-.14.17-.24.25-.41.08-.16.04-.3-.02-.43l-.77-1.84c-.2-.48-.4-.42-.56-.43h-.47a.92.92 0 0 0-.67.3c-.23.25-.87.85-.87 2.07 0 1.22.9 2.4 1.02 2.56.12.17 1.75 2.67 4.25 3.74.6.26 1.06.4 1.42.52.6.2 1.14.16 1.56.1.48-.07 1.48-.6 1.68-1.18.21-.57.21-1.07.15-1.17-.06-.1-.23-.17-.48-.3Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Yandex = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M14.12 20H17V4h-4.19C8.6 4 6.4 6.1 6.4 9.18c0 2.67 1.43 4.17 3.97 5.8l1.54 1-1.98-1.62L6 20h3.12l4.19-6.06-1.46-.94c-1.76-1.15-2.62-2.05-2.62-3.98 0-1.7 1.24-2.86 3.6-2.86h1.28V20h.01Z"
    />
  </svg>
);

export const YandexPro = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22.9993C18.0751 22.9993 23 18.0744 23 11.9993C23 5.92414 18.0751 0.999268 12 0.999268C5.92487 0.999268 1 5.92414 1 11.9993C1 18.0744 5.92487 22.9993 12 22.9993ZM18.1875 7.32946C18.1875 7.32946 16.1695 9.19738 16.1695 11.9993C16.1695 14.8012 18.1875 16.6691 18.1875 16.6691L16.6698 18.1868C16.6698 18.1868 14.7685 16.1687 12 16.1687C9.23147 16.1687 7.33019 18.1868 7.33019 18.1868L5.8125 16.6691C5.8125 16.6691 7.83053 14.8012 7.83053 11.9993C7.83053 9.19738 5.8125 7.32946 5.8125 7.32946L7.33019 5.81177C7.33019 5.81177 9.24815 7.82979 12 7.82979C14.7519 7.82979 16.6698 5.81177 16.6698 5.81177L18.1875 7.32946Z"
      fill="currentColor"
    />
  </svg>
);

export const YandexRoundOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M15.06 17.4h-1.83V8.03h-.9c-1.57 0-2.35.78-2.35 1.95 0 1.3.52 1.95 1.7 2.74l.9.65-2.6 4.03H7.9l2.47-3.64c-1.43-1.04-2.21-1.96-2.21-3.65 0-2.08 1.43-3.51 4.16-3.51h2.74v10.8Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export const YandexSquareFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.65 5.28C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.65 6.32a6 6 0 0 0 2.63 2.63c1.28.65 2.96.65 6.32.65h.8c3.36 0 5.04 0 6.32-.65a6 6 0 0 0 2.63-2.63c.65-1.28.65-2.96.65-6.32v-.8c0-3.36 0-5.04-.65-6.32a6 6 0 0 0-2.63-2.63C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.32.65a6 6 0 0 0-2.63 2.63M13.41 18h2.09v-12h-3.04C9.4 6.01 7.8 7.58 7.8 9.89c0 1.85.88 2.94 2.45 4.06l-2.73 4.06h2.26l3.04-4.54-1.05-.7c-1.28-.87-1.9-1.55-1.9-3 0-1.27.9-2.14 2.6-2.14h.94z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M13.4 18.01h2.1v-12h-3.04C9.4 6.01 7.8 7.58 7.8 9.89c0 1.85.88 2.94 2.45 4.06l-2.73 4.06h2.26l3.04-4.54-1.05-.7c-1.28-.87-1.9-1.55-1.9-3 0-1.27.9-2.14 2.6-2.14h.94z"
      clipRule="evenodd"
    />
  </svg>
);

export const YouTubeColor = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="red"
      d="M21.58 7.16a2.53 2.53 0 0 0-1.77-1.78C18.25 4.96 12 4.96 12 4.96s-6.25 0-7.82.42c-.86.22-1.53.9-1.77 1.78C2 8.73 2 12 2 12s0 3.27.42 4.84c.23.87.91 1.55 1.77 1.79 1.56.42 7.81.42 7.81.42s6.25 0 7.82-.42c.86-.23 1.53-.91 1.77-1.79C22 15.27 22 12 22 12s0-3.27-.42-4.84ZM9.95 14.98V9.02L15.18 12l-5.23 2.98Z"
    />
    <path fill="#fff" d="M9.95 14.98V9.02L15.18 12l-5.23 2.98Z" />
  </svg>
);
